(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', '@js-joda/core', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('@js-joda/core'), require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'));
  else {
    if (typeof globalThis['@js-joda/core'] === 'undefined') {
      throw new Error("Error loading module 'Kotlin-DateTime-library-kotlinx-datetime'. Its dependency '@js-joda/core' was not found. Please, check whether '@js-joda/core' is loaded prior to 'Kotlin-DateTime-library-kotlinx-datetime'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'Kotlin-DateTime-library-kotlinx-datetime'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Kotlin-DateTime-library-kotlinx-datetime'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'Kotlin-DateTime-library-kotlinx-datetime'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'Kotlin-DateTime-library-kotlinx-datetime'.");
    }
    globalThis['Kotlin-DateTime-library-kotlinx-datetime'] = factory(typeof globalThis['Kotlin-DateTime-library-kotlinx-datetime'] === 'undefined' ? {} : globalThis['Kotlin-DateTime-library-kotlinx-datetime'], globalThis['@js-joda/core'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-serialization-kotlinx-serialization-core']);
  }
}(function (_, $module$_js_joda_core_gcv2k, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var ZoneId = $module$_js_joda_core_gcv2k.ZoneId;
  var ZoneRulesProvider = $module$_js_joda_core_gcv2k.ZoneRulesProvider;
  var VOID = kotlin_kotlin.$_$.d;
  var protoOf = kotlin_kotlin.$_$.eh;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var Long = kotlin_kotlin.$_$.kn;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var compare = kotlin_kotlin.$_$.je;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var fromInt = kotlin_kotlin.$_$.pe;
  var add = kotlin_kotlin.$_$.fe;
  var numberRangeToNumber = kotlin_kotlin.$_$.yg;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var ClosedRange = kotlin_kotlin.$_$.sh;
  var isInterface = kotlin_kotlin.$_$.rg;
  var contains = kotlin_kotlin.$_$.hi;
  var convertToInt = kotlin_kotlin.$_$.le;
  var charCodeAt = kotlin_kotlin.$_$.jf;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var toString = kotlin_kotlin.$_$.y;
  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.t;
  var ArithmeticException = kotlin_kotlin.$_$.vm;
  var multiply = kotlin_kotlin.$_$.ue;
  var uppercaseChar = kotlin_kotlin.$_$.nm;
  var substring = kotlin_kotlin.$_$.pl;
  var repeat = kotlin_kotlin.$_$.uk;
  var toInt = kotlin_kotlin.$_$.zl;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var divide = kotlin_kotlin.$_$.ne;
  var modulo = kotlin_kotlin.$_$.te;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var abs = kotlin_kotlin.$_$.ih;
  var padStart = kotlin_kotlin.$_$.qk;
  var toString_0 = kotlin_kotlin.$_$.hh;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var SerializableWith = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w2;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var enumEntries = kotlin_kotlin.$_$.ae;
  var Enum = kotlin_kotlin.$_$.en;
  var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.m5;
  var captureStack = kotlin_kotlin.$_$.gf;
  var IllegalArgumentException_init_$Init$_0 = kotlin_kotlin.$_$.o5;
  var IllegalArgumentException_init_$Init$_1 = kotlin_kotlin.$_$.q5;
  var IllegalArgumentException = kotlin_kotlin.$_$.hn;
  var IllegalArgumentException_init_$Init$_2 = kotlin_kotlin.$_$.k5;
  var RuntimeException_init_$Init$ = kotlin_kotlin.$_$.h6;
  var RuntimeException_init_$Init$_0 = kotlin_kotlin.$_$.k6;
  var RuntimeException = kotlin_kotlin.$_$.rn;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var isArray = kotlin_kotlin.$_$.jg;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.z3;
  var KProperty0 = kotlin_kotlin.$_$.xi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var hashCode = kotlin_kotlin.$_$.bg;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var KMutableProperty1 = kotlin_kotlin.$_$.wi;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var lazy = kotlin_kotlin.$_$.to;
  var equals = kotlin_kotlin.$_$.sf;
  var listOf = kotlin_kotlin.$_$.ta;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.a4;
  var mutableListOf = kotlin_kotlin.$_$.cb;
  var last = kotlin_kotlin.$_$.na;
  var Char = kotlin_kotlin.$_$.ym;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var removeLast = kotlin_kotlin.$_$.ob;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var joinToString = kotlin_kotlin.$_$.aa;
  var charSequenceGet = kotlin_kotlin.$_$.kf;
  var isLetter = kotlin_kotlin.$_$.gk;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var Char__hashCode_impl_otmys = kotlin_kotlin.$_$.s;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.o6;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var Char__rangeTo_impl_tkncvp = kotlin_kotlin.$_$.w;
  var plus = kotlin_kotlin.$_$.hb;
  var plus_0 = kotlin_kotlin.$_$.ib;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var listOf_0 = kotlin_kotlin.$_$.sa;
  var emptyList = kotlin_kotlin.$_$.c9;
  var toString_1 = kotlin_kotlin.$_$.hp;
  var substring_0 = kotlin_kotlin.$_$.ol;
  var get_lastIndex = kotlin_kotlin.$_$.kk;
  var toSet = kotlin_kotlin.$_$.tc;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var distinct = kotlin_kotlin.$_$.z8;
  var to = kotlin_kotlin.$_$.ip;
  var single = kotlin_kotlin.$_$.ub;
  var Collection = kotlin_kotlin.$_$.y6;
  var append = kotlin_kotlin.$_$.kj;
  var charSequenceSubSequence = kotlin_kotlin.$_$.mf;
  var removeLastOrNull = kotlin_kotlin.$_$.nb;
  var sortWith = kotlin_kotlin.$_$.wb;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var Comparator = kotlin_kotlin.$_$.bn;
  var compareValues = kotlin_kotlin.$_$.ad;
  var Exception = kotlin_kotlin.$_$.gn;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.h5;
  var asReversed = kotlin_kotlin.$_$.u7;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.v4;
  var joinTo = kotlin_kotlin.$_$.ca;
  var firstOrNull = kotlin_kotlin.$_$.k9;
  var get_lastIndex_0 = kotlin_kotlin.$_$.fa;
  var toMutableList = kotlin_kotlin.$_$.pc;
  var addAll = kotlin_kotlin.$_$.o7;
  var asReversed_0 = kotlin_kotlin.$_$.t7;
  var checkCountOverflow = kotlin_kotlin.$_$.z7;
  var compareTo = kotlin_kotlin.$_$.nf;
  var removePrefix = kotlin_kotlin.$_$.rk;
  var Comparable = kotlin_kotlin.$_$.an;
  var get_ONE = kotlin_kotlin.$_$.ee;
  var subtract = kotlin_kotlin.$_$.af;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i1;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var SerializationException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var buildClassSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o1;
  var getKClass = kotlin_kotlin.$_$.si;
  var arrayOf = kotlin_kotlin.$_$.fo;
  var createKType = kotlin_kotlin.$_$.qi;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d3;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.v3;
  var lazy_0 = kotlin_kotlin.$_$.so;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var MissingFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s;
  var SealedClassSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v2;
  var AbstractPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.b3;
  var toNumber = kotlin_kotlin.$_$.bf;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var throwOnFailure = kotlin_kotlin.$_$.cp;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.d1;
  var charArrayOf = kotlin_kotlin.$_$.hf;
  var split = kotlin_kotlin.$_$.bl;
  var startsWith = kotlin_kotlin.$_$.el;
  var numberToLong = kotlin_kotlin.$_$.we;
  var getOrNull = kotlin_kotlin.$_$.t9;
  var Companion_instance = kotlin_kotlin.$_$.j3;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var take = kotlin_kotlin.$_$.dc;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var createFailure = kotlin_kotlin.$_$.ko;
  var negate = kotlin_kotlin.$_$.ve;
  var bitwiseXor = kotlin_kotlin.$_$.ie;
  var shiftRightUnsigned = kotlin_kotlin.$_$.ye;
  var Companion_getInstance = kotlin_kotlin.$_$.e3;
  var startsWith_0 = kotlin_kotlin.$_$.dl;
  var take_0 = kotlin_kotlin.$_$.rl;
  var compareValuesBy = kotlin_kotlin.$_$.zc;
  var lastOrNull = kotlin_kotlin.$_$.ka;
  var binarySearch = kotlin_kotlin.$_$.w7;
  var first = kotlin_kotlin.$_$.o9;
  var ArithmeticException_init_$Create$ = kotlin_kotlin.$_$.x4;
  var toList = kotlin_kotlin.$_$.lc;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForClass(DateTimePeriod, 'DateTimePeriod', VOID, VOID, VOID, VOID, VOID, {0: DateTimePeriodSerializer_getInstance});
  initMetadataForClass(DatePeriod, 'DatePeriod', DatePeriod_init_$Create$, DateTimePeriod, VOID, VOID, VOID, {0: DatePeriodSerializer_getInstance});
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(DateTimePeriodImpl, 'DateTimePeriodImpl', VOID, DateTimePeriod);
  initMetadataForCompanion(Companion_1);
  initMetadataForCompanion(Companion_2);
  initMetadataForCompanion(Companion_3);
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(DateTimeUnit, 'DateTimeUnit', VOID, VOID, VOID, VOID, VOID, {0: DateTimeUnitSerializer_getInstance});
  initMetadataForClass(TimeBased, 'TimeBased', VOID, DateTimeUnit, VOID, VOID, VOID, {0: TimeBasedDateTimeUnitSerializer_getInstance});
  initMetadataForClass(DateBased, 'DateBased', VOID, DateTimeUnit, VOID, VOID, VOID, {0: DateBasedDateTimeUnitSerializer_getInstance});
  initMetadataForClass(DayBased, 'DayBased', VOID, DateBased, VOID, VOID, VOID, {0: DayBasedDateTimeUnitSerializer_getInstance});
  initMetadataForClass(MonthBased, 'MonthBased', VOID, DateBased, VOID, VOID, VOID, {0: MonthBasedDateTimeUnitSerializer_getInstance});
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(DayOfWeek, 'DayOfWeek', VOID, Enum);
  initMetadataForCompanion(Companion_6);
  initMetadataForClass(DateTimeFormatException, 'DateTimeFormatException', DateTimeFormatException_init_$Create$, IllegalArgumentException);
  initMetadataForCompanion(Companion_7);
  initMetadataForClass(IllegalTimeZoneException, 'IllegalTimeZoneException', IllegalTimeZoneException_init_$Create$, IllegalArgumentException);
  initMetadataForCompanion(Companion_8);
  initMetadataForClass(DateTimeArithmeticException, 'DateTimeArithmeticException', DateTimeArithmeticException_init_$Create$, RuntimeException);
  initMetadataForClass(Month, 'Month', VOID, Enum);
  initMetadataForCompanion(Companion_9);
  initMetadataForClass(OverloadMarker, 'OverloadMarker');
  initMetadataForClass(AbstractDateTimeFormat, 'AbstractDateTimeFormat');
  initMetadataForClass(Padding, 'Padding', VOID, Enum);
  function year$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.dn6(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.dn6.call(this, padding);
    }
    return tmp;
  }
  function monthNumber$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.gn6(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.gn6.call(this, padding);
    }
    return tmp;
  }
  initMetadataForInterface(WithYearMonth, 'WithYearMonth');
  function day$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.jn6(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.jn6.call(this, padding);
    }
    return tmp;
  }
  initMetadataForInterface(WithDate, 'WithDate', VOID, VOID, [WithYearMonth]);
  function hour$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.nn6(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.nn6.call(this, padding);
    }
    return tmp;
  }
  function minute$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.pn6(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.pn6.call(this, padding);
    }
    return tmp;
  }
  function second$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.rn6(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.rn6.call(this, padding);
    }
    return tmp;
  }
  function secondFraction(fixedLength) {
    this.tn6(fixedLength, fixedLength);
  }
  initMetadataForInterface(WithTime, 'WithTime');
  function offsetHours$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.wn6(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.wn6.call(this, padding);
    }
    return tmp;
  }
  function offsetMinutesOfHour$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.yn6(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.yn6.call(this, padding);
    }
    return tmp;
  }
  function offsetSecondsOfMinute$default(padding, $super) {
    padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
    var tmp;
    if ($super === VOID) {
      this.an7(padding);
      tmp = Unit_instance;
    } else {
      tmp = $super.an7.call(this, padding);
    }
    return tmp;
  }
  initMetadataForInterface(WithUtcOffset, 'WithUtcOffset');
  initMetadataForInterface(WithDateTimeComponents, 'WithDateTimeComponents', VOID, VOID, [WithTime, WithDate, WithUtcOffset]);
  function appendAlternativeParsingImpl(otherFormats, mainFormat) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(otherFormats.length);
    var inductionVariable = 0;
    var last = otherFormats.length;
    while (inductionVariable < last) {
      var item = otherFormats[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.also' call
      var this_0 = this.gn7();
      item(this_0);
      var tmp$ret$2 = this_0.fn7().g3d();
      destination.j1(tmp$ret$2);
    }
    var others = destination;
    // Inline function 'kotlin.also' call
    var this_1 = this.gn7();
    mainFormat(this_1);
    var main = this_1.fn7().g3d();
    this.fn7().in7(new AlternativesParsingFormatStructure(main, others));
  }
  function appendOptionalImpl(onZero, format) {
    var tmp = this.fn7();
    // Inline function 'kotlin.also' call
    var this_0 = this.gn7();
    format(this_0);
    tmp.in7(new OptionalFormatStructure(onZero, this_0.fn7().g3d()));
  }
  function chars(value) {
    return this.fn7().in7(new ConstantFormatStructure(value));
  }
  function build() {
    return new CachedFormatStructure(this.fn7().g3d().jn7_1);
  }
  initMetadataForInterface(AbstractDateTimeFormatBuilder, 'AbstractDateTimeFormatBuilder');
  initMetadataForClass(IncompleteLocalDate, 'IncompleteLocalDate', IncompleteLocalDate);
  initMetadataForCompanion(Companion_10);
  function year(padding) {
    return this.kn8(new BasicFormatStructure(new YearDirective(padding)));
  }
  function yearTwoDigits(baseYear) {
    return this.kn8(new BasicFormatStructure(new ReducedYearDirective(baseYear)));
  }
  function monthNumber(padding) {
    return this.kn8(new BasicFormatStructure(new MonthDirective(padding)));
  }
  initMetadataForInterface(AbstractWithYearMonthBuilder, 'AbstractWithYearMonthBuilder', VOID, VOID, [WithYearMonth]);
  function addFormatStructureForYearMonth(structure) {
    this.jn8(structure);
  }
  function day(padding) {
    return this.jn8(new BasicFormatStructure(new DayDirective(padding)));
  }
  function dayOfYear(padding) {
    return this.jn8(new BasicFormatStructure(new DayOfYearDirective(padding)));
  }
  function date(format) {
    return this.jn8((format instanceof LocalDateFormat ? format : THROW_CCE()).ln8_1);
  }
  initMetadataForInterface(AbstractWithDateBuilder, 'AbstractWithDateBuilder', VOID, VOID, [AbstractWithYearMonthBuilder, WithDate]);
  initMetadataForClass(Builder, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithDateBuilder]);
  initMetadataForClass(LocalDateFormat, 'LocalDateFormat', VOID, AbstractDateTimeFormat);
  initMetadataForClass(UnsignedIntFieldFormatDirective, 'UnsignedIntFieldFormatDirective');
  initMetadataForClass(DayDirective, 'DayDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForClass(DayOfYearDirective, 'DayOfYearDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForObject(DateFields, 'DateFields');
  initMetadataForCompanion(Companion_11);
  function hour(padding) {
    return this.kn7(new BasicFormatStructure(new HourDirective(padding)));
  }
  function minute(padding) {
    return this.kn7(new BasicFormatStructure(new MinuteDirective(padding)));
  }
  function second(padding) {
    return this.kn7(new BasicFormatStructure(new SecondDirective(padding)));
  }
  function secondFraction_0(minLength, maxLength) {
    return this.kn7(new BasicFormatStructure(new FractionalSecondDirective(minLength, maxLength)));
  }
  function time(format) {
    return this.kn7((format instanceof LocalTimeFormat ? format : THROW_CCE()).xna_1);
  }
  initMetadataForInterface(AbstractWithTimeBuilder, 'AbstractWithTimeBuilder', VOID, VOID, [WithTime]);
  function addFormatStructureForDate(structure) {
    this.in9(structure);
  }
  function addFormatStructureForTime(structure) {
    this.in9(structure);
  }
  initMetadataForInterface(AbstractWithDateTimeBuilder, 'AbstractWithDateTimeBuilder', VOID, VOID, [AbstractWithDateBuilder, AbstractWithTimeBuilder, WithTime, WithDate]);
  initMetadataForClass(Builder_0, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithDateTimeBuilder]);
  initMetadataForClass(LocalDateTimeFormat, 'LocalDateTimeFormat', VOID, AbstractDateTimeFormat);
  function set_fractionOfSecond(value) {
    this.ena(value == null ? null : value.qna(9));
  }
  function get_fractionOfSecond() {
    var tmp0_safe_receiver = this.fna();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new DecimalFraction(tmp0_safe_receiver, 9);
    }
    return tmp;
  }
  initMetadataForInterface(TimeFieldContainer, 'TimeFieldContainer');
  initMetadataForClass(IncompleteLocalDateTime, 'IncompleteLocalDateTime', IncompleteLocalDateTime, VOID, [TimeFieldContainer]);
  initMetadataForClass(IncompleteLocalTime, 'IncompleteLocalTime', IncompleteLocalTime, VOID, [TimeFieldContainer]);
  initMetadataForClass(AmPmMarker, 'AmPmMarker', VOID, Enum);
  initMetadataForCompanion(Companion_12);
  initMetadataForClass(Builder_1, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithTimeBuilder]);
  initMetadataForClass(LocalTimeFormat, 'LocalTimeFormat', VOID, AbstractDateTimeFormat);
  initMetadataForClass(HourDirective, 'HourDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForClass(MinuteDirective, 'MinuteDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForClass(SecondDirective, 'SecondDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForCompanion(Companion_13);
  initMetadataForClass(DecimalFractionFieldFormatDirective, 'DecimalFractionFieldFormatDirective');
  initMetadataForClass(FractionalSecondDirective, 'FractionalSecondDirective', VOID, DecimalFractionFieldFormatDirective);
  initMetadataForObject(TimeFields, 'TimeFields');
  initMetadataForClass(Directive, 'Directive');
  initMetadataForClass(DateBased_0, 'DateBased', VOID, Directive);
  initMetadataForClass(YearMonthBased, 'YearMonthBased', VOID, DateBased_0);
  initMetadataForClass(Era, 'Era', VOID, YearMonthBased);
  initMetadataForClass(Year, 'Year', VOID, YearMonthBased);
  initMetadataForClass(YearOfEra, 'YearOfEra', VOID, YearMonthBased);
  initMetadataForClass(CyclicYearName, 'CyclicYearName', VOID, YearMonthBased);
  initMetadataForClass(RelatedGregorianYear, 'RelatedGregorianYear', VOID, YearMonthBased);
  initMetadataForClass(MonthOfYear, 'MonthOfYear', VOID, YearMonthBased);
  initMetadataForClass(StandaloneMonthOfYear, 'StandaloneMonthOfYear', VOID, YearMonthBased);
  initMetadataForClass(QuarterOfYear, 'QuarterOfYear', VOID, YearMonthBased);
  initMetadataForClass(StandaloneQuarterOfYear, 'StandaloneQuarterOfYear', VOID, YearMonthBased);
  initMetadataForClass(DayOfYear, 'DayOfYear', VOID, DateBased_0);
  initMetadataForClass(DayOfMonth, 'DayOfMonth', VOID, DateBased_0);
  initMetadataForClass(ModifiedJulianDay, 'ModifiedJulianDay', VOID, DateBased_0);
  initMetadataForClass(WeekBasedYear, 'WeekBasedYear', VOID, DateBased_0);
  initMetadataForClass(WeekOfWeekBasedYear, 'WeekOfWeekBasedYear', VOID, DateBased_0);
  initMetadataForClass(WeekOfMonth, 'WeekOfMonth', VOID, DateBased_0);
  initMetadataForClass(DayOfWeek_1, 'DayOfWeek', VOID, DateBased_0);
  initMetadataForClass(LocalizedDayOfWeek, 'LocalizedDayOfWeek', VOID, DateBased_0);
  initMetadataForClass(StandaloneLocalizedDayOfWeek, 'StandaloneLocalizedDayOfWeek', VOID, DateBased_0);
  initMetadataForClass(DayOfWeekInMonth, 'DayOfWeekInMonth', VOID, DateBased_0);
  initMetadataForClass(TimeBased_0, 'TimeBased', VOID, Directive);
  initMetadataForClass(WithSecondPrecision, 'WithSecondPrecision', VOID, TimeBased_0);
  initMetadataForClass(SecondOfMinute, 'SecondOfMinute', VOID, WithSecondPrecision);
  initMetadataForClass(WithSubsecondPrecision, 'WithSubsecondPrecision', VOID, WithSecondPrecision);
  initMetadataForClass(FractionOfSecond, 'FractionOfSecond', VOID, WithSubsecondPrecision);
  initMetadataForClass(MilliOfDay, 'MilliOfDay', VOID, WithSubsecondPrecision);
  initMetadataForClass(NanoOfSecond, 'NanoOfSecond', VOID, WithSubsecondPrecision);
  initMetadataForClass(NanoOfDay, 'NanoOfDay', VOID, WithSubsecondPrecision);
  initMetadataForClass(AmPmMarker_0, 'AmPmMarker', VOID, TimeBased_0);
  initMetadataForClass(AmPmHourOfDay, 'AmPmHourOfDay', VOID, TimeBased_0);
  initMetadataForClass(HourOfDay, 'HourOfDay', VOID, TimeBased_0);
  initMetadataForClass(MinuteOfHour, 'MinuteOfHour', VOID, TimeBased_0);
  initMetadataForClass(ZoneBased, 'ZoneBased', VOID, Directive);
  initMetadataForClass(TimeZoneId, 'TimeZoneId', VOID, ZoneBased);
  initMetadataForClass(GenericTimeZoneName, 'GenericTimeZoneName', VOID, ZoneBased);
  initMetadataForClass(TimeZoneName, 'TimeZoneName', VOID, ZoneBased);
  initMetadataForClass(OffsetBased, 'OffsetBased', VOID, Directive);
  initMetadataForClass(LocalizedZoneOffset, 'LocalizedZoneOffset', VOID, OffsetBased);
  initMetadataForClass(ZoneOffset1, 'ZoneOffset1', VOID, OffsetBased);
  initMetadataForClass(ZoneOffset2, 'ZoneOffset2', VOID, OffsetBased);
  initMetadataForClass(ZoneOffset3, 'ZoneOffset3', VOID, OffsetBased);
  initMetadataForCompanion(Companion_14);
  initMetadataForClass(OptionalGroup, 'OptionalGroup');
  initMetadataForClass(Sequence, 'Sequence');
  initMetadataForClass(StringLiteral, 'StringLiteral');
  initMetadataForClass(UnknownUnicodeDirective, 'UnknownUnicodeDirective', VOID, Directive);
  initMetadataForInterface(UtcOffsetFieldContainer, 'UtcOffsetFieldContainer');
  initMetadataForClass(IncompleteUtcOffset, 'IncompleteUtcOffset', IncompleteUtcOffset, VOID, [UtcOffsetFieldContainer]);
  initMetadataForClass(UtcOffsetWholeHoursDirective, 'UtcOffsetWholeHoursDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForCompanion(Companion_15);
  function offsetHours(padding) {
    return this.tng(new SignedFormatStructure(new BasicFormatStructure(new UtcOffsetWholeHoursDirective(padding)), true));
  }
  function offsetMinutesOfHour(padding) {
    return this.tng(new BasicFormatStructure(new UtcOffsetMinuteOfHourDirective(padding)));
  }
  function offsetSecondsOfMinute(padding) {
    return this.tng(new BasicFormatStructure(new UtcOffsetSecondOfMinuteDirective(padding)));
  }
  initMetadataForInterface(AbstractWithOffsetBuilder, 'AbstractWithOffsetBuilder', VOID, VOID, [WithUtcOffset]);
  initMetadataForClass(Builder_2, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithOffsetBuilder]);
  initMetadataForClass(UtcOffsetFormat, 'UtcOffsetFormat', VOID, AbstractDateTimeFormat);
  initMetadataForClass(OffsetFields$sign$1);
  initMetadataForObject(OffsetFields, 'OffsetFields');
  initMetadataForClass(UtcOffsetMinuteOfHourDirective, 'UtcOffsetMinuteOfHourDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForClass(UtcOffsetSecondOfMinuteDirective, 'UtcOffsetSecondOfMinuteDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForClass(WhenToOutput, 'WhenToOutput', VOID, Enum);
  initMetadataForClass(IncompleteYearMonth, 'IncompleteYearMonth', IncompleteYearMonth);
  initMetadataForCompanion(Companion_16);
  initMetadataForClass(Builder_3, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithYearMonthBuilder]);
  initMetadataForClass(YearMonthFormat, 'YearMonthFormat', VOID, AbstractDateTimeFormat);
  initMetadataForClass(SignedIntFieldFormatDirective, 'SignedIntFieldFormatDirective');
  initMetadataForClass(YearDirective, 'YearDirective', VOID, SignedIntFieldFormatDirective);
  initMetadataForClass(ReducedIntFieldDirective, 'ReducedIntFieldDirective');
  initMetadataForClass(ReducedYearDirective, 'ReducedYearDirective', VOID, ReducedIntFieldDirective);
  initMetadataForClass(MonthDirective, 'MonthDirective', VOID, UnsignedIntFieldFormatDirective);
  initMetadataForObject(YearMonthFields, 'YearMonthFields');
  initMetadataForClass(AppendableFormatStructure, 'AppendableFormatStructure', AppendableFormatStructure);
  initMetadataForClass(AbstractFieldSpec, 'AbstractFieldSpec');
  initMetadataForClass(GenericFieldSpec, 'GenericFieldSpec', VOID, AbstractFieldSpec);
  function getterNotNull(container) {
    var tmp0_elvis_lhs = this.nnj(container);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('Field ' + this.m() + ' is not set');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  initMetadataForInterface(Accessor, 'Accessor');
  initMetadataForClass(PropertyAccessor, 'PropertyAccessor', VOID, VOID, [Accessor]);
  initMetadataForClass(UnsignedFieldSpec, 'UnsignedFieldSpec', VOID, AbstractFieldSpec);
  initMetadataForClass(ConcatenatedFormatStructure, 'ConcatenatedFormatStructure');
  initMetadataForClass(CachedFormatStructure, 'CachedFormatStructure', VOID, ConcatenatedFormatStructure);
  initMetadataForInterface(NonConcatenatedFormatStructure, 'NonConcatenatedFormatStructure');
  initMetadataForClass(BasicFormatStructure, 'BasicFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
  initMetadataForClass(ConstantFormatStructure, 'ConstantFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
  initMetadataForClass(SignedFormatStructure, 'SignedFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
  initMetadataForCompanion(Companion_17);
  initMetadataForClass(PropertyWithDefault, 'PropertyWithDefault');
  initMetadataForClass(OptionalFormatStructure, 'OptionalFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
  initMetadataForClass(AlternativesParsingFormatStructure, 'AlternativesParsingFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
  initMetadataForClass(ComparisonPredicate, 'ComparisonPredicate');
  initMetadataForObject(Truth, 'Truth');
  initMetadataForClass(ConjunctionPredicate, 'ConjunctionPredicate');
  function format$default(obj, builder, minusNotRequired, $super) {
    minusNotRequired = minusNotRequired === VOID ? false : minusNotRequired;
    var tmp;
    if ($super === VOID) {
      this.hnk(obj, builder, minusNotRequired);
      tmp = Unit_instance;
    } else {
      tmp = $super.hnk.call(this, obj, builder, minusNotRequired);
    }
    return tmp;
  }
  initMetadataForInterface(FormatterStructure, 'FormatterStructure');
  initMetadataForClass(SpacePaddedFormatter, 'SpacePaddedFormatter', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(SignedFormatter, 'SignedFormatter', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(ConditionalFormatter, 'ConditionalFormatter', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(ConcatenatedFormatter, 'ConcatenatedFormatter', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(UnsignedIntFormatterStructure, 'UnsignedIntFormatterStructure', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(DecimalFractionFormatterStructure, 'DecimalFractionFormatterStructure', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(SignedIntFormatterStructure, 'SignedIntFormatterStructure', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(ReducedIntFormatterStructure, 'ReducedIntFormatterStructure', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(ConstantStringFormatterStructure, 'ConstantStringFormatterStructure', VOID, VOID, [FormatterStructure]);
  initMetadataForClass(NumberConsumer, 'NumberConsumer');
  initMetadataForClass(FractionPartConsumer, 'FractionPartConsumer', VOID, NumberConsumer);
  initMetadataForClass(ConstantNumberConsumer, 'ConstantNumberConsumer', VOID, NumberConsumer);
  initMetadataForObject(ExpectedInt, 'ExpectedInt');
  initMetadataForClass(TooManyDigits, 'TooManyDigits');
  initMetadataForClass(TooFewDigits, 'TooFewDigits');
  initMetadataForClass(WrongConstant, 'WrongConstant');
  initMetadataForClass(Conflicting, 'Conflicting');
  initMetadataForClass(UnsignedIntConsumer, 'UnsignedIntConsumer', VOID, NumberConsumer);
  initMetadataForClass(ReducedIntConsumer, 'ReducedIntConsumer', VOID, NumberConsumer);
  initMetadataForClass(ParseError, 'ParseError');
  initMetadataForCompanion(Companion_18);
  initMetadataForClass(ParserState, 'ParserState');
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(Parser, 'Parser');
  initMetadataForClass(ParserStructure, 'ParserStructure');
  initMetadataForCompanion(Companion_19);
  initMetadataForClass(ParseException, 'ParseException', VOID, Exception);
  initMetadataForClass(NumberSpanParserOperation, 'NumberSpanParserOperation');
  initMetadataForClass(PlainStringParserOperation, 'PlainStringParserOperation');
  initMetadataForClass(SignParser, 'SignParser');
  initMetadataForClass(UnconditionalModification, 'UnconditionalModification');
  initMetadataForClass(DecimalFraction, 'DecimalFraction', VOID, VOID, [Comparable]);
  initMetadataForObject(DatePeriodSerializer, 'DatePeriodSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DateTimePeriodSerializer, 'DateTimePeriodSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DatePeriodIso8601Serializer, 'DatePeriodIso8601Serializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DateTimePeriodIso8601Serializer, 'DateTimePeriodIso8601Serializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(TimeBasedDateTimeUnitSerializer, 'TimeBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DateBasedDateTimeUnitSerializer, 'DateBasedDateTimeUnitSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForObject(DayBasedDateTimeUnitSerializer, 'DayBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(MonthBasedDateTimeUnitSerializer, 'MonthBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DateTimeUnitSerializer, 'DateTimeUnitSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForObject(LocalDateSerializer, 'LocalDateSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(LocalDateTimeSerializer, 'LocalDateTimeSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(LocalTimeSerializer, 'LocalTimeSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UtcOffsetSerializer, 'UtcOffsetSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(YearMonthSerializer, 'YearMonthSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(TimeZone, 'TimeZone');
  initMetadataForObject(SystemTimeZone, 'SystemTimeZone', VOID, TimeZone);
  initMetadataForClass(tzdb$1);
  initMetadataForCompanion(Companion_20);
  initMetadataForObject(Formats, 'Formats');
  initMetadataForClass(LocalDate, 'LocalDate', VOID, VOID, [Comparable], VOID, VOID, {0: LocalDateSerializer_getInstance});
  initMetadataForCompanion(Companion_21);
  initMetadataForObject(Formats_0, 'Formats');
  initMetadataForClass(LocalDateTime, 'LocalDateTime', VOID, VOID, [Comparable], VOID, VOID, {0: LocalDateTimeSerializer_getInstance});
  initMetadataForCompanion(Companion_22);
  initMetadataForObject(Formats_1, 'Formats');
  initMetadataForClass(LocalTime, 'LocalTime', VOID, VOID, [Comparable], VOID, VOID, {0: LocalTimeSerializer_getInstance});
  initMetadataForCompanion(Companion_23);
  initMetadataForCompanion(Companion_24);
  initMetadataForClass(FixedOffsetTimeZone, 'FixedOffsetTimeZone', VOID, TimeZone);
  initMetadataForCompanion(Companion_25);
  initMetadataForObject(Formats_2, 'Formats');
  initMetadataForClass(UtcOffset, 'UtcOffset', VOID, VOID, VOID, VOID, VOID, {0: UtcOffsetSerializer_getInstance});
  initMetadataForCompanion(Companion_26);
  initMetadataForObject(Formats_3, 'Formats');
  initMetadataForClass(YearMonth, 'YearMonth', VOID, VOID, [Comparable], VOID, VOID, {0: YearMonthSerializer_getInstance});
  initMetadataForObject(WallClockOffset, 'WallClockOffset');
  initMetadataForClass(FixedOffset, 'FixedOffset');
  initMetadataForClass(Gap, 'Gap');
  initMetadataForClass(Overlap, 'Overlap');
  initMetadataForClass(Regular, 'Regular');
  initMetadataForClass(RegionTimeZone, 'RegionTimeZone', VOID, TimeZone);
  initMetadataForClass(TimeZoneRulesCommon, 'TimeZoneRulesCommon');
  initMetadataForClass(Rule, 'Rule');
  initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  //endregion
  function DatePeriod_init_$Init$(years, months, days, $this) {
    years = years === VOID ? 0 : years;
    months = months === VOID ? 0 : months;
    days = days === VOID ? 0 : days;
    DatePeriod.call($this, totalMonths(years, months), days);
    return $this;
  }
  function DatePeriod_init_$Create$(years, months, days) {
    return DatePeriod_init_$Init$(years, months, days, objectCreate(protoOf(DatePeriod)));
  }
  function Companion() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function DatePeriod(totalMonths, days) {
    DateTimePeriod.call(this);
    this.dn4_1 = totalMonths;
    this.en4_1 = days;
  }
  protoOf(DatePeriod).fn4 = function () {
    return this.dn4_1;
  };
  protoOf(DatePeriod).gn4 = function () {
    return this.en4_1;
  };
  protoOf(DatePeriod).hn4 = function () {
    return 0;
  };
  protoOf(DatePeriod).in4 = function () {
    return 0;
  };
  protoOf(DatePeriod).jn4 = function () {
    return 0;
  };
  protoOf(DatePeriod).kn4 = function () {
    return 0;
  };
  protoOf(DatePeriod).ln4 = function () {
    return new Long(0, 0);
  };
  function allNonpositive($this) {
    return compare($this.fn4(), new Long(0, 0)) <= 0 && $this.gn4() <= 0 && compare($this.ln4(), new Long(0, 0)) <= 0 && (!equalsLong(bitwiseOr($this.fn4(), $this.ln4()), new Long(0, 0)) || !($this.gn4() === 0));
  }
  function Companion_0() {
  }
  protoOf(Companion_0).jr = function (text) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.datetime.Companion.parseImpl' call
      var START = 0;
      var AFTER_P = 1;
      var AFTER_YEAR = 2;
      var AFTER_MONTH = 3;
      var AFTER_WEEK = 4;
      var AFTER_DAY = 5;
      var AFTER_T = 6;
      var AFTER_HOUR = 7;
      var AFTER_MINUTE = 8;
      var AFTER_SECOND_AND_NANO = 9;
      var state = START;
      var i = 0;
      var sign = 1;
      var years = 0;
      var months = 0;
      var weeks = 0;
      var days = 0;
      var hours = 0;
      var minutes = 0;
      var seconds = 0;
      var nanoseconds = 0;
      var someComponentParsed = false;
      $l$loop_0: while (true) {
        if (i >= text.length) {
          if (state === START) {
            var tmp0 = "Unexpected end of input; 'P' designator is required";
            var position = i;
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position + ': ' + tmp0);
          }
          if (state === AFTER_T) {
            var tmp0_0 = "Unexpected end of input; at least one time component is required after 'T'";
            var position_0 = i;
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_0 + ': ' + tmp0_0);
          }
          var tmp0_1 = fromInt(days);
          // Inline function 'kotlin.Long.plus' call
          var other = imul(weeks, 7);
          var n = add(tmp0_1, fromInt(other));
          var tmp;
          // Inline function 'kotlin.ranges.contains' call
          var this_0 = numberRangeToNumber(-2147483648, 2147483647);
          if (contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), n)) {
            tmp = convertToInt(n);
          } else {
            var message = "The total number of days under 'D' and 'W' designators should fit into an Int";
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + 0 + ': ' + message);
          }
          var daysTotal = tmp;
          if (!someComponentParsed) {
            var message_0 = 'At least one component is required, but none were found';
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + 0 + ': ' + message_0);
          }
          var tmp0_2 = years;
          var tmp2 = months;
          var tmp6 = hours;
          var tmp8 = minutes;
          var tmp10 = seconds;
          var p6 = fromInt(nanoseconds);
          tmp$ret$0 = DateTimePeriod_0(tmp0_2, tmp2, daysTotal, tmp6, tmp8, tmp10, p6);
          break $l$block;
        }
        if (state === START) {
          if ((i + 1 | 0) >= text.length && (charCodeAt(text, i) === _Char___init__impl__6a9atx(43) || charCodeAt(text, i) === _Char___init__impl__6a9atx(45))) {
            var tmp0_3 = "Unexpected end of string; 'P' designator is required";
            var position_1 = i;
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_1 + ': ' + tmp0_3);
          }
          var tmp0_subject = charCodeAt(text, i);
          if (tmp0_subject === _Char___init__impl__6a9atx(43) || tmp0_subject === _Char___init__impl__6a9atx(45)) {
            if (charCodeAt(text, i) === _Char___init__impl__6a9atx(45))
              sign = -1;
            if (!(charCodeAt(text, i + 1 | 0) === _Char___init__impl__6a9atx(80))) {
              var tmp0_4 = "Expected 'P', got '" + toString(charCodeAt(text, i + 1 | 0)) + "'";
              var position_2 = i + 1 | 0;
              throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_2 + ': ' + tmp0_4);
            }
            i = i + 2 | 0;
          } else if (tmp0_subject === _Char___init__impl__6a9atx(80)) {
            i = i + 1 | 0;
          } else {
            var tmp0_5 = "Expected '+', '-', 'P', got '" + toString(charCodeAt(text, i)) + "'";
            var position_3 = i;
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_3 + ': ' + tmp0_5);
          }
          state = AFTER_P;
          continue $l$loop_0;
        }
        var localSign = sign;
        var iStart = i;
        var tmp1_subject = charCodeAt(text, i);
        if (tmp1_subject === _Char___init__impl__6a9atx(43) || tmp1_subject === _Char___init__impl__6a9atx(45)) {
          if (charCodeAt(text, i) === _Char___init__impl__6a9atx(45))
            localSign = imul(localSign, -1);
          i = i + 1 | 0;
          var tmp_0;
          if (i >= text.length) {
            tmp_0 = true;
          } else {
            var containsArg = charCodeAt(text, i);
            tmp_0 = !(_Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false);
          }
          if (tmp_0) {
            var tmp0_6 = "A number expected after '" + toString(charCodeAt(text, i)) + "'";
            var position_4 = i;
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_4 + ': ' + tmp0_6);
          }
        } else if (!(_Char___init__impl__6a9atx(48) <= tmp1_subject ? tmp1_subject <= _Char___init__impl__6a9atx(57) : false))
          if (tmp1_subject === _Char___init__impl__6a9atx(84)) {
            if (state >= AFTER_T) {
              var tmp0_7 = "Only one 'T' designator is allowed";
              var position_5 = i;
              throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_5 + ': ' + tmp0_7);
            }
            state = AFTER_T;
            i = i + 1 | 0;
            continue $l$loop_0;
          }
        var number = new Long(0, 0);
        $l$loop_1: while (true) {
          var tmp_1;
          if (i < text.length) {
            var containsArg_0 = charCodeAt(text, i);
            tmp_1 = _Char___init__impl__6a9atx(48) <= containsArg_0 ? containsArg_0 <= _Char___init__impl__6a9atx(57) : false;
          } else {
            tmp_1 = false;
          }
          if (!tmp_1) {
            break $l$loop_1;
          }
          try {
            number = safeAdd(safeMultiply(number, new Long(10, 0)), fromInt(Char__minus_impl_a2frrh(charCodeAt(text, i), _Char___init__impl__6a9atx(48))));
          } catch ($p) {
            if ($p instanceof ArithmeticException) {
              var _unused_var__etf5q3 = $p;
              var message_1 = 'The number is too large';
              throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + iStart + ': ' + message_1);
            } else {
              throw $p;
            }
          }
          i = i + 1 | 0;
        }
        someComponentParsed = true;
        var tmp0_8 = number;
        // Inline function 'kotlin.Long.times' call
        var other_0 = localSign;
        number = multiply(tmp0_8, fromInt(other_0));
        if (i === text.length) {
          var tmp0_9 = 'Expected a designator after the numerical value';
          var position_6 = i;
          throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_6 + ': ' + tmp0_9);
        }
        var wrongOrder = "Wrong component order: should be 'Y', 'M', 'W', 'D', then designator 'T', then 'H', 'M', 'S'";
        var tmp2_subject = uppercaseChar(charCodeAt(text, i));
        if (tmp2_subject === _Char___init__impl__6a9atx(89)) {
          if (state >= AFTER_YEAR) {
            var position_7 = i;
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_7 + ': ' + wrongOrder);
          }
          state = AFTER_YEAR;
          var tmp2_0 = number;
          // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
          var component = _Char___init__impl__6a9atx(89);
          if (compare(tmp2_0, new Long(-2147483648, -1)) < 0 || compare(tmp2_0, new Long(2147483647, 0)) > 0) {
            var message_2 = 'Value ' + tmp2_0.toString() + " does not fit into an Int, which is required for component '" + toString(component) + "'";
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + iStart + ': ' + message_2);
          }
          years = convertToInt(tmp2_0);
        } else if (tmp2_subject === _Char___init__impl__6a9atx(77)) {
          if (state >= AFTER_T) {
            if (state >= AFTER_MINUTE) {
              var position_8 = i;
              throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_8 + ': ' + wrongOrder);
            }
            state = AFTER_MINUTE;
            var tmp2_1 = number;
            // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
            var component_0 = _Char___init__impl__6a9atx(77);
            if (compare(tmp2_1, new Long(-2147483648, -1)) < 0 || compare(tmp2_1, new Long(2147483647, 0)) > 0) {
              var message_3 = 'Value ' + tmp2_1.toString() + " does not fit into an Int, which is required for component '" + toString(component_0) + "'";
              throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + iStart + ': ' + message_3);
            }
            minutes = convertToInt(tmp2_1);
          } else {
            if (state >= AFTER_MONTH) {
              var position_9 = i;
              throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_9 + ': ' + wrongOrder);
            }
            state = AFTER_MONTH;
            var tmp2_2 = number;
            // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
            var component_1 = _Char___init__impl__6a9atx(77);
            if (compare(tmp2_2, new Long(-2147483648, -1)) < 0 || compare(tmp2_2, new Long(2147483647, 0)) > 0) {
              var message_4 = 'Value ' + tmp2_2.toString() + " does not fit into an Int, which is required for component '" + toString(component_1) + "'";
              throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + iStart + ': ' + message_4);
            }
            months = convertToInt(tmp2_2);
          }
        } else if (tmp2_subject === _Char___init__impl__6a9atx(87)) {
          if (state >= AFTER_WEEK) {
            var position_10 = i;
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_10 + ': ' + wrongOrder);
          }
          state = AFTER_WEEK;
          var tmp2_3 = number;
          // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
          var component_2 = _Char___init__impl__6a9atx(87);
          if (compare(tmp2_3, new Long(-2147483648, -1)) < 0 || compare(tmp2_3, new Long(2147483647, 0)) > 0) {
            var message_5 = 'Value ' + tmp2_3.toString() + " does not fit into an Int, which is required for component '" + toString(component_2) + "'";
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + iStart + ': ' + message_5);
          }
          weeks = convertToInt(tmp2_3);
        } else if (tmp2_subject === _Char___init__impl__6a9atx(68)) {
          if (state >= AFTER_DAY) {
            var position_11 = i;
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_11 + ': ' + wrongOrder);
          }
          state = AFTER_DAY;
          var tmp2_4 = number;
          // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
          var component_3 = _Char___init__impl__6a9atx(68);
          if (compare(tmp2_4, new Long(-2147483648, -1)) < 0 || compare(tmp2_4, new Long(2147483647, 0)) > 0) {
            var message_6 = 'Value ' + tmp2_4.toString() + " does not fit into an Int, which is required for component '" + toString(component_3) + "'";
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + iStart + ': ' + message_6);
          }
          days = convertToInt(tmp2_4);
        } else if (tmp2_subject === _Char___init__impl__6a9atx(72)) {
          if (state >= AFTER_HOUR || state < AFTER_T) {
            var position_12 = i;
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_12 + ': ' + wrongOrder);
          }
          state = AFTER_HOUR;
          var tmp2_5 = number;
          // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
          var component_4 = _Char___init__impl__6a9atx(72);
          if (compare(tmp2_5, new Long(-2147483648, -1)) < 0 || compare(tmp2_5, new Long(2147483647, 0)) > 0) {
            var message_7 = 'Value ' + tmp2_5.toString() + " does not fit into an Int, which is required for component '" + toString(component_4) + "'";
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + iStart + ': ' + message_7);
          }
          hours = convertToInt(tmp2_5);
        } else if (tmp2_subject === _Char___init__impl__6a9atx(83)) {
          if (state >= AFTER_SECOND_AND_NANO || state < AFTER_T) {
            var position_13 = i;
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_13 + ': ' + wrongOrder);
          }
          state = AFTER_SECOND_AND_NANO;
          var tmp2_6 = number;
          // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
          var component_5 = _Char___init__impl__6a9atx(83);
          if (compare(tmp2_6, new Long(-2147483648, -1)) < 0 || compare(tmp2_6, new Long(2147483647, 0)) > 0) {
            var message_8 = 'Value ' + tmp2_6.toString() + " does not fit into an Int, which is required for component '" + toString(component_5) + "'";
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + iStart + ': ' + message_8);
          }
          seconds = convertToInt(tmp2_6);
        } else if (tmp2_subject === _Char___init__impl__6a9atx(46) || tmp2_subject === _Char___init__impl__6a9atx(44)) {
          i = i + 1 | 0;
          if (i >= text.length) {
            var tmp0_10 = "Expected designator 'S' after " + toString(charCodeAt(text, i - 1 | 0));
            var position_14 = i;
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_14 + ': ' + tmp0_10);
          }
          var iStartFraction = i;
          $l$loop_2: while (true) {
            var tmp_2;
            if (i < text.length) {
              var containsArg_1 = charCodeAt(text, i);
              tmp_2 = _Char___init__impl__6a9atx(48) <= containsArg_1 ? containsArg_1 <= _Char___init__impl__6a9atx(57) : false;
            } else {
              tmp_2 = false;
            }
            if (!tmp_2) {
              break $l$loop_2;
            }
            i = i + 1 | 0;
          }
          var fractionLength = i - iStartFraction | 0;
          if (fractionLength > 9) {
            var message_9 = 'Only the nanosecond fractions of a second are supported';
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + iStartFraction + ': ' + message_9);
          }
          var fractionalPart = substring(text, iStartFraction, i) + repeat('0', 9 - fractionLength | 0);
          nanoseconds = imul(toInt(fractionalPart, 10), localSign);
          if (!(charCodeAt(text, i) === _Char___init__impl__6a9atx(83))) {
            var tmp0_11 = "Expected the 'S' designator after a fraction";
            var position_15 = i;
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_15 + ': ' + tmp0_11);
          }
          if (state >= AFTER_SECOND_AND_NANO || state < AFTER_T) {
            var position_16 = i;
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_16 + ': ' + wrongOrder);
          }
          state = AFTER_SECOND_AND_NANO;
          var tmp2_7 = number;
          // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
          var component_6 = _Char___init__impl__6a9atx(83);
          if (compare(tmp2_7, new Long(-2147483648, -1)) < 0 || compare(tmp2_7, new Long(2147483647, 0)) > 0) {
            var message_10 = 'Value ' + tmp2_7.toString() + " does not fit into an Int, which is required for component '" + toString(component_6) + "'";
            throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + iStart + ': ' + message_10);
          }
          seconds = convertToInt(tmp2_7);
        } else {
          var tmp0_12 = 'Expected a designator after the numerical value';
          var position_17 = i;
          throw DateTimeFormatException_init_$Create$_0('Parse error at char ' + position_17 + ': ' + tmp0_12);
        }
        i = i + 1 | 0;
      }
    }
    return tmp$ret$0;
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function DateTimePeriod() {
  }
  protoOf(DateTimePeriod).mn4 = function () {
    // Inline function 'kotlin.Long.div' call
    var this_0 = this.fn4();
    var tmp$ret$0 = divide(this_0, fromInt(12));
    return convertToInt(tmp$ret$0);
  };
  protoOf(DateTimePeriod).nn4 = function () {
    // Inline function 'kotlin.Long.rem' call
    var this_0 = this.fn4();
    var tmp$ret$0 = modulo(this_0, fromInt(12));
    return convertToInt(tmp$ret$0);
  };
  protoOf(DateTimePeriod).hn4 = function () {
    return convertToInt(divide(this.ln4(), new Long(817405952, 838)));
  };
  protoOf(DateTimePeriod).in4 = function () {
    return convertToInt(divide(modulo(this.ln4(), new Long(817405952, 838)), new Long(-129542144, 13)));
  };
  protoOf(DateTimePeriod).jn4 = function () {
    var tmp0 = modulo(this.ln4(), new Long(-129542144, 13));
    // Inline function 'kotlin.Long.div' call
    var other = 1000000000;
    var tmp$ret$0 = divide(tmp0, fromInt(other));
    return convertToInt(tmp$ret$0);
  };
  protoOf(DateTimePeriod).kn4 = function () {
    var tmp0 = this.ln4();
    // Inline function 'kotlin.Long.rem' call
    var other = 1000000000;
    var tmp$ret$0 = modulo(tmp0, fromInt(other));
    return convertToInt(tmp$ret$0);
  };
  protoOf(DateTimePeriod).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    var tmp;
    if (allNonpositive(this)) {
      this_0.s(_Char___init__impl__6a9atx(45));
      tmp = -1;
    } else {
      tmp = 1;
    }
    var sign = tmp;
    this_0.s(_Char___init__impl__6a9atx(80));
    if (!(this.mn4() === 0)) {
      this_0.ed(imul(this.mn4(), sign)).s(_Char___init__impl__6a9atx(89));
    }
    if (!(this.nn4() === 0)) {
      this_0.ed(imul(this.nn4(), sign)).s(_Char___init__impl__6a9atx(77));
    }
    if (!(this.gn4() === 0)) {
      this_0.ed(imul(this.gn4(), sign)).s(_Char___init__impl__6a9atx(68));
    }
    var t = 'T';
    if (!(this.hn4() === 0)) {
      // Inline function 'kotlin.also' call
      this_0.q(t).ed(imul(this.hn4(), sign)).s(_Char___init__impl__6a9atx(72));
      t = '';
    }
    if (!(this.in4() === 0)) {
      // Inline function 'kotlin.also' call
      this_0.q(t).ed(imul(this.in4(), sign)).s(_Char___init__impl__6a9atx(77));
      t = '';
    }
    if (!((this.jn4() | this.kn4()) === 0)) {
      this_0.q(t);
      this_0.w(!(this.jn4() === 0) ? imul(this.jn4(), sign) : imul(this.kn4(), sign) < 0 ? '-0' : '0');
      if (!(this.kn4() === 0)) {
        var tmp_0 = this_0.s(_Char___init__impl__6a9atx(46));
        // Inline function 'kotlin.math.absoluteValue' call
        var this_1 = this.kn4();
        var tmp$ret$7 = abs(this_1);
        tmp_0.q(padStart(tmp$ret$7.toString(), 9, _Char___init__impl__6a9atx(48)));
      }
      this_0.s(_Char___init__impl__6a9atx(83));
    }
    if (this_0.a() === 1) {
      this_0.q('0D');
    }
    return this_0.toString();
  };
  protoOf(DateTimePeriod).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DateTimePeriod))
      return false;
    if (!equalsLong(this.fn4(), other.fn4()))
      return false;
    if (!(this.gn4() === other.gn4()))
      return false;
    if (!equalsLong(this.ln4(), other.ln4()))
      return false;
    return true;
  };
  protoOf(DateTimePeriod).hashCode = function () {
    var result = this.fn4().hashCode();
    result = imul(31, result) + this.gn4() | 0;
    result = imul(31, result) + this.ln4().hashCode() | 0;
    return result;
  };
  function totalMonths(years, months) {
    // Inline function 'kotlin.Long.times' call
    var this_0 = fromInt(years);
    var tmp$ret$0 = multiply(this_0, fromInt(12));
    // Inline function 'kotlin.also' call
    var this_1 = add(tmp$ret$0, fromInt(months));
    var tmp0 = numberRangeToNumber(-2147483648, 2147483647);
    // Inline function 'kotlin.Long.div' call
    // Inline function 'kotlin.ranges.contains' call
    var value = divide(this_1, fromInt(12));
    // Inline function 'kotlin.require' call
    if (!contains(isInterface(tmp0, ClosedRange) ? tmp0 : THROW_CCE(), value)) {
      var message = 'The total number of years in ' + years + ' years and ' + months + ' months overflows an Int';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    return this_1;
  }
  function DateTimePeriod_0(years, months, days, hours, minutes, seconds, nanoseconds) {
    years = years === VOID ? 0 : years;
    months = months === VOID ? 0 : months;
    days = days === VOID ? 0 : days;
    hours = hours === VOID ? 0 : hours;
    minutes = minutes === VOID ? 0 : minutes;
    seconds = seconds === VOID ? 0 : seconds;
    nanoseconds = nanoseconds === VOID ? new Long(0, 0) : nanoseconds;
    return buildDateTimePeriod(totalMonths(years, months), days, totalNanoseconds(hours, minutes, seconds, nanoseconds));
  }
  function buildDateTimePeriod(totalMonths, days, totalNanoseconds) {
    totalMonths = totalMonths === VOID ? new Long(0, 0) : totalMonths;
    days = days === VOID ? 0 : days;
    return !equalsLong(totalNanoseconds, new Long(0, 0)) ? new DateTimePeriodImpl(totalMonths, days, totalNanoseconds) : new DatePeriod(totalMonths, days);
  }
  function totalNanoseconds(hours, minutes, seconds, nanoseconds) {
    // Inline function 'kotlin.Long.times' call
    var this_0 = fromInt(hours);
    // Inline function 'kotlin.Long.plus' call
    var this_1 = multiply(this_0, fromInt(60));
    var totalMinutes = add(this_1, fromInt(minutes));
    // Inline function 'kotlin.Long.times' call
    var totalMinutesAsSeconds = multiply(totalMinutes, fromInt(60));
    // Inline function 'kotlin.Long.div' call
    var other = 1000000000;
    var tmp$ret$3 = divide(nanoseconds, fromInt(other));
    var minutesAndNanosecondsAsSeconds = add(totalMinutesAsSeconds, tmp$ret$3);
    // Inline function 'kotlin.Long.plus' call
    var totalSeconds = add(minutesAndNanosecondsAsSeconds, fromInt(seconds));
    var tmp;
    try {
      var tmp_0 = new Long(1000000000, 0);
      // Inline function 'kotlin.Long.rem' call
      var other_0 = 1000000000;
      var tmp$ret$5 = modulo(nanoseconds, fromInt(other_0));
      tmp = multiplyAndAdd(totalSeconds, tmp_0, tmp$ret$5);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof ArithmeticException) {
        var _unused_var__etf5q3 = $p;
        throw IllegalArgumentException_init_$Create$('The total number of nanoseconds in ' + hours + ' hours, ' + minutes + ' minutes, ' + seconds + ' seconds, and ' + nanoseconds.toString() + ' nanoseconds overflows a Long');
      } else {
        throw $p;
      }
    }
    return tmp;
  }
  function DateTimePeriodImpl(totalMonths, days, totalNanoseconds) {
    DateTimePeriod.call(this);
    this.on4_1 = totalMonths;
    this.pn4_1 = days;
    this.qn4_1 = totalNanoseconds;
  }
  protoOf(DateTimePeriodImpl).fn4 = function () {
    return this.on4_1;
  };
  protoOf(DateTimePeriodImpl).gn4 = function () {
    return this.pn4_1;
  };
  protoOf(DateTimePeriodImpl).ln4 = function () {
    return this.qn4_1;
  };
  function Companion_1() {
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function Companion_2() {
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function Companion_3() {
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function Companion_4() {
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function TimeBased(nanoseconds) {
    DateTimeUnit.call(this);
    this.rn4_1 = nanoseconds;
    // Inline function 'kotlin.require' call
    if (!(compare(this.rn4_1, new Long(0, 0)) > 0)) {
      var message = 'Unit duration must be positive, but was ' + this.rn4_1.toString() + ' ns.';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    if (equalsLong(modulo(this.rn4_1, new Long(817405952, 838)), new Long(0, 0))) {
      this.sn4_1 = 'HOUR';
      this.tn4_1 = divide(this.rn4_1, new Long(817405952, 838));
    } else {
      if (equalsLong(modulo(this.rn4_1, new Long(-129542144, 13)), new Long(0, 0))) {
        this.sn4_1 = 'MINUTE';
        this.tn4_1 = divide(this.rn4_1, new Long(-129542144, 13));
      } else {
        var tmp0 = this.rn4_1;
        // Inline function 'kotlin.Long.rem' call
        var other = 1000000000;
        var tmp$ret$2 = modulo(tmp0, fromInt(other));
        if (equalsLong(tmp$ret$2, new Long(0, 0))) {
          this.sn4_1 = 'SECOND';
          var tmp = this;
          var tmp0_0 = this.rn4_1;
          // Inline function 'kotlin.Long.div' call
          var other_0 = 1000000000;
          tmp.tn4_1 = divide(tmp0_0, fromInt(other_0));
        } else {
          // Inline function 'kotlin.Long.rem' call
          var this_0 = this.rn4_1;
          var tmp$ret$4 = modulo(this_0, fromInt(1000000));
          if (equalsLong(tmp$ret$4, new Long(0, 0))) {
            this.sn4_1 = 'MILLISECOND';
            var tmp_0 = this;
            // Inline function 'kotlin.Long.div' call
            var this_1 = this.rn4_1;
            tmp_0.tn4_1 = divide(this_1, fromInt(1000000));
          } else {
            // Inline function 'kotlin.Long.rem' call
            var this_2 = this.rn4_1;
            var tmp$ret$6 = modulo(this_2, fromInt(1000));
            if (equalsLong(tmp$ret$6, new Long(0, 0))) {
              this.sn4_1 = 'MICROSECOND';
              var tmp_1 = this;
              // Inline function 'kotlin.Long.div' call
              var this_3 = this.rn4_1;
              tmp_1.tn4_1 = divide(this_3, fromInt(1000));
            } else {
              this.sn4_1 = 'NANOSECOND';
              this.tn4_1 = this.rn4_1;
            }
          }
        }
      }
    }
  }
  protoOf(TimeBased).un4 = function (scalar) {
    return new TimeBased(safeMultiply(this.rn4_1, fromInt(scalar)));
  };
  protoOf(TimeBased).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      if (other instanceof TimeBased) {
        tmp_0 = equalsLong(this.rn4_1, other.rn4_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(TimeBased).hashCode = function () {
    return convertToInt(this.rn4_1) ^ convertToInt(shiftRight(this.rn4_1, 32));
  };
  protoOf(TimeBased).toString = function () {
    return this.vn4(this.tn4_1, this.sn4_1);
  };
  function DateBased() {
    DateTimeUnit.call(this);
  }
  function DayBased(days) {
    DateBased.call(this);
    this.xn4_1 = days;
    // Inline function 'kotlin.require' call
    if (!(this.xn4_1 > 0)) {
      var message = 'Unit duration must be positive, but was ' + this.xn4_1 + ' days.';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
  }
  protoOf(DayBased).un4 = function (scalar) {
    return new DayBased(safeMultiply_0(this.xn4_1, scalar));
  };
  protoOf(DayBased).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      if (other instanceof DayBased) {
        tmp_0 = this.xn4_1 === other.xn4_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(DayBased).hashCode = function () {
    return this.xn4_1 ^ 65536;
  };
  protoOf(DayBased).toString = function () {
    return (this.xn4_1 % 7 | 0) === 0 ? this.wn4(this.xn4_1 / 7 | 0, 'WEEK') : this.wn4(this.xn4_1, 'DAY');
  };
  function MonthBased(months) {
    DateBased.call(this);
    this.yn4_1 = months;
    // Inline function 'kotlin.require' call
    if (!(this.yn4_1 > 0)) {
      var message = 'Unit duration must be positive, but was ' + this.yn4_1 + ' months.';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
  }
  protoOf(MonthBased).un4 = function (scalar) {
    return new MonthBased(safeMultiply_0(this.yn4_1, scalar));
  };
  protoOf(MonthBased).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      if (other instanceof MonthBased) {
        tmp_0 = this.yn4_1 === other.yn4_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(MonthBased).hashCode = function () {
    return this.yn4_1 ^ 131072;
  };
  protoOf(MonthBased).toString = function () {
    return (this.yn4_1 % 1200 | 0) === 0 ? this.wn4(this.yn4_1 / 1200 | 0, 'CENTURY') : (this.yn4_1 % 12 | 0) === 0 ? this.wn4(this.yn4_1 / 12 | 0, 'YEAR') : (this.yn4_1 % 3 | 0) === 0 ? this.wn4(this.yn4_1 / 3 | 0, 'QUARTER') : this.wn4(this.yn4_1, 'MONTH');
  };
  function Companion_5() {
    Companion_instance_6 = this;
    this.zn4_1 = new TimeBased(new Long(1, 0));
    this.an5_1 = this.zn4_1.un4(1000);
    this.bn5_1 = this.an5_1.un4(1000);
    this.cn5_1 = this.bn5_1.un4(1000);
    this.dn5_1 = this.cn5_1.un4(60);
    this.en5_1 = this.dn5_1.un4(60);
    this.fn5_1 = new DayBased(1);
    this.gn5_1 = this.fn5_1.un4(7);
    this.hn5_1 = new MonthBased(1);
    this.in5_1 = this.hn5_1.un4(3);
    this.jn5_1 = this.hn5_1.un4(12);
    this.kn5_1 = this.jn5_1.un4(100);
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    if (Companion_instance_6 == null)
      new Companion_5();
    return Companion_instance_6;
  }
  function DateTimeUnit() {
    Companion_getInstance_6();
  }
  protoOf(DateTimeUnit).wn4 = function (value, unit) {
    return value === 1 ? unit : '' + value + '-' + unit;
  };
  protoOf(DateTimeUnit).vn4 = function (value, unit) {
    return equalsLong(value, new Long(1, 0)) ? unit : value.toString() + '-' + unit;
  };
  function get_isoDayNumber(_this__u8e3s4) {
    return _this__u8e3s4.a1_1 + 1 | 0;
  }
  var DayOfWeek_MONDAY_instance;
  var DayOfWeek_TUESDAY_instance;
  var DayOfWeek_WEDNESDAY_instance;
  var DayOfWeek_THURSDAY_instance;
  var DayOfWeek_FRIDAY_instance;
  var DayOfWeek_SATURDAY_instance;
  var DayOfWeek_SUNDAY_instance;
  function values() {
    return [DayOfWeek_MONDAY_getInstance(), DayOfWeek_TUESDAY_getInstance(), DayOfWeek_WEDNESDAY_getInstance(), DayOfWeek_THURSDAY_getInstance(), DayOfWeek_FRIDAY_getInstance(), DayOfWeek_SATURDAY_getInstance(), DayOfWeek_SUNDAY_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var DayOfWeek_entriesInitialized;
  function DayOfWeek_initEntries() {
    if (DayOfWeek_entriesInitialized)
      return Unit_instance;
    DayOfWeek_entriesInitialized = true;
    DayOfWeek_MONDAY_instance = new DayOfWeek('MONDAY', 0);
    DayOfWeek_TUESDAY_instance = new DayOfWeek('TUESDAY', 1);
    DayOfWeek_WEDNESDAY_instance = new DayOfWeek('WEDNESDAY', 2);
    DayOfWeek_THURSDAY_instance = new DayOfWeek('THURSDAY', 3);
    DayOfWeek_FRIDAY_instance = new DayOfWeek('FRIDAY', 4);
    DayOfWeek_SATURDAY_instance = new DayOfWeek('SATURDAY', 5);
    DayOfWeek_SUNDAY_instance = new DayOfWeek('SUNDAY', 6);
  }
  var $ENTRIES;
  function DayOfWeek(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function DayOfWeek_0(isoDayNumber) {
    // Inline function 'kotlin.require' call
    if (!(1 <= isoDayNumber ? isoDayNumber <= 7 : false)) {
      var message = 'Expected ISO day-of-week number in 1..7, got ' + isoDayNumber;
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    return get_entries().l1(isoDayNumber - 1 | 0);
  }
  function DayOfWeek_MONDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_MONDAY_instance;
  }
  function DayOfWeek_TUESDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_TUESDAY_instance;
  }
  function DayOfWeek_WEDNESDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_WEDNESDAY_instance;
  }
  function DayOfWeek_THURSDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_THURSDAY_instance;
  }
  function DayOfWeek_FRIDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_FRIDAY_instance;
  }
  function DayOfWeek_SATURDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_SATURDAY_instance;
  }
  function DayOfWeek_SUNDAY_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_SUNDAY_instance;
  }
  function DateTimeFormatException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    DateTimeFormatException.call($this);
    return $this;
  }
  function DateTimeFormatException_init_$Create$() {
    var tmp = DateTimeFormatException_init_$Init$(objectCreate(protoOf(DateTimeFormatException)));
    captureStack(tmp, DateTimeFormatException_init_$Create$);
    return tmp;
  }
  function DateTimeFormatException_init_$Init$_0(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    DateTimeFormatException.call($this);
    return $this;
  }
  function DateTimeFormatException_init_$Create$_0(message) {
    var tmp = DateTimeFormatException_init_$Init$_0(message, objectCreate(protoOf(DateTimeFormatException)));
    captureStack(tmp, DateTimeFormatException_init_$Create$_0);
    return tmp;
  }
  function DateTimeFormatException_init_$Init$_1(message, cause, $this) {
    IllegalArgumentException_init_$Init$_1(message, cause, $this);
    DateTimeFormatException.call($this);
    return $this;
  }
  function DateTimeFormatException_init_$Create$_1(message, cause) {
    var tmp = DateTimeFormatException_init_$Init$_1(message, cause, objectCreate(protoOf(DateTimeFormatException)));
    captureStack(tmp, DateTimeFormatException_init_$Create$_1);
    return tmp;
  }
  function Companion_6() {
    Companion_instance_7 = this;
    this.ln5_1 = new Long(-367331340, 985152264);
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    if (Companion_instance_7 == null)
      new Companion_6();
    return Companion_instance_7;
  }
  function DateTimeFormatException() {
    Companion_getInstance_7();
    captureStack(this, DateTimeFormatException);
  }
  function IllegalTimeZoneException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    IllegalTimeZoneException.call($this);
    return $this;
  }
  function IllegalTimeZoneException_init_$Create$() {
    var tmp = IllegalTimeZoneException_init_$Init$(objectCreate(protoOf(IllegalTimeZoneException)));
    captureStack(tmp, IllegalTimeZoneException_init_$Create$);
    return tmp;
  }
  function IllegalTimeZoneException_init_$Init$_0(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    IllegalTimeZoneException.call($this);
    return $this;
  }
  function IllegalTimeZoneException_init_$Create$_0(message) {
    var tmp = IllegalTimeZoneException_init_$Init$_0(message, objectCreate(protoOf(IllegalTimeZoneException)));
    captureStack(tmp, IllegalTimeZoneException_init_$Create$_0);
    return tmp;
  }
  function IllegalTimeZoneException_init_$Init$_1(cause, $this) {
    IllegalArgumentException_init_$Init$_2(cause, $this);
    IllegalTimeZoneException.call($this);
    return $this;
  }
  function IllegalTimeZoneException_init_$Create$_1(cause) {
    var tmp = IllegalTimeZoneException_init_$Init$_1(cause, objectCreate(protoOf(IllegalTimeZoneException)));
    captureStack(tmp, IllegalTimeZoneException_init_$Create$_1);
    return tmp;
  }
  function IllegalTimeZoneException_init_$Init$_2(message, cause, $this) {
    IllegalArgumentException_init_$Init$_1(message, cause, $this);
    IllegalTimeZoneException.call($this);
    return $this;
  }
  function IllegalTimeZoneException_init_$Create$_2(message, cause) {
    var tmp = IllegalTimeZoneException_init_$Init$_2(message, cause, objectCreate(protoOf(IllegalTimeZoneException)));
    captureStack(tmp, IllegalTimeZoneException_init_$Create$_2);
    return tmp;
  }
  function Companion_7() {
    Companion_instance_8 = this;
    this.mn5_1 = new Long(-1606983967, 269924282);
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    if (Companion_instance_8 == null)
      new Companion_7();
    return Companion_instance_8;
  }
  function IllegalTimeZoneException() {
    Companion_getInstance_8();
    captureStack(this, IllegalTimeZoneException);
  }
  function DateTimeArithmeticException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    DateTimeArithmeticException.call($this);
    return $this;
  }
  function DateTimeArithmeticException_init_$Create$() {
    var tmp = DateTimeArithmeticException_init_$Init$(objectCreate(protoOf(DateTimeArithmeticException)));
    captureStack(tmp, DateTimeArithmeticException_init_$Create$);
    return tmp;
  }
  function DateTimeArithmeticException_init_$Init$_0(message, cause, $this) {
    RuntimeException_init_$Init$_0(message, cause, $this);
    DateTimeArithmeticException.call($this);
    return $this;
  }
  function DateTimeArithmeticException_init_$Create$_0(message, cause) {
    var tmp = DateTimeArithmeticException_init_$Init$_0(message, cause, objectCreate(protoOf(DateTimeArithmeticException)));
    captureStack(tmp, DateTimeArithmeticException_init_$Create$_0);
    return tmp;
  }
  function Companion_8() {
    Companion_instance_9 = this;
    this.nn5_1 = new Long(-1408802782, -746875576);
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_8();
    return Companion_instance_9;
  }
  function DateTimeArithmeticException() {
    Companion_getInstance_9();
    captureStack(this, DateTimeArithmeticException);
  }
  function plus_1(_this__u8e3s4, value, unit) {
    return plus_2(_this__u8e3s4, fromInt(value), unit);
  }
  function getIsoDateFormat() {
    return Formats_getInstance().pn5();
  }
  function format(_this__u8e3s4, format) {
    return format.qn5(_this__u8e3s4);
  }
  function atTime(_this__u8e3s4, time) {
    return new LocalDateTime(_this__u8e3s4, time);
  }
  function getIsoDateTimeFormat() {
    return Formats_getInstance_0().rn5_1;
  }
  function format_0(_this__u8e3s4, format) {
    return format.qn5(_this__u8e3s4);
  }
  function getIsoTimeFormat() {
    return Formats_instance_1.pn5();
  }
  function format_1(_this__u8e3s4, format) {
    return format.qn5(_this__u8e3s4);
  }
  function get_number(_this__u8e3s4) {
    return _this__u8e3s4.a1_1 + 1 | 0;
  }
  var Month_JANUARY_instance;
  var Month_FEBRUARY_instance;
  var Month_MARCH_instance;
  var Month_APRIL_instance;
  var Month_MAY_instance;
  var Month_JUNE_instance;
  var Month_JULY_instance;
  var Month_AUGUST_instance;
  var Month_SEPTEMBER_instance;
  var Month_OCTOBER_instance;
  var Month_NOVEMBER_instance;
  var Month_DECEMBER_instance;
  function values_0() {
    return [Month_JANUARY_getInstance(), Month_FEBRUARY_getInstance(), Month_MARCH_getInstance(), Month_APRIL_getInstance(), Month_MAY_getInstance(), Month_JUNE_getInstance(), Month_JULY_getInstance(), Month_AUGUST_getInstance(), Month_SEPTEMBER_getInstance(), Month_OCTOBER_getInstance(), Month_NOVEMBER_getInstance(), Month_DECEMBER_getInstance()];
  }
  function get_entries_0() {
    if ($ENTRIES_0 == null)
      $ENTRIES_0 = enumEntries(values_0());
    return $ENTRIES_0;
  }
  var Month_entriesInitialized;
  function Month_initEntries() {
    if (Month_entriesInitialized)
      return Unit_instance;
    Month_entriesInitialized = true;
    Month_JANUARY_instance = new Month('JANUARY', 0);
    Month_FEBRUARY_instance = new Month('FEBRUARY', 1);
    Month_MARCH_instance = new Month('MARCH', 2);
    Month_APRIL_instance = new Month('APRIL', 3);
    Month_MAY_instance = new Month('MAY', 4);
    Month_JUNE_instance = new Month('JUNE', 5);
    Month_JULY_instance = new Month('JULY', 6);
    Month_AUGUST_instance = new Month('AUGUST', 7);
    Month_SEPTEMBER_instance = new Month('SEPTEMBER', 8);
    Month_OCTOBER_instance = new Month('OCTOBER', 9);
    Month_NOVEMBER_instance = new Month('NOVEMBER', 10);
    Month_DECEMBER_instance = new Month('DECEMBER', 11);
  }
  var $ENTRIES_0;
  function Month(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Month_0(number) {
    // Inline function 'kotlin.require' call
    if (!(1 <= number ? number <= 12 : false)) {
      var message = 'Month must be a number between 1 and 12, got ' + number;
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    return get_entries_0().l1(number - 1 | 0);
  }
  function Month_JANUARY_getInstance() {
    Month_initEntries();
    return Month_JANUARY_instance;
  }
  function Month_FEBRUARY_getInstance() {
    Month_initEntries();
    return Month_FEBRUARY_instance;
  }
  function Month_MARCH_getInstance() {
    Month_initEntries();
    return Month_MARCH_instance;
  }
  function Month_APRIL_getInstance() {
    Month_initEntries();
    return Month_APRIL_instance;
  }
  function Month_MAY_getInstance() {
    Month_initEntries();
    return Month_MAY_instance;
  }
  function Month_JUNE_getInstance() {
    Month_initEntries();
    return Month_JUNE_instance;
  }
  function Month_JULY_getInstance() {
    Month_initEntries();
    return Month_JULY_instance;
  }
  function Month_AUGUST_getInstance() {
    Month_initEntries();
    return Month_AUGUST_instance;
  }
  function Month_SEPTEMBER_getInstance() {
    Month_initEntries();
    return Month_SEPTEMBER_instance;
  }
  function Month_OCTOBER_getInstance() {
    Month_initEntries();
    return Month_OCTOBER_instance;
  }
  function Month_NOVEMBER_getInstance() {
    Month_initEntries();
    return Month_NOVEMBER_instance;
  }
  function Month_DECEMBER_getInstance() {
    Month_initEntries();
    return Month_DECEMBER_instance;
  }
  function Companion_9() {
    Companion_instance_10 = this;
    this.sn5_1 = new OverloadMarker();
  }
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_9();
    return Companion_instance_10;
  }
  function OverloadMarker() {
    Companion_getInstance_10();
  }
  function format_2(_this__u8e3s4, format) {
    return format.qn5(_this__u8e3s4);
  }
  function getIsoUtcOffsetFormat() {
    return Formats_instance_2.pn5();
  }
  function asTimeZone(_this__u8e3s4) {
    return FixedOffsetTimeZone_init_$Create$(_this__u8e3s4);
  }
  function AbstractDateTimeFormat() {
  }
  protoOf(AbstractDateTimeFormat).qn5 = function (value) {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder_init_$Create$();
    this.tn5().an6().bn6(this.un5(value), this_0);
    return this_0.toString();
  };
  protoOf(AbstractDateTimeFormat).sp = function (input) {
    var tmp;
    try {
      tmp = Parser__match$default_impl_x2xlti(_Parser___init__impl__gdyfby(this.tn5().cn6()), input, this.wn5());
    } catch ($p) {
      var tmp_0;
      if ($p instanceof ParseException) {
        var e = $p;
        throw DateTimeFormatException_init_$Create$_1("Failed to parse value from '" + toString_0(input) + "'", e);
      } else {
        throw $p;
      }
    }
    var matched = tmp;
    try {
      return this.vn5(matched);
    } catch ($p_0) {
      if ($p_0 instanceof IllegalArgumentException) {
        var e_0 = $p_0;
        var message = e_0.message;
        throw DateTimeFormatException_init_$Create$_1(message == null ? "The value parsed from '" + toString_0(input) + "' is invalid" : '' + message + " (when parsing '" + toString_0(input) + "')", e_0);
      } else {
        throw $p_0;
      }
    }
  };
  var Padding_NONE_instance;
  var Padding_ZERO_instance;
  var Padding_SPACE_instance;
  var Padding_entriesInitialized;
  function Padding_initEntries() {
    if (Padding_entriesInitialized)
      return Unit_instance;
    Padding_entriesInitialized = true;
    Padding_NONE_instance = new Padding('NONE', 0);
    Padding_ZERO_instance = new Padding('ZERO', 1);
    Padding_SPACE_instance = new Padding('SPACE', 2);
  }
  function Padding(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Padding_NONE_getInstance() {
    Padding_initEntries();
    return Padding_NONE_instance;
  }
  function Padding_ZERO_getInstance() {
    Padding_initEntries();
    return Padding_ZERO_instance;
  }
  function Padding_SPACE_getInstance() {
    Padding_initEntries();
    return Padding_SPACE_instance;
  }
  function WithYearMonth() {
  }
  function WithDate() {
  }
  function WithTime() {
  }
  function WithUtcOffset() {
  }
  function WithDateTimeComponents() {
  }
  function char(_this__u8e3s4, value) {
    return _this__u8e3s4.in6(toString(value));
  }
  function optional(_this__u8e3s4, ifZero, format) {
    ifZero = ifZero === VOID ? '' : ifZero;
    var tmp;
    if (isInterface(_this__u8e3s4, AbstractDateTimeFormatBuilder)) {
      _this__u8e3s4.dn7(ifZero, typeof format === 'function' ? format : THROW_CCE());
      tmp = Unit_instance;
    } else {
      throw IllegalStateException_init_$Create$('impossible');
    }
    return tmp;
  }
  function alternativeParsing(_this__u8e3s4, alternativeFormats, primaryFormat) {
    var tmp;
    if (isInterface(_this__u8e3s4, AbstractDateTimeFormatBuilder)) {
      var tmp_0 = (isArray(alternativeFormats) ? alternativeFormats : THROW_CCE()).slice();
      _this__u8e3s4.en7(tmp_0, typeof primaryFormat === 'function' ? primaryFormat : THROW_CCE());
      tmp = Unit_instance;
    } else {
      throw IllegalStateException_init_$Create$('impossible');
    }
    return tmp;
  }
  function AbstractDateTimeFormatBuilder() {
  }
  function secondFractionInternal(_this__u8e3s4, minLength, maxLength, grouping) {
    (isInterface(_this__u8e3s4, AbstractWithTimeBuilder) ? _this__u8e3s4 : THROW_CCE()).kn7(new BasicFormatStructure(new FractionalSecondDirective(minLength, maxLength, grouping)));
  }
  function get_ISO_DATE() {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    var tmp0 = ISO_DATE$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ISO_DATE', 0, tmp, _get_ISO_DATE_$ref_powsum(), null);
    return tmp0.u1();
  }
  var ISO_DATE$delegate;
  function get_ISO_DATE_BASIC() {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    var tmp0 = ISO_DATE_BASIC$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ISO_DATE_BASIC', 0, tmp, _get_ISO_DATE_BASIC_$ref_3fs8eb(), null);
    return tmp0.u1();
  }
  var ISO_DATE_BASIC$delegate;
  function get_emptyIncompleteLocalDate() {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    return emptyIncompleteLocalDate;
  }
  var emptyIncompleteLocalDate;
  function IncompleteLocalDate(yearMonth, day, dayOfWeek, dayOfYear) {
    yearMonth = yearMonth === VOID ? new IncompleteYearMonth() : yearMonth;
    day = day === VOID ? null : day;
    dayOfWeek = dayOfWeek === VOID ? null : dayOfWeek;
    dayOfYear = dayOfYear === VOID ? null : dayOfYear;
    this.ln7_1 = yearMonth;
    this.mn7_1 = day;
    this.nn7_1 = dayOfWeek;
    this.on7_1 = dayOfYear;
  }
  protoOf(IncompleteLocalDate).pn7 = function (_set____db54di) {
    this.mn7_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDate).qn7 = function () {
    return this.mn7_1;
  };
  protoOf(IncompleteLocalDate).rn7 = function (_set____db54di) {
    this.nn7_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDate).sn7 = function () {
    return this.nn7_1;
  };
  protoOf(IncompleteLocalDate).tn7 = function (_set____db54di) {
    this.on7_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDate).un7 = function () {
    return this.on7_1;
  };
  protoOf(IncompleteLocalDate).vn7 = function () {
    var year = requireParsedField(this.wn7(), 'year');
    var dayOfYear = this.on7_1;
    var tmp;
    if (dayOfYear == null) {
      tmp = LocalDate_init_$Create$(year, requireParsedField(this.bn8(), 'monthNumber'), requireParsedField(this.mn7_1, 'day'));
    } else {
      // Inline function 'kotlin.also' call
      var this_0 = plus_1(LocalDate_init_$Create$(year, 1, 1), dayOfYear - 1 | 0, Companion_getInstance_6().fn5_1);
      if (!(this_0.xn7_1 === year)) {
        throw DateTimeFormatException_init_$Create$_0('Can not create a LocalDate from the given input: ' + ('the day of year is ' + dayOfYear + ', which is not a valid day of year for the year ' + year));
      }
      if (!(this.bn8() == null) && !(get_number(this_0.an8()) === this.bn8())) {
        throw DateTimeFormatException_init_$Create$_0('Can not create a LocalDate from the given input: ' + ('the day of year is ' + dayOfYear + ', which is ' + this_0.an8().toString() + ', ') + ('but ' + this.bn8() + ' was specified as the month number'));
      }
      if (!(this.mn7_1 == null) && !(this_0.yn7_1 === this.mn7_1)) {
        throw DateTimeFormatException_init_$Create$_0('Can not create a LocalDate from the given input: ' + ('the day of year is ' + dayOfYear + ', which is the day ' + this_0.yn7_1 + ' of ' + this_0.an8().toString() + ', ') + ('but ' + this.mn7_1 + ' was specified as the day of month'));
      }
      tmp = this_0;
    }
    var date = tmp;
    var tmp0_safe_receiver = this.nn7_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (!(tmp0_safe_receiver === get_isoDayNumber(date.sn7()))) {
        throw DateTimeFormatException_init_$Create$_0('Can not create a LocalDate from the given input: ' + ('the day of week is ' + DayOfWeek_0(tmp0_safe_receiver).toString() + ' but the date is ' + date.toString() + ', which is a ' + date.sn7().toString()));
      }
    }
    return date;
  };
  protoOf(IncompleteLocalDate).cn8 = function (date) {
    this.dn8(date.xn7_1);
    this.en8(get_number(date.an8()));
    this.mn7_1 = date.yn7_1;
    this.nn7_1 = get_isoDayNumber(date.sn7());
    this.on7_1 = date.un7();
  };
  protoOf(IncompleteLocalDate).xbr = function () {
    return new IncompleteLocalDate(this.ln7_1.xbr(), this.mn7_1, this.nn7_1, this.on7_1);
  };
  protoOf(IncompleteLocalDate).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof IncompleteLocalDate) {
      tmp_2 = this.ln7_1.equals(other.ln7_1);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.mn7_1 == other.mn7_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.nn7_1 == other.nn7_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.on7_1 == other.on7_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IncompleteLocalDate).hashCode = function () {
    var tmp = imul(this.ln7_1.hashCode(), 29791);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.mn7_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp_0 = tmp + imul(tmp$ret$0, 961) | 0;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.nn7_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    var tmp$ret$1 = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
    var tmp_1 = tmp_0 + imul(tmp$ret$1, 31) | 0;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_1 = this.on7_1;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
    return tmp_1 + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
  };
  protoOf(IncompleteLocalDate).toString = function () {
    var tmp;
    if (this.on7_1 == null) {
      var tmp_0 = this.ln7_1.toString();
      var tmp0_elvis_lhs = this.mn7_1;
      var tmp_1 = toString_0(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
      var tmp1_elvis_lhs = this.nn7_1;
      tmp = tmp_0 + '-' + tmp_1 + ' (day of week is ' + toString_0(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs) + ')';
    } else if (this.mn7_1 == null && this.bn8() == null) {
      var tmp2_elvis_lhs = this.ln7_1.fn8_1;
      var tmp_2 = toString_0(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
      var tmp_3 = this.on7_1;
      var tmp3_elvis_lhs = this.nn7_1;
      tmp = '(' + tmp_2 + ')-' + tmp_3 + ' (day of week is ' + toString_0(tmp3_elvis_lhs == null ? '??' : tmp3_elvis_lhs) + ')';
    } else {
      var tmp_4 = this.ln7_1.toString();
      var tmp4_elvis_lhs = this.mn7_1;
      var tmp_5 = toString_0(tmp4_elvis_lhs == null ? '??' : tmp4_elvis_lhs);
      var tmp5_elvis_lhs = this.nn7_1;
      tmp = tmp_4 + '-' + tmp_5 + ' (day of week is ' + toString_0(tmp5_elvis_lhs == null ? '??' : tmp5_elvis_lhs) + ', day of year is ' + this.on7_1 + ')';
    }
    return tmp;
  };
  protoOf(IncompleteLocalDate).dn8 = function (_set____db54di) {
    this.ln7_1.fn8_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDate).wn7 = function () {
    return this.ln7_1.fn8_1;
  };
  protoOf(IncompleteLocalDate).en8 = function (_set____db54di) {
    this.ln7_1.gn8_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDate).bn8 = function () {
    return this.ln7_1.gn8_1;
  };
  function Companion_10() {
  }
  protoOf(Companion_10).hn8 = function (block) {
    var builder = new Builder(new AppendableFormatStructure());
    block(builder);
    return new LocalDateFormat(builder.g3d());
  };
  var Companion_instance_11;
  function Companion_getInstance_11() {
    return Companion_instance_11;
  }
  function Builder(actualBuilder) {
    this.in8_1 = actualBuilder;
  }
  protoOf(Builder).fn7 = function () {
    return this.in8_1;
  };
  protoOf(Builder).jn8 = function (structure) {
    return this.in8_1.in7(structure);
  };
  protoOf(Builder).gn7 = function () {
    return new Builder(new AppendableFormatStructure());
  };
  function LocalDateFormat(actualFormat) {
    AbstractDateTimeFormat.call(this);
    this.ln8_1 = actualFormat;
  }
  protoOf(LocalDateFormat).tn5 = function () {
    return this.ln8_1;
  };
  protoOf(LocalDateFormat).mn8 = function (value) {
    // Inline function 'kotlin.apply' call
    var this_0 = new IncompleteLocalDate();
    this_0.cn8(value);
    return this_0;
  };
  protoOf(LocalDateFormat).un5 = function (value) {
    return this.mn8(value instanceof LocalDate ? value : THROW_CCE());
  };
  protoOf(LocalDateFormat).nn8 = function (intermediate) {
    return intermediate.vn7();
  };
  protoOf(LocalDateFormat).vn5 = function (intermediate) {
    return this.nn8(intermediate instanceof IncompleteLocalDate ? intermediate : THROW_CCE());
  };
  protoOf(LocalDateFormat).wn5 = function () {
    return get_emptyIncompleteLocalDate();
  };
  function AbstractWithDateBuilder() {
  }
  function DayDirective(padding) {
    var tmp = DateFields_getInstance().on8_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.vn8_1 = padding;
  }
  protoOf(DayDirective).equals = function (other) {
    var tmp;
    if (other instanceof DayDirective) {
      tmp = this.vn8_1.equals(other.vn8_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(DayDirective).hashCode = function () {
    return this.vn8_1.hashCode();
  };
  function DayOfYearDirective(padding) {
    var tmp = DateFields_getInstance().qn8_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 3 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 3 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.fn9_1 = padding;
  }
  protoOf(DayOfYearDirective).equals = function (other) {
    var tmp;
    if (other instanceof DayOfYearDirective) {
      tmp = this.fn9_1.equals(other.fn9_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(DayOfYearDirective).hashCode = function () {
    return this.fn9_1.hashCode();
  };
  function DateFieldContainer$_get_day_$ref_2ebhxx() {
    return constructCallableReference(function (p0) {
      return p0.qn7();
    }, 1, 0, 395);
  }
  function DateFieldContainer$_set_day_$ref_s0jsax() {
    return constructCallableReference(function (p0, p1) {
      p0.pn7(p1);
      return Unit_instance;
    }, 2, 0, 396);
  }
  function DateFieldContainer$_get_dayOfWeek_$ref_thwqom() {
    return constructCallableReference(function (p0) {
      return p0.sn7();
    }, 1, 0, 397);
  }
  function DateFieldContainer$_set_dayOfWeek_$ref_ea586a() {
    return constructCallableReference(function (p0, p1) {
      p0.rn7(p1);
      return Unit_instance;
    }, 2, 0, 398);
  }
  function DateFieldContainer$_get_dayOfYear_$ref_2m6gfz() {
    return constructCallableReference(function (p0) {
      return p0.un7();
    }, 1, 0, 399);
  }
  function DateFieldContainer$_set_dayOfYear_$ref_cll22d() {
    return constructCallableReference(function (p0, p1) {
      p0.tn7(p1);
      return Unit_instance;
    }, 2, 0, 400);
  }
  function DateFields() {
    DateFields_instance = this;
    var tmp = this;
    var tmp_0 = KMutableProperty1;
    var tmp_1 = DateFieldContainer$_get_day_$ref_2ebhxx();
    tmp.on8_1 = new UnsignedFieldSpec(new PropertyAccessor(getPropertyCallableRef('day', 1, tmp_0, tmp_1, DateFieldContainer$_set_day_$ref_s0jsax())), 1, 31);
    var tmp_2 = this;
    var tmp_3 = KMutableProperty1;
    var tmp_4 = DateFieldContainer$_get_dayOfWeek_$ref_thwqom();
    tmp_2.pn8_1 = new UnsignedFieldSpec(new PropertyAccessor(getPropertyCallableRef('dayOfWeek', 1, tmp_3, tmp_4, DateFieldContainer$_set_dayOfWeek_$ref_ea586a())), 1, 7);
    var tmp_5 = this;
    var tmp_6 = KMutableProperty1;
    var tmp_7 = DateFieldContainer$_get_dayOfYear_$ref_2m6gfz();
    tmp_5.qn8_1 = new UnsignedFieldSpec(new PropertyAccessor(getPropertyCallableRef('dayOfYear', 1, tmp_6, tmp_7, DateFieldContainer$_set_dayOfYear_$ref_cll22d())), 1, 366);
  }
  var DateFields_instance;
  function DateFields_getInstance() {
    if (DateFields_instance == null)
      new DateFields();
    return DateFields_instance;
  }
  function ISO_DATE$delegate$lambda() {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    var tmp = Companion_instance_11;
    return tmp.hn8(ISO_DATE$delegate$lambda$lambda);
  }
  function ISO_DATE$delegate$lambda$lambda($this$build) {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    $this$build.en6();
    char($this$build, _Char___init__impl__6a9atx(45));
    $this$build.hn6();
    char($this$build, _Char___init__impl__6a9atx(45));
    $this$build.kn6();
    return Unit_instance;
  }
  function _get_ISO_DATE_$ref_powsum() {
    return constructCallableReference(function () {
      return get_ISO_DATE();
    }, 0, 0, 401);
  }
  function ISO_DATE_BASIC$delegate$lambda() {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    var tmp = Companion_instance_11;
    return tmp.hn8(ISO_DATE_BASIC$delegate$lambda$lambda);
  }
  function ISO_DATE_BASIC$delegate$lambda$lambda($this$build) {
    _init_properties_LocalDateFormat_kt__k1uk9u();
    $this$build.en6();
    $this$build.hn6();
    $this$build.kn6();
    return Unit_instance;
  }
  function _get_ISO_DATE_BASIC_$ref_3fs8eb() {
    return constructCallableReference(function () {
      return get_ISO_DATE_BASIC();
    }, 0, 0, 402);
  }
  var properties_initialized_LocalDateFormat_kt_fmnlhc;
  function _init_properties_LocalDateFormat_kt__k1uk9u() {
    if (!properties_initialized_LocalDateFormat_kt_fmnlhc) {
      properties_initialized_LocalDateFormat_kt_fmnlhc = true;
      ISO_DATE$delegate = lazy(ISO_DATE$delegate$lambda);
      ISO_DATE_BASIC$delegate = lazy(ISO_DATE_BASIC$delegate$lambda);
      emptyIncompleteLocalDate = new IncompleteLocalDate();
    }
  }
  function get_ISO_DATETIME() {
    _init_properties_LocalDateTimeFormat_kt__aloigl();
    var tmp0 = ISO_DATETIME$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ISO_DATETIME', 0, tmp, _get_ISO_DATETIME_$ref_5bxm11(), null);
    return tmp0.u1();
  }
  var ISO_DATETIME$delegate;
  function get_emptyIncompleteLocalDateTime() {
    _init_properties_LocalDateTimeFormat_kt__aloigl();
    return emptyIncompleteLocalDateTime;
  }
  var emptyIncompleteLocalDateTime;
  function Companion_11() {
  }
  protoOf(Companion_11).gn9 = function (block) {
    var builder = new Builder_0(new AppendableFormatStructure());
    block(builder);
    return new LocalDateTimeFormat(builder.g3d());
  };
  var Companion_instance_12;
  function Companion_getInstance_12() {
    return Companion_instance_12;
  }
  function Builder_0(actualBuilder) {
    this.hn9_1 = actualBuilder;
  }
  protoOf(Builder_0).fn7 = function () {
    return this.hn9_1;
  };
  protoOf(Builder_0).in9 = function (structure) {
    this.hn9_1.in7(structure);
  };
  protoOf(Builder_0).gn7 = function () {
    return new Builder_0(new AppendableFormatStructure());
  };
  function LocalDateTimeFormat(actualFormat) {
    AbstractDateTimeFormat.call(this);
    this.jn9_1 = actualFormat;
  }
  protoOf(LocalDateTimeFormat).tn5 = function () {
    return this.jn9_1;
  };
  protoOf(LocalDateTimeFormat).kn9 = function (value) {
    // Inline function 'kotlin.apply' call
    var this_0 = new IncompleteLocalDateTime();
    this_0.nn9(value);
    return this_0;
  };
  protoOf(LocalDateTimeFormat).un5 = function (value) {
    return this.kn9(value instanceof LocalDateTime ? value : THROW_CCE());
  };
  protoOf(LocalDateTimeFormat).on9 = function (intermediate) {
    return intermediate.pn9();
  };
  protoOf(LocalDateTimeFormat).vn5 = function (intermediate) {
    return this.on9(intermediate instanceof IncompleteLocalDateTime ? intermediate : THROW_CCE());
  };
  protoOf(LocalDateTimeFormat).wn5 = function () {
    return get_emptyIncompleteLocalDateTime();
  };
  function IncompleteLocalDateTime(date, time) {
    date = date === VOID ? new IncompleteLocalDate() : date;
    time = time === VOID ? new IncompleteLocalTime() : time;
    this.ln9_1 = date;
    this.mn9_1 = time;
  }
  protoOf(IncompleteLocalDateTime).pn9 = function () {
    return new LocalDateTime(this.ln9_1.vn7(), this.mn9_1.wn9());
  };
  protoOf(IncompleteLocalDateTime).nn9 = function (dateTime) {
    this.ln9_1.cn8(dateTime.xn9_1);
    this.mn9_1.zn9(dateTime.yn9_1);
  };
  protoOf(IncompleteLocalDateTime).xbr = function () {
    return new IncompleteLocalDateTime(this.ln9_1.xbr(), this.mn9_1.xbr());
  };
  protoOf(IncompleteLocalDateTime).pn7 = function (_set____db54di) {
    this.ln9_1.mn7_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).qn7 = function () {
    return this.ln9_1.mn7_1;
  };
  protoOf(IncompleteLocalDateTime).rn7 = function (_set____db54di) {
    this.ln9_1.nn7_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).sn7 = function () {
    return this.ln9_1.nn7_1;
  };
  protoOf(IncompleteLocalDateTime).tn7 = function (_set____db54di) {
    this.ln9_1.on7_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).un7 = function () {
    return this.ln9_1.on7_1;
  };
  protoOf(IncompleteLocalDateTime).dn8 = function (_set____db54di) {
    this.ln9_1.dn8(_set____db54di);
  };
  protoOf(IncompleteLocalDateTime).wn7 = function () {
    return this.ln9_1.wn7();
  };
  protoOf(IncompleteLocalDateTime).en8 = function (_set____db54di) {
    this.ln9_1.en8(_set____db54di);
  };
  protoOf(IncompleteLocalDateTime).bn8 = function () {
    return this.ln9_1.bn8();
  };
  protoOf(IncompleteLocalDateTime).ana = function (_set____db54di) {
    this.mn9_1.tn9_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).bna = function () {
    return this.mn9_1.tn9_1;
  };
  protoOf(IncompleteLocalDateTime).cna = function (_set____db54di) {
    this.mn9_1.un9_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).dna = function () {
    return this.mn9_1.un9_1;
  };
  protoOf(IncompleteLocalDateTime).ena = function (_set____db54di) {
    this.mn9_1.vn9_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).fna = function () {
    return this.mn9_1.vn9_1;
  };
  protoOf(IncompleteLocalDateTime).gna = function (_set____db54di) {
    this.mn9_1.qn9_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).hna = function () {
    return this.mn9_1.qn9_1;
  };
  protoOf(IncompleteLocalDateTime).ina = function (_set____db54di) {
    this.mn9_1.rn9_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).jna = function () {
    return this.mn9_1.rn9_1;
  };
  protoOf(IncompleteLocalDateTime).kna = function (_set____db54di) {
    this.mn9_1.sn9_1 = _set____db54di;
  };
  protoOf(IncompleteLocalDateTime).lna = function () {
    return this.mn9_1.sn9_1;
  };
  protoOf(IncompleteLocalDateTime).mna = function (value) {
    this.mn9_1.mna(value);
  };
  protoOf(IncompleteLocalDateTime).nna = function () {
    return this.mn9_1.nna();
  };
  function AbstractWithDateTimeBuilder() {
  }
  function ISO_DATETIME$delegate$lambda() {
    _init_properties_LocalDateTimeFormat_kt__aloigl();
    var tmp = Companion_instance_12;
    return tmp.gn9(ISO_DATETIME$delegate$lambda$lambda);
  }
  function ISO_DATETIME$delegate$lambda$lambda($this$build) {
    _init_properties_LocalDateTimeFormat_kt__aloigl();
    $this$build.mn6(get_ISO_DATE());
    var tmp = [ISO_DATETIME$delegate$lambda$lambda$lambda];
    alternativeParsing($this$build, tmp, ISO_DATETIME$delegate$lambda$lambda$lambda_0);
    $this$build.vn6(get_ISO_TIME());
    return Unit_instance;
  }
  function ISO_DATETIME$delegate$lambda$lambda$lambda($this$alternativeParsing) {
    _init_properties_LocalDateTimeFormat_kt__aloigl();
    char($this$alternativeParsing, _Char___init__impl__6a9atx(116));
    return Unit_instance;
  }
  function ISO_DATETIME$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
    _init_properties_LocalDateTimeFormat_kt__aloigl();
    char($this$alternativeParsing, _Char___init__impl__6a9atx(84));
    return Unit_instance;
  }
  function _get_ISO_DATETIME_$ref_5bxm11() {
    return constructCallableReference(function () {
      return get_ISO_DATETIME();
    }, 0, 0, 403);
  }
  var properties_initialized_LocalDateTimeFormat_kt_67ys6r;
  function _init_properties_LocalDateTimeFormat_kt__aloigl() {
    if (!properties_initialized_LocalDateTimeFormat_kt_67ys6r) {
      properties_initialized_LocalDateTimeFormat_kt_67ys6r = true;
      ISO_DATETIME$delegate = lazy(ISO_DATETIME$delegate$lambda);
      emptyIncompleteLocalDateTime = new IncompleteLocalDateTime();
    }
  }
  function get_ISO_TIME() {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    var tmp0 = ISO_TIME$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ISO_TIME', 0, tmp, _get_ISO_TIME_$ref_kyx2od(), null);
    return tmp0.u1();
  }
  var ISO_TIME$delegate;
  function get_emptyIncompleteLocalTime() {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    return emptyIncompleteLocalTime;
  }
  var emptyIncompleteLocalTime;
  function TimeFieldContainer() {
  }
  function IncompleteLocalTime(hour, hourOfAmPm, amPm, minute, second, nanosecond) {
    hour = hour === VOID ? null : hour;
    hourOfAmPm = hourOfAmPm === VOID ? null : hourOfAmPm;
    amPm = amPm === VOID ? null : amPm;
    minute = minute === VOID ? null : minute;
    second = second === VOID ? null : second;
    nanosecond = nanosecond === VOID ? null : nanosecond;
    this.qn9_1 = hour;
    this.rn9_1 = hourOfAmPm;
    this.sn9_1 = amPm;
    this.tn9_1 = minute;
    this.un9_1 = second;
    this.vn9_1 = nanosecond;
  }
  protoOf(IncompleteLocalTime).gna = function (_set____db54di) {
    this.qn9_1 = _set____db54di;
  };
  protoOf(IncompleteLocalTime).hna = function () {
    return this.qn9_1;
  };
  protoOf(IncompleteLocalTime).ina = function (_set____db54di) {
    this.rn9_1 = _set____db54di;
  };
  protoOf(IncompleteLocalTime).jna = function () {
    return this.rn9_1;
  };
  protoOf(IncompleteLocalTime).kna = function (_set____db54di) {
    this.sn9_1 = _set____db54di;
  };
  protoOf(IncompleteLocalTime).lna = function () {
    return this.sn9_1;
  };
  protoOf(IncompleteLocalTime).ana = function (_set____db54di) {
    this.tn9_1 = _set____db54di;
  };
  protoOf(IncompleteLocalTime).bna = function () {
    return this.tn9_1;
  };
  protoOf(IncompleteLocalTime).cna = function (_set____db54di) {
    this.un9_1 = _set____db54di;
  };
  protoOf(IncompleteLocalTime).dna = function () {
    return this.un9_1;
  };
  protoOf(IncompleteLocalTime).ena = function (_set____db54di) {
    this.vn9_1 = _set____db54di;
  };
  protoOf(IncompleteLocalTime).fna = function () {
    return this.vn9_1;
  };
  protoOf(IncompleteLocalTime).wn9 = function () {
    var tmp0_safe_receiver = this.qn9_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = this.rn9_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.require' call
        if (!((((tmp0_safe_receiver + 11 | 0) % 12 | 0) + 1 | 0) === tmp0_safe_receiver_0)) {
          var message = 'Inconsistent hour and hour-of-am-pm: hour is ' + tmp0_safe_receiver + ', but hour-of-am-pm is ' + tmp0_safe_receiver_0;
          throw IllegalArgumentException_init_$Create$(toString_0(message));
        }
      }
      var tmp1_safe_receiver = this.sn9_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.require' call
        if (!(tmp1_safe_receiver.equals(AmPmMarker_PM_getInstance()) === tmp0_safe_receiver >= 12)) {
          var message_0 = 'Inconsistent hour and the AM/PM marker: hour is ' + tmp0_safe_receiver + ', but the AM/PM marker is ' + tmp1_safe_receiver.toString();
          throw IllegalArgumentException_init_$Create$(toString_0(message_0));
        }
      }
      tmp = tmp0_safe_receiver;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = this.rn9_1;
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp0_safe_receiver_1 = this.sn9_1;
        var tmp_2;
        if (tmp0_safe_receiver_1 == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.let' call
          tmp_2 = (tmp2_safe_receiver === 12 ? 0 : tmp2_safe_receiver) + (tmp0_safe_receiver_1.equals(AmPmMarker_PM_getInstance()) ? 12 : 0) | 0;
        }
        tmp_1 = tmp_2;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_0;
    var tmp_3;
    if (tmp3_elvis_lhs == null) {
      throw DateTimeFormatException_init_$Create$_0('Incomplete time: missing hour');
    } else {
      tmp_3 = tmp3_elvis_lhs;
    }
    var hour = tmp_3;
    var tmp_4 = requireParsedField(this.tn9_1, 'minute');
    var tmp4_elvis_lhs = this.un9_1;
    var tmp_5 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
    var tmp5_elvis_lhs = this.vn9_1;
    return LocalTime_init_$Create$(hour, tmp_4, tmp_5, tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs);
  };
  protoOf(IncompleteLocalTime).zn9 = function (localTime) {
    this.qn9_1 = localTime.rna_1;
    this.rn9_1 = ((localTime.rna_1 + 11 | 0) % 12 | 0) + 1 | 0;
    this.sn9_1 = localTime.rna_1 >= 12 ? AmPmMarker_PM_getInstance() : AmPmMarker_AM_getInstance();
    this.tn9_1 = localTime.sna_1;
    this.un9_1 = localTime.tna_1;
    this.vn9_1 = localTime.una_1;
  };
  protoOf(IncompleteLocalTime).xbr = function () {
    return new IncompleteLocalTime(this.qn9_1, this.rn9_1, this.sn9_1, this.tn9_1, this.un9_1, this.vn9_1);
  };
  protoOf(IncompleteLocalTime).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    if (other instanceof IncompleteLocalTime) {
      tmp_4 = this.qn9_1 == other.qn9_1;
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = this.rn9_1 == other.rn9_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = equals(this.sn9_1, other.sn9_1);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.tn9_1 == other.tn9_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.un9_1 == other.un9_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.vn9_1 == other.vn9_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IncompleteLocalTime).hashCode = function () {
    var tmp0_elvis_lhs = this.qn9_1;
    var tmp = imul(tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs, 31);
    var tmp1_elvis_lhs = this.rn9_1;
    var tmp_0 = tmp + imul(tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs, 31) | 0;
    var tmp2_safe_receiver = this.sn9_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    var tmp_1 = tmp_0 + imul(tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs, 31) | 0;
    var tmp4_elvis_lhs = this.tn9_1;
    var tmp_2 = tmp_1 + imul(tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs, 31) | 0;
    var tmp5_elvis_lhs = this.un9_1;
    var tmp_3 = tmp_2 + imul(tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs, 31) | 0;
    var tmp6_elvis_lhs = this.vn9_1;
    return tmp_3 + (tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs) | 0;
  };
  protoOf(IncompleteLocalTime).toString = function () {
    var tmp0_elvis_lhs = this.qn9_1;
    var tmp = toString_0(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
    var tmp1_elvis_lhs = this.tn9_1;
    var tmp_0 = toString_0(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs);
    var tmp2_elvis_lhs = this.un9_1;
    var tmp_1 = toString_0(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
    var tmp3_safe_receiver = this.vn9_1;
    var tmp_2;
    if (tmp3_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.let' call
      var it = tmp3_safe_receiver.toString();
      tmp_2 = padStart(it, 9 - it.length | 0, _Char___init__impl__6a9atx(48));
    }
    var tmp4_elvis_lhs = tmp_2;
    return tmp + ':' + tmp_0 + ':' + tmp_1 + '.' + (tmp4_elvis_lhs == null ? '???' : tmp4_elvis_lhs);
  };
  var AmPmMarker_AM_instance;
  var AmPmMarker_PM_instance;
  var AmPmMarker_entriesInitialized;
  function AmPmMarker_initEntries() {
    if (AmPmMarker_entriesInitialized)
      return Unit_instance;
    AmPmMarker_entriesInitialized = true;
    AmPmMarker_AM_instance = new AmPmMarker('AM', 0);
    AmPmMarker_PM_instance = new AmPmMarker('PM', 1);
  }
  function AmPmMarker(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_12() {
  }
  protoOf(Companion_12).vna = function (block) {
    var builder = new Builder_1(new AppendableFormatStructure());
    block(builder);
    return new LocalTimeFormat(builder.g3d());
  };
  var Companion_instance_13;
  function Companion_getInstance_13() {
    return Companion_instance_13;
  }
  function Builder_1(actualBuilder) {
    this.wna_1 = actualBuilder;
  }
  protoOf(Builder_1).fn7 = function () {
    return this.wna_1;
  };
  protoOf(Builder_1).kn7 = function (structure) {
    this.wna_1.in7(structure);
  };
  protoOf(Builder_1).gn7 = function () {
    return new Builder_1(new AppendableFormatStructure());
  };
  function LocalTimeFormat(actualFormat) {
    AbstractDateTimeFormat.call(this);
    this.xna_1 = actualFormat;
  }
  protoOf(LocalTimeFormat).tn5 = function () {
    return this.xna_1;
  };
  protoOf(LocalTimeFormat).yna = function (value) {
    // Inline function 'kotlin.apply' call
    var this_0 = new IncompleteLocalTime();
    this_0.zn9(value);
    return this_0;
  };
  protoOf(LocalTimeFormat).un5 = function (value) {
    return this.yna(value instanceof LocalTime ? value : THROW_CCE());
  };
  protoOf(LocalTimeFormat).zna = function (intermediate) {
    return intermediate.wn9();
  };
  protoOf(LocalTimeFormat).vn5 = function (intermediate) {
    return this.zna(intermediate instanceof IncompleteLocalTime ? intermediate : THROW_CCE());
  };
  protoOf(LocalTimeFormat).wn5 = function () {
    return get_emptyIncompleteLocalTime();
  };
  function AbstractWithTimeBuilder() {
  }
  function HourDirective(padding) {
    var tmp = TimeFields_getInstance().anb_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.knb_1 = padding;
  }
  protoOf(HourDirective).equals = function (other) {
    var tmp;
    if (other instanceof HourDirective) {
      tmp = this.knb_1.equals(other.knb_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(HourDirective).hashCode = function () {
    return this.knb_1.hashCode();
  };
  function MinuteDirective(padding) {
    var tmp = TimeFields_getInstance().bnb_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.pnb_1 = padding;
  }
  protoOf(MinuteDirective).equals = function (other) {
    var tmp;
    if (other instanceof MinuteDirective) {
      tmp = this.pnb_1.equals(other.pnb_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(MinuteDirective).hashCode = function () {
    return this.pnb_1.hashCode();
  };
  function SecondDirective(padding) {
    var tmp = TimeFields_getInstance().cnb_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.unb_1 = padding;
  }
  protoOf(SecondDirective).equals = function (other) {
    var tmp;
    if (other instanceof SecondDirective) {
      tmp = this.unb_1.equals(other.unb_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SecondDirective).hashCode = function () {
    return this.unb_1.hashCode();
  };
  function Companion_13() {
    Companion_instance_14 = this;
    this.vnb_1 = listOf([0, 0, 0, 0, 0, 0, 0, 0, 0]);
    this.wnb_1 = listOf([2, 1, 0, 2, 1, 0, 2, 1, 0]);
  }
  var Companion_instance_14;
  function Companion_getInstance_14() {
    if (Companion_instance_14 == null)
      new Companion_13();
    return Companion_instance_14;
  }
  function FractionalSecondDirective(minDigits, maxDigits, zerosToAdd) {
    Companion_getInstance_14();
    zerosToAdd = zerosToAdd === VOID ? Companion_getInstance_14().vnb_1 : zerosToAdd;
    DecimalFractionFieldFormatDirective.call(this, TimeFields_getInstance().dnb_1, minDigits, maxDigits, zerosToAdd);
    this.bnc_1 = minDigits;
    this.cnc_1 = maxDigits;
  }
  protoOf(FractionalSecondDirective).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof FractionalSecondDirective) {
      tmp_0 = this.bnc_1 === other.bnc_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.cnc_1 === other.cnc_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(FractionalSecondDirective).hashCode = function () {
    return imul(31, this.bnc_1) + this.cnc_1 | 0;
  };
  function TimeFieldContainer$_get_hour_$ref_8ezbwm() {
    return constructCallableReference(function (p0) {
      return p0.hna();
    }, 1, 0, 404);
  }
  function TimeFieldContainer$_set_hour_$ref_l7vnde() {
    return constructCallableReference(function (p0, p1) {
      p0.gna(p1);
      return Unit_instance;
    }, 2, 0, 405);
  }
  function TimeFieldContainer$_get_minute_$ref_evb2i2() {
    return constructCallableReference(function (p0) {
      return p0.bna();
    }, 1, 0, 406);
  }
  function TimeFieldContainer$_set_minute_$ref_6xin6() {
    return constructCallableReference(function (p0, p1) {
      p0.ana(p1);
      return Unit_instance;
    }, 2, 0, 407);
  }
  function TimeFieldContainer$_get_second_$ref_t7tjxy() {
    return constructCallableReference(function (p0) {
      return p0.dna();
    }, 1, 0, 408);
  }
  function TimeFieldContainer$_set_second_$ref_qr1wvy() {
    return constructCallableReference(function (p0, p1) {
      p0.cna(p1);
      return Unit_instance;
    }, 2, 0, 409);
  }
  function TimeFieldContainer$_get_fractionOfSecond_$ref_u85by5() {
    return constructCallableReference(function (p0) {
      return p0.nna();
    }, 1, 0, 410);
  }
  function TimeFieldContainer$_set_fractionOfSecond_$ref_quw20n() {
    return constructCallableReference(function (p0, p1) {
      p0.mna(p1);
      return Unit_instance;
    }, 2, 0, 411);
  }
  function TimeFieldContainer$_get_amPm_$ref_u9tt1b() {
    return constructCallableReference(function (p0) {
      return p0.lna();
    }, 1, 0, 412);
  }
  function TimeFieldContainer$_set_amPm_$ref_hgxhkj() {
    return constructCallableReference(function (p0, p1) {
      p0.kna(p1);
      return Unit_instance;
    }, 2, 0, 413);
  }
  function TimeFieldContainer$_get_hourOfAmPm_$ref_okyxye() {
    return constructCallableReference(function (p0) {
      return p0.jna();
    }, 1, 0, 414);
  }
  function TimeFieldContainer$_set_hourOfAmPm_$ref_y4i32() {
    return constructCallableReference(function (p0, p1) {
      p0.ina(p1);
      return Unit_instance;
    }, 2, 0, 415);
  }
  function TimeFields() {
    TimeFields_instance = this;
    var tmp = this;
    var tmp_0 = KMutableProperty1;
    var tmp_1 = TimeFieldContainer$_get_hour_$ref_8ezbwm();
    tmp.anb_1 = new UnsignedFieldSpec(new PropertyAccessor(getPropertyCallableRef('hour', 1, tmp_0, tmp_1, TimeFieldContainer$_set_hour_$ref_l7vnde())), 0, 23);
    var tmp_2 = this;
    var tmp_3 = KMutableProperty1;
    var tmp_4 = TimeFieldContainer$_get_minute_$ref_evb2i2();
    tmp_2.bnb_1 = new UnsignedFieldSpec(new PropertyAccessor(getPropertyCallableRef('minute', 1, tmp_3, tmp_4, TimeFieldContainer$_set_minute_$ref_6xin6())), 0, 59);
    var tmp_5 = this;
    var tmp_6 = KMutableProperty1;
    var tmp_7 = TimeFieldContainer$_get_second_$ref_t7tjxy();
    tmp_5.cnb_1 = new UnsignedFieldSpec(new PropertyAccessor(getPropertyCallableRef('second', 1, tmp_6, tmp_7, TimeFieldContainer$_set_second_$ref_qr1wvy())), 0, 59, VOID, 0);
    var tmp_8 = this;
    var tmp_9 = KMutableProperty1;
    var tmp_10 = TimeFieldContainer$_get_fractionOfSecond_$ref_u85by5();
    tmp_8.dnb_1 = new GenericFieldSpec(new PropertyAccessor(getPropertyCallableRef('fractionOfSecond', 1, tmp_9, tmp_10, TimeFieldContainer$_set_fractionOfSecond_$ref_quw20n()), 'nanosecond'), VOID, new DecimalFraction(0, 9));
    var tmp_11 = this;
    var tmp_12 = KMutableProperty1;
    var tmp_13 = TimeFieldContainer$_get_amPm_$ref_u9tt1b();
    tmp_11.enb_1 = new GenericFieldSpec(new PropertyAccessor(getPropertyCallableRef('amPm', 1, tmp_12, tmp_13, TimeFieldContainer$_set_amPm_$ref_hgxhkj())));
    var tmp_14 = this;
    var tmp_15 = KMutableProperty1;
    var tmp_16 = TimeFieldContainer$_get_hourOfAmPm_$ref_okyxye();
    tmp_14.fnb_1 = new UnsignedFieldSpec(new PropertyAccessor(getPropertyCallableRef('hourOfAmPm', 1, tmp_15, tmp_16, TimeFieldContainer$_set_hourOfAmPm_$ref_y4i32())), 1, 12);
  }
  var TimeFields_instance;
  function TimeFields_getInstance() {
    if (TimeFields_instance == null)
      new TimeFields();
    return TimeFields_instance;
  }
  function ISO_TIME$delegate$lambda() {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    var tmp = Companion_instance_13;
    return tmp.vna(ISO_TIME$delegate$lambda$lambda);
  }
  function ISO_TIME$delegate$lambda$lambda($this$build) {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    $this$build.on6();
    char($this$build, _Char___init__impl__6a9atx(58));
    $this$build.qn6();
    var tmp = [ISO_TIME$delegate$lambda$lambda$lambda];
    alternativeParsing($this$build, tmp, ISO_TIME$delegate$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function ISO_TIME$delegate$lambda$lambda$lambda($this$alternativeParsing) {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    return Unit_instance;
  }
  function ISO_TIME$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    char($this$alternativeParsing, _Char___init__impl__6a9atx(58));
    $this$alternativeParsing.sn6();
    optional($this$alternativeParsing, VOID, ISO_TIME$delegate$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_TIME$delegate$lambda$lambda$lambda$lambda($this$optional) {
    _init_properties_LocalTimeFormat_kt__5i3lfh();
    char($this$optional, _Char___init__impl__6a9atx(46));
    $this$optional.tn6(1, 9);
    return Unit_instance;
  }
  function _get_ISO_TIME_$ref_kyx2od() {
    return constructCallableReference(function () {
      return get_ISO_TIME();
    }, 0, 0, 416);
  }
  function AmPmMarker_AM_getInstance() {
    AmPmMarker_initEntries();
    return AmPmMarker_AM_instance;
  }
  function AmPmMarker_PM_getInstance() {
    AmPmMarker_initEntries();
    return AmPmMarker_PM_instance;
  }
  var properties_initialized_LocalTimeFormat_kt_l1b0w1;
  function _init_properties_LocalTimeFormat_kt__5i3lfh() {
    if (!properties_initialized_LocalTimeFormat_kt_l1b0w1) {
      properties_initialized_LocalTimeFormat_kt_l1b0w1 = true;
      ISO_TIME$delegate = lazy(ISO_TIME$delegate$lambda);
      emptyIncompleteLocalTime = new IncompleteLocalTime();
    }
  }
  function get_nonPlainCharacters() {
    _init_properties_Unicode_kt__5cnwob();
    return nonPlainCharacters;
  }
  var nonPlainCharacters;
  function byUnicodePattern(_this__u8e3s4, pattern) {
    _init_properties_Unicode_kt__5cnwob();
    var directives = Companion_instance_15.jr(pattern);
    byUnicodePattern$rec(_this__u8e3s4, directives);
  }
  function Era(formatLength) {
    YearMonthBased.call(this);
    this.hnc_1 = formatLength;
    this.inc_1 = _Char___init__impl__6a9atx(71);
  }
  protoOf(Era).jnc = function () {
    return this.hnc_1;
  };
  protoOf(Era).knc = function () {
    return this.inc_1;
  };
  protoOf(Era).lnc = function (builder) {
    localizedDirective(this);
  };
  protoOf(Era).mnc = function (builder) {
    return this.lnc(builder);
  };
  function Year(formatLength) {
    YearMonthBased.call(this);
    this.onc_1 = formatLength;
    this.pnc_1 = _Char___init__impl__6a9atx(117);
  }
  protoOf(Year).jnc = function () {
    return this.onc_1;
  };
  protoOf(Year).knc = function () {
    return this.pnc_1;
  };
  protoOf(Year).mnc = function (builder) {
    switch (this.onc_1) {
      case 1:
        builder.dn6(Padding_NONE_getInstance());
        break;
      case 2:
        builder.fn6(2000);
        break;
      case 3:
        unsupportedPadding(this, this.onc_1);
        break;
      case 4:
        builder.dn6(Padding_ZERO_getInstance());
        break;
      default:
        unsupportedPadding(this, this.onc_1);
        break;
    }
  };
  function YearOfEra(formatLength) {
    YearMonthBased.call(this);
    this.qnc_1 = formatLength;
    this.rnc_1 = _Char___init__impl__6a9atx(121);
  }
  protoOf(YearOfEra).jnc = function () {
    return this.qnc_1;
  };
  protoOf(YearOfEra).knc = function () {
    return this.rnc_1;
  };
  protoOf(YearOfEra).mnc = function (builder) {
    var tmp;
    switch (this.qnc_1) {
      case 1:
        yearOfEra(builder, Padding_NONE_getInstance());
        tmp = Unit_instance;
        break;
      case 2:
        yearOfEraTwoDigits(builder, 2000);
        tmp = Unit_instance;
        break;
      case 3:
        unsupportedPadding(this, this.qnc_1);
        break;
      case 4:
        yearOfEra(builder, Padding_ZERO_getInstance());
        tmp = Unit_instance;
        break;
      default:
        unsupportedPadding(this, this.qnc_1);
        break;
    }
    return tmp;
  };
  function CyclicYearName(formatLength) {
    YearMonthBased.call(this);
    this.snc_1 = formatLength;
    this.tnc_1 = _Char___init__impl__6a9atx(85);
  }
  protoOf(CyclicYearName).jnc = function () {
    return this.snc_1;
  };
  protoOf(CyclicYearName).knc = function () {
    return this.tnc_1;
  };
  protoOf(CyclicYearName).lnc = function (builder) {
    unsupportedDirective('cyclic-year');
  };
  protoOf(CyclicYearName).mnc = function (builder) {
    return this.lnc(builder);
  };
  function RelatedGregorianYear(formatLength) {
    YearMonthBased.call(this);
    this.unc_1 = formatLength;
    this.vnc_1 = _Char___init__impl__6a9atx(114);
  }
  protoOf(RelatedGregorianYear).jnc = function () {
    return this.unc_1;
  };
  protoOf(RelatedGregorianYear).knc = function () {
    return this.vnc_1;
  };
  protoOf(RelatedGregorianYear).lnc = function (builder) {
    unsupportedDirective('related-gregorian-year');
  };
  protoOf(RelatedGregorianYear).mnc = function (builder) {
    return this.lnc(builder);
  };
  function MonthOfYear(formatLength) {
    YearMonthBased.call(this);
    this.wnc_1 = formatLength;
    this.xnc_1 = _Char___init__impl__6a9atx(77);
  }
  protoOf(MonthOfYear).jnc = function () {
    return this.wnc_1;
  };
  protoOf(MonthOfYear).knc = function () {
    return this.xnc_1;
  };
  protoOf(MonthOfYear).mnc = function (builder) {
    switch (this.wnc_1) {
      case 1:
        builder.gn6(Padding_NONE_getInstance());
        break;
      case 2:
        builder.gn6(Padding_ZERO_getInstance());
        break;
      case 3:
      case 4:
      case 5:
        localizedDirective(this);
        break;
      default:
        unknownLength(this);
        break;
    }
  };
  function StandaloneMonthOfYear(formatLength) {
    YearMonthBased.call(this);
    this.ync_1 = formatLength;
    this.znc_1 = _Char___init__impl__6a9atx(76);
  }
  protoOf(StandaloneMonthOfYear).jnc = function () {
    return this.ync_1;
  };
  protoOf(StandaloneMonthOfYear).knc = function () {
    return this.znc_1;
  };
  protoOf(StandaloneMonthOfYear).mnc = function (builder) {
    switch (this.ync_1) {
      case 1:
        builder.gn6(Padding_NONE_getInstance());
        break;
      case 2:
        builder.gn6(Padding_ZERO_getInstance());
        break;
      case 3:
      case 4:
      case 5:
        localizedDirective(this);
        break;
      default:
        unknownLength(this);
        break;
    }
  };
  function QuarterOfYear(formatLength) {
    YearMonthBased.call(this);
    this.and_1 = formatLength;
    this.bnd_1 = _Char___init__impl__6a9atx(81);
  }
  protoOf(QuarterOfYear).jnc = function () {
    return this.and_1;
  };
  protoOf(QuarterOfYear).knc = function () {
    return this.bnd_1;
  };
  protoOf(QuarterOfYear).mnc = function (builder) {
    switch (this.and_1) {
      case 1:
      case 2:
        unsupportedDirective('quarter-of-year');
        break;
      case 3:
      case 4:
      case 5:
        localizedDirective(this);
        break;
      default:
        unknownLength(this);
        break;
    }
  };
  function StandaloneQuarterOfYear(formatLength) {
    YearMonthBased.call(this);
    this.cnd_1 = formatLength;
    this.dnd_1 = _Char___init__impl__6a9atx(113);
  }
  protoOf(StandaloneQuarterOfYear).jnc = function () {
    return this.cnd_1;
  };
  protoOf(StandaloneQuarterOfYear).knc = function () {
    return this.dnd_1;
  };
  protoOf(StandaloneQuarterOfYear).mnc = function (builder) {
    switch (this.cnd_1) {
      case 1:
      case 2:
        unsupportedDirective('standalone-quarter-of-year');
        break;
      case 3:
      case 4:
      case 5:
        localizedDirective(this);
        break;
      default:
        unknownLength(this);
        break;
    }
  };
  function DayOfYear(formatLength) {
    DateBased_0.call(this);
    this.end_1 = formatLength;
    this.fnd_1 = _Char___init__impl__6a9atx(68);
  }
  protoOf(DayOfYear).jnc = function () {
    return this.end_1;
  };
  protoOf(DayOfYear).knc = function () {
    return this.fnd_1;
  };
  protoOf(DayOfYear).nnc = function (builder) {
    switch (this.end_1) {
      case 1:
        builder.ln6(Padding_NONE_getInstance());
        break;
      case 3:
        builder.ln6(Padding_ZERO_getInstance());
        break;
      default:
        unknownLength(this);
        break;
    }
  };
  function DayOfMonth(formatLength) {
    DateBased_0.call(this);
    this.gnd_1 = formatLength;
    this.hnd_1 = _Char___init__impl__6a9atx(100);
  }
  protoOf(DayOfMonth).jnc = function () {
    return this.gnd_1;
  };
  protoOf(DayOfMonth).knc = function () {
    return this.hnd_1;
  };
  protoOf(DayOfMonth).nnc = function (builder) {
    var tmp;
    switch (this.gnd_1) {
      case 1:
        builder.jn6(Padding_NONE_getInstance());
        tmp = Unit_instance;
        break;
      case 2:
        builder.jn6(Padding_ZERO_getInstance());
        tmp = Unit_instance;
        break;
      default:
        unknownLength(this);
        break;
    }
    return tmp;
  };
  function ModifiedJulianDay(formatLength) {
    DateBased_0.call(this);
    this.ind_1 = formatLength;
    this.jnd_1 = _Char___init__impl__6a9atx(103);
  }
  protoOf(ModifiedJulianDay).jnc = function () {
    return this.ind_1;
  };
  protoOf(ModifiedJulianDay).knc = function () {
    return this.jnd_1;
  };
  protoOf(ModifiedJulianDay).knd = function (builder) {
    unsupportedDirective('modified-julian-day');
  };
  protoOf(ModifiedJulianDay).nnc = function (builder) {
    return this.knd(builder);
  };
  function WeekBasedYear(formatLength) {
    DateBased_0.call(this);
    this.lnd_1 = formatLength;
    this.mnd_1 = _Char___init__impl__6a9atx(89);
  }
  protoOf(WeekBasedYear).jnc = function () {
    return this.lnd_1;
  };
  protoOf(WeekBasedYear).knc = function () {
    return this.mnd_1;
  };
  protoOf(WeekBasedYear).knd = function (builder) {
    unsupportedDirective('week-based-year');
  };
  protoOf(WeekBasedYear).nnc = function (builder) {
    return this.knd(builder);
  };
  function WeekOfWeekBasedYear(formatLength) {
    DateBased_0.call(this);
    this.nnd_1 = formatLength;
    this.ond_1 = _Char___init__impl__6a9atx(119);
  }
  protoOf(WeekOfWeekBasedYear).jnc = function () {
    return this.nnd_1;
  };
  protoOf(WeekOfWeekBasedYear).knc = function () {
    return this.ond_1;
  };
  protoOf(WeekOfWeekBasedYear).knd = function (builder) {
    unsupportedDirective('week-of-week-based-year');
  };
  protoOf(WeekOfWeekBasedYear).nnc = function (builder) {
    return this.knd(builder);
  };
  function WeekOfMonth(formatLength) {
    DateBased_0.call(this);
    this.pnd_1 = formatLength;
    this.qnd_1 = _Char___init__impl__6a9atx(87);
  }
  protoOf(WeekOfMonth).jnc = function () {
    return this.pnd_1;
  };
  protoOf(WeekOfMonth).knc = function () {
    return this.qnd_1;
  };
  protoOf(WeekOfMonth).knd = function (builder) {
    unsupportedDirective('week-of-month');
  };
  protoOf(WeekOfMonth).nnc = function (builder) {
    return this.knd(builder);
  };
  function DayOfWeek_1(formatLength) {
    DateBased_0.call(this);
    this.rnd_1 = formatLength;
    this.snd_1 = _Char___init__impl__6a9atx(69);
  }
  protoOf(DayOfWeek_1).jnc = function () {
    return this.rnd_1;
  };
  protoOf(DayOfWeek_1).knc = function () {
    return this.snd_1;
  };
  protoOf(DayOfWeek_1).knd = function (builder) {
    localizedDirective(this);
  };
  protoOf(DayOfWeek_1).nnc = function (builder) {
    return this.knd(builder);
  };
  function LocalizedDayOfWeek(formatLength) {
    DateBased_0.call(this);
    this.tnd_1 = formatLength;
    this.und_1 = _Char___init__impl__6a9atx(101);
  }
  protoOf(LocalizedDayOfWeek).jnc = function () {
    return this.tnd_1;
  };
  protoOf(LocalizedDayOfWeek).knc = function () {
    return this.und_1;
  };
  protoOf(LocalizedDayOfWeek).knd = function (builder) {
    localizedDirective(this);
  };
  protoOf(LocalizedDayOfWeek).nnc = function (builder) {
    return this.knd(builder);
  };
  function StandaloneLocalizedDayOfWeek(formatLength) {
    DateBased_0.call(this);
    this.vnd_1 = formatLength;
    this.wnd_1 = _Char___init__impl__6a9atx(99);
  }
  protoOf(StandaloneLocalizedDayOfWeek).jnc = function () {
    return this.vnd_1;
  };
  protoOf(StandaloneLocalizedDayOfWeek).knc = function () {
    return this.wnd_1;
  };
  protoOf(StandaloneLocalizedDayOfWeek).knd = function (builder) {
    localizedDirective(this);
  };
  protoOf(StandaloneLocalizedDayOfWeek).nnc = function (builder) {
    return this.knd(builder);
  };
  function DayOfWeekInMonth(formatLength) {
    DateBased_0.call(this);
    this.xnd_1 = formatLength;
    this.ynd_1 = _Char___init__impl__6a9atx(70);
  }
  protoOf(DayOfWeekInMonth).jnc = function () {
    return this.xnd_1;
  };
  protoOf(DayOfWeekInMonth).knc = function () {
    return this.ynd_1;
  };
  protoOf(DayOfWeekInMonth).knd = function (builder) {
    unsupportedDirective('day-of-week-in-month');
  };
  protoOf(DayOfWeekInMonth).nnc = function (builder) {
    return this.knd(builder);
  };
  function SecondOfMinute(formatLength) {
    WithSecondPrecision.call(this);
    this.znd_1 = formatLength;
    this.ane_1 = _Char___init__impl__6a9atx(115);
  }
  protoOf(SecondOfMinute).jnc = function () {
    return this.znd_1;
  };
  protoOf(SecondOfMinute).knc = function () {
    return this.ane_1;
  };
  protoOf(SecondOfMinute).bne = function (builder) {
    var tmp;
    switch (this.znd_1) {
      case 1:
        builder.rn6(Padding_NONE_getInstance());
        tmp = Unit_instance;
        break;
      case 2:
        builder.rn6(Padding_ZERO_getInstance());
        tmp = Unit_instance;
        break;
      default:
        unknownLength(this);
        break;
    }
    return tmp;
  };
  function FractionOfSecond(formatLength) {
    WithSubsecondPrecision.call(this);
    this.cne_1 = formatLength;
    this.dne_1 = _Char___init__impl__6a9atx(83);
  }
  protoOf(FractionOfSecond).jnc = function () {
    return this.cne_1;
  };
  protoOf(FractionOfSecond).knc = function () {
    return this.dne_1;
  };
  protoOf(FractionOfSecond).bne = function (builder) {
    return builder.un6(this.cne_1);
  };
  function MilliOfDay(formatLength) {
    WithSubsecondPrecision.call(this);
    this.ene_1 = formatLength;
    this.fne_1 = _Char___init__impl__6a9atx(65);
  }
  protoOf(MilliOfDay).jnc = function () {
    return this.ene_1;
  };
  protoOf(MilliOfDay).knc = function () {
    return this.fne_1;
  };
  protoOf(MilliOfDay).gne = function (builder) {
    unsupportedDirective('millisecond-of-day');
  };
  protoOf(MilliOfDay).bne = function (builder) {
    return this.gne(builder);
  };
  function NanoOfSecond(formatLength) {
    WithSubsecondPrecision.call(this);
    this.hne_1 = formatLength;
    this.ine_1 = _Char___init__impl__6a9atx(110);
  }
  protoOf(NanoOfSecond).jnc = function () {
    return this.hne_1;
  };
  protoOf(NanoOfSecond).knc = function () {
    return this.ine_1;
  };
  protoOf(NanoOfSecond).gne = function (builder) {
    unsupportedDirective('nano-of-second', "Maybe you meant 'S' instead of 'n'?");
  };
  protoOf(NanoOfSecond).bne = function (builder) {
    return this.gne(builder);
  };
  function NanoOfDay(formatLength) {
    WithSubsecondPrecision.call(this);
    this.jne_1 = formatLength;
    this.kne_1 = _Char___init__impl__6a9atx(78);
  }
  protoOf(NanoOfDay).jnc = function () {
    return this.jne_1;
  };
  protoOf(NanoOfDay).knc = function () {
    return this.kne_1;
  };
  protoOf(NanoOfDay).gne = function (builder) {
    unsupportedDirective('nanosecond-of-day');
  };
  protoOf(NanoOfDay).bne = function (builder) {
    return this.gne(builder);
  };
  function AmPmMarker_0(formatLength) {
    TimeBased_0.call(this);
    this.lne_1 = formatLength;
    this.mne_1 = _Char___init__impl__6a9atx(97);
  }
  protoOf(AmPmMarker_0).jnc = function () {
    return this.lne_1;
  };
  protoOf(AmPmMarker_0).knc = function () {
    return this.mne_1;
  };
  protoOf(AmPmMarker_0).gne = function (builder) {
    localizedDirective(this);
  };
  protoOf(AmPmMarker_0).bne = function (builder) {
    return this.gne(builder);
  };
  function AmPmHourOfDay(formatLength) {
    TimeBased_0.call(this);
    this.nne_1 = formatLength;
    this.one_1 = _Char___init__impl__6a9atx(104);
  }
  protoOf(AmPmHourOfDay).jnc = function () {
    return this.nne_1;
  };
  protoOf(AmPmHourOfDay).knc = function () {
    return this.one_1;
  };
  protoOf(AmPmHourOfDay).gne = function (builder) {
    localizedDirective(this);
  };
  protoOf(AmPmHourOfDay).bne = function (builder) {
    return this.gne(builder);
  };
  function HourOfDay(formatLength) {
    TimeBased_0.call(this);
    this.pne_1 = formatLength;
    this.qne_1 = _Char___init__impl__6a9atx(72);
  }
  protoOf(HourOfDay).jnc = function () {
    return this.pne_1;
  };
  protoOf(HourOfDay).knc = function () {
    return this.qne_1;
  };
  protoOf(HourOfDay).bne = function (builder) {
    var tmp;
    switch (this.pne_1) {
      case 1:
        builder.nn6(Padding_NONE_getInstance());
        tmp = Unit_instance;
        break;
      case 2:
        builder.nn6(Padding_ZERO_getInstance());
        tmp = Unit_instance;
        break;
      default:
        unknownLength(this);
        break;
    }
    return tmp;
  };
  function MinuteOfHour(formatLength) {
    TimeBased_0.call(this);
    this.rne_1 = formatLength;
    this.sne_1 = _Char___init__impl__6a9atx(109);
  }
  protoOf(MinuteOfHour).jnc = function () {
    return this.rne_1;
  };
  protoOf(MinuteOfHour).knc = function () {
    return this.sne_1;
  };
  protoOf(MinuteOfHour).bne = function (builder) {
    var tmp;
    switch (this.rne_1) {
      case 1:
        builder.pn6(Padding_NONE_getInstance());
        tmp = Unit_instance;
        break;
      case 2:
        builder.pn6(Padding_ZERO_getInstance());
        tmp = Unit_instance;
        break;
      default:
        unknownLength(this);
        break;
    }
    return tmp;
  };
  function WithSecondPrecision() {
    TimeBased_0.call(this);
  }
  function WithSubsecondPrecision() {
    WithSecondPrecision.call(this);
  }
  function TimeZoneId(formatLength) {
    ZoneBased.call(this);
    this.tne_1 = formatLength;
    this.une_1 = _Char___init__impl__6a9atx(86);
  }
  protoOf(TimeZoneId).jnc = function () {
    return this.tne_1;
  };
  protoOf(TimeZoneId).knc = function () {
    return this.une_1;
  };
  protoOf(TimeZoneId).vne = function (builder) {
    var tmp;
    if (this.tne_1 === 2) {
      builder.cn7();
      tmp = Unit_instance;
    } else {
      unknownLength(this);
    }
    return tmp;
  };
  function GenericTimeZoneName(formatLength) {
    ZoneBased.call(this);
    this.wne_1 = formatLength;
    this.xne_1 = _Char___init__impl__6a9atx(118);
  }
  protoOf(GenericTimeZoneName).jnc = function () {
    return this.wne_1;
  };
  protoOf(GenericTimeZoneName).knc = function () {
    return this.xne_1;
  };
  protoOf(GenericTimeZoneName).yne = function (builder) {
    localizedDirective(this);
  };
  protoOf(GenericTimeZoneName).vne = function (builder) {
    return this.yne(builder);
  };
  function TimeZoneName(formatLength) {
    ZoneBased.call(this);
    this.zne_1 = formatLength;
    this.anf_1 = _Char___init__impl__6a9atx(122);
  }
  protoOf(TimeZoneName).jnc = function () {
    return this.zne_1;
  };
  protoOf(TimeZoneName).knc = function () {
    return this.anf_1;
  };
  protoOf(TimeZoneName).yne = function (builder) {
    localizedDirective(this, "Format 'V' can be used to format time zone IDs in a locale-invariant manner.");
  };
  protoOf(TimeZoneName).vne = function (builder) {
    return this.yne(builder);
  };
  function LocalizedZoneOffset(formatLength) {
    OffsetBased.call(this);
    this.bnf_1 = formatLength;
    this.cnf_1 = _Char___init__impl__6a9atx(79);
  }
  protoOf(LocalizedZoneOffset).jnc = function () {
    return this.bnf_1;
  };
  protoOf(LocalizedZoneOffset).knc = function () {
    return this.cnf_1;
  };
  protoOf(LocalizedZoneOffset).dnf = function (builder) {
    localizedDirective(this);
  };
  protoOf(LocalizedZoneOffset).enf = function (builder) {
    return this.dnf(builder);
  };
  protoOf(LocalizedZoneOffset).fnf = function () {
    localizedDirective(this);
  };
  protoOf(LocalizedZoneOffset).gnf = function () {
    localizedDirective(this);
  };
  function ZoneOffset1(formatLength) {
    OffsetBased.call(this);
    this.hnf_1 = formatLength;
    this.inf_1 = _Char___init__impl__6a9atx(88);
  }
  protoOf(ZoneOffset1).jnc = function () {
    return this.hnf_1;
  };
  protoOf(ZoneOffset1).knc = function () {
    return this.inf_1;
  };
  protoOf(ZoneOffset1).enf = function (builder) {
    switch (this.hnf_1) {
      case 1:
        this.jnf(builder, true, false);
        break;
      case 2:
        this.jnf(builder, true, false);
        break;
      case 3:
        this.jnf(builder, true, true);
        break;
      case 4:
        this.jnf(builder, true, false);
        break;
      case 5:
        this.jnf(builder, true, true);
        break;
      default:
        unknownLength(this);
        break;
    }
  };
  protoOf(ZoneOffset1).fnf = function () {
    return this.hnf_1 === 1 ? WhenToOutput_IF_NONZERO_getInstance() : WhenToOutput_ALWAYS_getInstance();
  };
  protoOf(ZoneOffset1).gnf = function () {
    return this.hnf_1 <= 3 ? WhenToOutput_NEVER_getInstance() : WhenToOutput_IF_NONZERO_getInstance();
  };
  function ZoneOffset2(formatLength) {
    OffsetBased.call(this);
    this.knf_1 = formatLength;
    this.lnf_1 = _Char___init__impl__6a9atx(120);
  }
  protoOf(ZoneOffset2).jnc = function () {
    return this.knf_1;
  };
  protoOf(ZoneOffset2).knc = function () {
    return this.lnf_1;
  };
  protoOf(ZoneOffset2).enf = function (builder) {
    switch (this.knf_1) {
      case 1:
        this.jnf(builder, false, false);
        break;
      case 2:
        this.jnf(builder, false, false);
        break;
      case 3:
        this.jnf(builder, false, true);
        break;
      case 4:
        this.jnf(builder, false, false);
        break;
      case 5:
        this.jnf(builder, false, true);
        break;
      default:
        unknownLength(this);
        break;
    }
  };
  protoOf(ZoneOffset2).fnf = function () {
    return this.knf_1 === 1 ? WhenToOutput_IF_NONZERO_getInstance() : WhenToOutput_ALWAYS_getInstance();
  };
  protoOf(ZoneOffset2).gnf = function () {
    return this.knf_1 <= 3 ? WhenToOutput_NEVER_getInstance() : WhenToOutput_IF_NONZERO_getInstance();
  };
  function ZoneOffset3(formatLength) {
    OffsetBased.call(this);
    this.mnf_1 = formatLength;
    this.nnf_1 = _Char___init__impl__6a9atx(90);
  }
  protoOf(ZoneOffset3).jnc = function () {
    return this.mnf_1;
  };
  protoOf(ZoneOffset3).knc = function () {
    return this.nnf_1;
  };
  protoOf(ZoneOffset3).enf = function (builder) {
    switch (this.mnf_1) {
      case 1:
      case 2:
      case 3:
        this.jnf(builder, false, false);
        break;
      case 4:
        (new LocalizedZoneOffset(4)).dnf(builder);
        break;
      case 5:
        this.jnf(builder, false, true);
        break;
      default:
        unknownLength(this);
        break;
    }
  };
  protoOf(ZoneOffset3).fnf = function () {
    return WhenToOutput_ALWAYS_getInstance();
  };
  protoOf(ZoneOffset3).gnf = function () {
    return this.mnf_1 <= 3 ? WhenToOutput_NEVER_getInstance() : WhenToOutput_IF_NONZERO_getInstance();
  };
  function YearMonthBased() {
    DateBased_0.call(this);
  }
  protoOf(YearMonthBased).nnc = function (builder) {
    var downcastBuilder = builder;
    this.mnc(downcastBuilder);
  };
  function DateBased_0() {
    Directive.call(this);
  }
  function TimeBased_0() {
    Directive.call(this);
  }
  function ZoneBased() {
    Directive.call(this);
  }
  function OffsetBased() {
    Directive.call(this);
  }
  protoOf(OffsetBased).jnf = function (_this__u8e3s4, zOnZero, useSeparator) {
    isoOffset(_this__u8e3s4, zOnZero, useSeparator, this.fnf(), this.gnf());
  };
  function Companion_14() {
  }
  protoOf(Companion_14).jr = function (pattern) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tmp$ret$0 = ArrayList_init_$Create$_0();
    var groups = mutableListOf([tmp$ret$0]);
    var insideLiteral = false;
    var literal = '';
    var lastCharacter = null;
    var lastCharacterCount = 0;
    var inductionVariable = 0;
    var last_0 = pattern.length;
    $l$loop: while (inductionVariable < last_0) {
      var character = charCodeAt(pattern, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = lastCharacter;
      if (equals(new Char(character), tmp == null ? null : new Char(tmp))) {
        lastCharacterCount = lastCharacterCount + 1 | 0;
      } else {
        if (insideLiteral) {
          if (character === _Char___init__impl__6a9atx(39)) {
            var tmp0_safe_receiver = last(groups);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.text.ifEmpty' call
              var this_0 = literal;
              var tmp_0;
              // Inline function 'kotlin.text.isEmpty' call
              if (charSequenceLength(this_0) === 0) {
                tmp_0 = "'";
              } else {
                tmp_0 = this_0;
              }
              var tmp$ret$1 = tmp_0;
              tmp0_safe_receiver.j1(new StringLiteral(tmp$ret$1));
            }
            insideLiteral = false;
            literal = '';
          } else
            literal = literal + toString(character);
        } else {
          if (lastCharacterCount > 0) {
            var tmp1_safe_receiver = last(groups);
            if (tmp1_safe_receiver == null)
              null;
            else {
              var tmp_1 = lastCharacter;
              tmp1_safe_receiver.j1(unicodeDirective(ensureNotNull(tmp_1 == null ? null : new Char(tmp_1)).f2_1, lastCharacterCount));
            }
            lastCharacter = null;
            lastCharacterCount = 0;
          }
          if (!get_nonPlainCharacters().m1(new Char(character))) {
            literal = literal + toString(character);
            continue $l$loop;
          }
          if (!(literal === '')) {
            var tmp2_safe_receiver = last(groups);
            if (tmp2_safe_receiver == null)
              null;
            else
              tmp2_safe_receiver.j1(new StringLiteral(literal));
            literal = '';
          }
          if (character === _Char___init__impl__6a9atx(39)) {
            insideLiteral = true;
            literal = '';
          } else if (character === _Char___init__impl__6a9atx(91)) {
            // Inline function 'kotlin.collections.mutableListOf' call
            var tmp$ret$4 = ArrayList_init_$Create$_0();
            groups.j1(tmp$ret$4);
          } else if (character === _Char___init__impl__6a9atx(93)) {
            var tmp4_elvis_lhs = removeLast(groups);
            var tmp_2;
            if (tmp4_elvis_lhs == null) {
              throw IllegalArgumentException_init_$Create$('Unmatched closing bracket');
            } else {
              tmp_2 = tmp4_elvis_lhs;
            }
            var group = tmp_2;
            var tmp5_safe_receiver = last(groups);
            if (tmp5_safe_receiver == null)
              null;
            else
              tmp5_safe_receiver.j1(new OptionalGroup(new Sequence(group)));
          } else {
            lastCharacter = character;
            lastCharacterCount = 1;
          }
        }
      }
    }
    if (lastCharacterCount > 0) {
      var tmp6_safe_receiver = last(groups);
      if (tmp6_safe_receiver == null)
        null;
      else {
        var tmp_3 = lastCharacter;
        tmp6_safe_receiver.j1(unicodeDirective(ensureNotNull(tmp_3 == null ? null : new Char(tmp_3)).f2_1, lastCharacterCount));
      }
    }
    if (!(literal === '')) {
      var tmp7_safe_receiver = last(groups);
      if (tmp7_safe_receiver == null)
        null;
      else
        tmp7_safe_receiver.j1(new StringLiteral(literal));
    }
    var tmp8_elvis_lhs = removeLast(groups);
    var tmp_4;
    if (tmp8_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('Unmatched opening bracket');
    } else {
      tmp_4 = tmp8_elvis_lhs;
    }
    return new Sequence(tmp_4);
  };
  var Companion_instance_15;
  function Companion_getInstance_15() {
    return Companion_instance_15;
  }
  function OptionalGroup(format) {
    this.onf_1 = format;
  }
  protoOf(OptionalGroup).toString = function () {
    return '[' + toString_0(this.onf_1) + ']';
  };
  protoOf(OptionalGroup).hashCode = function () {
    return hashCode(this.onf_1);
  };
  protoOf(OptionalGroup).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OptionalGroup))
      return false;
    var tmp0_other_with_cast = other instanceof OptionalGroup ? other : THROW_CCE();
    if (!equals(this.onf_1, tmp0_other_with_cast.onf_1))
      return false;
    return true;
  };
  function Sequence(formats) {
    this.pnf_1 = formats;
  }
  protoOf(Sequence).toString = function () {
    return joinToString(this.pnf_1, '');
  };
  protoOf(Sequence).hashCode = function () {
    return hashCode(this.pnf_1);
  };
  protoOf(Sequence).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Sequence))
      return false;
    var tmp0_other_with_cast = other instanceof Sequence ? other : THROW_CCE();
    if (!equals(this.pnf_1, tmp0_other_with_cast.pnf_1))
      return false;
    return true;
  };
  function StringLiteral(literal) {
    this.qnf_1 = literal;
  }
  protoOf(StringLiteral).toString = function () {
    var tmp;
    if (this.qnf_1 === "'") {
      tmp = "''";
    } else {
      var tmp0 = this.qnf_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.text.any' call
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(tmp0)) {
          var element = charSequenceGet(tmp0, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          if (isLetter(element)) {
            tmp$ret$0 = true;
            break $l$block;
          }
        }
        tmp$ret$0 = false;
      }
      if (tmp$ret$0) {
        tmp = "'" + this.qnf_1 + "'";
      } else {
        // Inline function 'kotlin.text.ifEmpty' call
        var this_0 = this.qnf_1;
        var tmp_0;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(this_0) === 0) {
          tmp_0 = '';
        } else {
          tmp_0 = this_0;
        }
        tmp = tmp_0;
      }
    }
    return tmp;
  };
  protoOf(StringLiteral).hashCode = function () {
    return getStringHashCode(this.qnf_1);
  };
  protoOf(StringLiteral).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StringLiteral))
      return false;
    var tmp0_other_with_cast = other instanceof StringLiteral ? other : THROW_CCE();
    if (!(this.qnf_1 === tmp0_other_with_cast.qnf_1))
      return false;
    return true;
  };
  function Directive() {
  }
  protoOf(Directive).toString = function () {
    return repeat(toString(this.knc()), this.jnc());
  };
  protoOf(Directive).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof Directive) {
      tmp_0 = this.knc() === other.knc();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.jnc() === other.jnc();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Directive).hashCode = function () {
    return imul(Char__hashCode_impl_otmys(this.knc()), 31) + this.jnc() | 0;
  };
  function UnknownUnicodeDirective(formatLetter, formatLength) {
    Directive.call(this);
    this.rnf_1 = formatLetter;
    this.snf_1 = formatLength;
  }
  protoOf(UnknownUnicodeDirective).knc = function () {
    return this.rnf_1;
  };
  protoOf(UnknownUnicodeDirective).jnc = function () {
    return this.snf_1;
  };
  function unicodeDirective(char, formatLength) {
    _init_properties_Unicode_kt__5cnwob();
    return char === _Char___init__impl__6a9atx(71) ? new Era(formatLength) : char === _Char___init__impl__6a9atx(121) ? new YearOfEra(formatLength) : char === _Char___init__impl__6a9atx(117) ? new Year(formatLength) : char === _Char___init__impl__6a9atx(85) ? new CyclicYearName(formatLength) : char === _Char___init__impl__6a9atx(114) ? new RelatedGregorianYear(formatLength) : char === _Char___init__impl__6a9atx(81) ? new QuarterOfYear(formatLength) : char === _Char___init__impl__6a9atx(113) ? new StandaloneQuarterOfYear(formatLength) : char === _Char___init__impl__6a9atx(77) ? new MonthOfYear(formatLength) : char === _Char___init__impl__6a9atx(76) ? new StandaloneMonthOfYear(formatLength) : char === _Char___init__impl__6a9atx(89) ? new WeekBasedYear(formatLength) : char === _Char___init__impl__6a9atx(119) ? new WeekOfWeekBasedYear(formatLength) : char === _Char___init__impl__6a9atx(87) ? new WeekOfMonth(formatLength) : char === _Char___init__impl__6a9atx(100) ? new DayOfMonth(formatLength) : char === _Char___init__impl__6a9atx(68) ? new DayOfYear(formatLength) : char === _Char___init__impl__6a9atx(70) ? new DayOfWeekInMonth(formatLength) : char === _Char___init__impl__6a9atx(103) ? new ModifiedJulianDay(formatLength) : char === _Char___init__impl__6a9atx(69) ? new DayOfWeek_1(formatLength) : char === _Char___init__impl__6a9atx(101) ? new LocalizedDayOfWeek(formatLength) : char === _Char___init__impl__6a9atx(99) ? new StandaloneLocalizedDayOfWeek(formatLength) : char === _Char___init__impl__6a9atx(97) ? new AmPmMarker_0(formatLength) : char === _Char___init__impl__6a9atx(104) ? new AmPmHourOfDay(formatLength) : char === _Char___init__impl__6a9atx(72) ? new HourOfDay(formatLength) : char === _Char___init__impl__6a9atx(109) ? new MinuteOfHour(formatLength) : char === _Char___init__impl__6a9atx(115) ? new SecondOfMinute(formatLength) : char === _Char___init__impl__6a9atx(83) ? new FractionOfSecond(formatLength) : char === _Char___init__impl__6a9atx(65) ? new MilliOfDay(formatLength) : char === _Char___init__impl__6a9atx(110) ? new NanoOfSecond(formatLength) : char === _Char___init__impl__6a9atx(78) ? new NanoOfDay(formatLength) : char === _Char___init__impl__6a9atx(86) ? new TimeZoneId(formatLength) : char === _Char___init__impl__6a9atx(118) ? new GenericTimeZoneName(formatLength) : char === _Char___init__impl__6a9atx(122) ? new TimeZoneName(formatLength) : char === _Char___init__impl__6a9atx(79) ? new LocalizedZoneOffset(formatLength) : char === _Char___init__impl__6a9atx(88) ? new ZoneOffset1(formatLength) : char === _Char___init__impl__6a9atx(120) ? new ZoneOffset2(formatLength) : char === _Char___init__impl__6a9atx(90) ? new ZoneOffset3(formatLength) : new UnknownUnicodeDirective(char, formatLength);
  }
  function localizedDirective(_this__u8e3s4, recommendation) {
    recommendation = recommendation === VOID ? null : recommendation;
    _init_properties_Unicode_kt__5cnwob();
    throw IllegalArgumentException_init_$Create$("The directive '" + _this__u8e3s4.toString() + "' is locale-dependent, but locales are not supported in Kotlin" + (!(recommendation == null) ? '. ' + recommendation : ''));
  }
  function unsupportedPadding(_this__u8e3s4, digits) {
    _init_properties_Unicode_kt__5cnwob();
    throw UnsupportedOperationException_init_$Create$('Padding do ' + digits + ' digits is not supported for the ' + toString(_this__u8e3s4.knc()) + ' directive');
  }
  function unsupportedDirective(fieldName, recommendation) {
    recommendation = recommendation === VOID ? null : recommendation;
    _init_properties_Unicode_kt__5cnwob();
    throw UnsupportedOperationException_init_$Create$('kotlinx.datetime formatting does not support the ' + fieldName + ' field. ' + (!(recommendation == null) ? '' + recommendation + ' ' : '') + 'Please report your use case to https://github.com/Kotlin/kotlinx-datetime/issues');
  }
  function unknownLength(_this__u8e3s4) {
    _init_properties_Unicode_kt__5cnwob();
    throw IllegalArgumentException_init_$Create$('Unknown length ' + _this__u8e3s4.jnc() + ' for the ' + toString(_this__u8e3s4.knc()) + ' directive');
  }
  function byUnicodePattern$rec$lambda($this$alternativeParsing) {
    _init_properties_Unicode_kt__5cnwob();
    return Unit_instance;
  }
  function byUnicodePattern$rec$lambda_0($format) {
    return function ($this$alternativeParsing) {
      byUnicodePattern$rec($this$alternativeParsing, $format.onf_1);
      return Unit_instance;
    };
  }
  function byUnicodePattern$rec(builder, format) {
    if (format instanceof StringLiteral) {
      builder.in6(format.qnf_1);
    } else {
      if (format instanceof Sequence) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = format.pnf_1.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          byUnicodePattern$rec(builder, element);
        }
      } else {
        if (format instanceof OptionalGroup) {
          var tmp = [byUnicodePattern$rec$lambda];
          alternativeParsing(builder, tmp, byUnicodePattern$rec$lambda_0(format));
        } else {
          if (format instanceof Directive) {
            if (format instanceof TimeBased_0) {
              // Inline function 'kotlin.require' call
              if (!isInterface(builder, WithTime)) {
                var message = 'A time-based directive ' + format.toString() + " was used in a format builder that doesn't support time components";
                throw IllegalArgumentException_init_$Create$(toString_0(message));
              }
              format.bne(builder);
            } else {
              if (format instanceof YearMonthBased) {
                // Inline function 'kotlin.require' call
                if (!isInterface(builder, WithYearMonth)) {
                  var message_0 = 'A year-month-based directive ' + format.toString() + " was used in a format builder that doesn't support year-month components";
                  throw IllegalArgumentException_init_$Create$(toString_0(message_0));
                }
                format.mnc(builder);
              } else {
                if (format instanceof DateBased_0) {
                  // Inline function 'kotlin.require' call
                  if (!isInterface(builder, WithDate)) {
                    var message_1 = 'A date-based directive ' + format.toString() + " was used in a format builder that doesn't support date components";
                    throw IllegalArgumentException_init_$Create$(toString_0(message_1));
                  }
                  format.nnc(builder);
                } else {
                  if (format instanceof ZoneBased) {
                    // Inline function 'kotlin.require' call
                    if (!isInterface(builder, WithDateTimeComponents)) {
                      var message_2 = 'A time-zone-based directive ' + format.toString() + " was used in a format builder that doesn't support time-zone components";
                      throw IllegalArgumentException_init_$Create$(toString_0(message_2));
                    }
                    format.vne(builder);
                  } else {
                    if (format instanceof OffsetBased) {
                      // Inline function 'kotlin.require' call
                      if (!isInterface(builder, WithUtcOffset)) {
                        var message_3 = 'A UTC-offset-based directive ' + format.toString() + " was used in a format builder that doesn't support UTC offset components";
                        throw IllegalArgumentException_init_$Create$(toString_0(message_3));
                      }
                      format.enf(builder);
                    } else {
                      if (format instanceof UnknownUnicodeDirective) {
                        throw IllegalArgumentException_init_$Create$("The meaning of the directive '" + format.toString() + "' is unknown");
                      } else {
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
  }
  var properties_initialized_Unicode_kt_2yq8h9;
  function _init_properties_Unicode_kt__5cnwob() {
    if (!properties_initialized_Unicode_kt_2yq8h9) {
      properties_initialized_Unicode_kt_2yq8h9 = true;
      nonPlainCharacters = plus_0(plus(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90))), listOf([new Char(_Char___init__impl__6a9atx(91)), new Char(_Char___init__impl__6a9atx(93)), new Char(_Char___init__impl__6a9atx(39))]));
    }
  }
  function get_ISO_OFFSET() {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    var tmp0 = ISO_OFFSET$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ISO_OFFSET', 0, tmp, _get_ISO_OFFSET_$ref_70d0nn(), null);
    return tmp0.u1();
  }
  var ISO_OFFSET$delegate;
  var ISO_OFFSET_BASIC$delegate;
  var FOUR_DIGIT_OFFSET$delegate;
  function get_emptyIncompleteUtcOffset() {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    return emptyIncompleteUtcOffset;
  }
  var emptyIncompleteUtcOffset;
  function UtcOffsetFieldContainer() {
  }
  function IncompleteUtcOffset(offsetIsNegative, offsetHours, offsetMinutesOfHour, offsetSecondsOfMinute) {
    offsetIsNegative = offsetIsNegative === VOID ? null : offsetIsNegative;
    offsetHours = offsetHours === VOID ? null : offsetHours;
    offsetMinutesOfHour = offsetMinutesOfHour === VOID ? null : offsetMinutesOfHour;
    offsetSecondsOfMinute = offsetSecondsOfMinute === VOID ? null : offsetSecondsOfMinute;
    this.bng_1 = offsetIsNegative;
    this.cng_1 = offsetHours;
    this.dng_1 = offsetMinutesOfHour;
    this.eng_1 = offsetSecondsOfMinute;
  }
  protoOf(IncompleteUtcOffset).tnf = function (_set____db54di) {
    this.bng_1 = _set____db54di;
  };
  protoOf(IncompleteUtcOffset).unf = function () {
    return this.bng_1;
  };
  protoOf(IncompleteUtcOffset).vnf = function (_set____db54di) {
    this.cng_1 = _set____db54di;
  };
  protoOf(IncompleteUtcOffset).wnf = function () {
    return this.cng_1;
  };
  protoOf(IncompleteUtcOffset).xnf = function (_set____db54di) {
    this.dng_1 = _set____db54di;
  };
  protoOf(IncompleteUtcOffset).ynf = function () {
    return this.dng_1;
  };
  protoOf(IncompleteUtcOffset).znf = function (_set____db54di) {
    this.eng_1 = _set____db54di;
  };
  protoOf(IncompleteUtcOffset).ang = function () {
    return this.eng_1;
  };
  protoOf(IncompleteUtcOffset).fng = function () {
    var sign = this.bng_1 === true ? -1 : 1;
    var tmp0_safe_receiver = this.cng_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = imul(tmp0_safe_receiver, sign);
    }
    var tmp_0 = tmp;
    var tmp1_safe_receiver = this.dng_1;
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = imul(tmp1_safe_receiver, sign);
    }
    var tmp_2 = tmp_1;
    var tmp2_safe_receiver = this.eng_1;
    var tmp_3;
    if (tmp2_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = imul(tmp2_safe_receiver, sign);
    }
    return UtcOffset_0(tmp_0, tmp_2, tmp_3);
  };
  protoOf(IncompleteUtcOffset).gng = function (offset) {
    this.bng_1 = offset.hng_1 < 0;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = offset.hng_1;
    var totalSecondsAbs = abs(this_0);
    this.cng_1 = totalSecondsAbs / 3600 | 0;
    this.dng_1 = (totalSecondsAbs / 60 | 0) % 60 | 0;
    this.eng_1 = totalSecondsAbs % 60 | 0;
  };
  protoOf(IncompleteUtcOffset).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof IncompleteUtcOffset) {
      tmp_2 = this.bng_1 == other.bng_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.cng_1 == other.cng_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.dng_1 == other.dng_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.eng_1 == other.eng_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IncompleteUtcOffset).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.bng_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.cng_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    var tmp_0 = tmp + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_1 = this.dng_1;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
    var tmp_1 = tmp_0 + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_2 = this.eng_1;
    var tmp1_elvis_lhs_2 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    return tmp_1 + (tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2) | 0;
  };
  protoOf(IncompleteUtcOffset).xbr = function () {
    return new IncompleteUtcOffset(this.bng_1, this.cng_1, this.dng_1, this.eng_1);
  };
  protoOf(IncompleteUtcOffset).toString = function () {
    var tmp0_safe_receiver = this.bng_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = tmp0_safe_receiver ? '-' : '+';
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0 = tmp1_elvis_lhs == null ? ' ' : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = this.cng_1;
    var tmp_1 = toString_0(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
    var tmp3_elvis_lhs = this.dng_1;
    var tmp_2 = toString_0(tmp3_elvis_lhs == null ? '??' : tmp3_elvis_lhs);
    var tmp4_elvis_lhs = this.eng_1;
    return tmp_0 + tmp_1 + ':' + tmp_2 + ':' + toString_0(tmp4_elvis_lhs == null ? '??' : tmp4_elvis_lhs);
  };
  function UtcOffsetWholeHoursDirective(padding) {
    var tmp = OffsetFields_getInstance().jng_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.qng_1 = padding;
  }
  protoOf(UtcOffsetWholeHoursDirective).equals = function (other) {
    var tmp;
    if (other instanceof UtcOffsetWholeHoursDirective) {
      tmp = this.qng_1.equals(other.qng_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(UtcOffsetWholeHoursDirective).hashCode = function () {
    return this.qng_1.hashCode();
  };
  function Companion_15() {
  }
  protoOf(Companion_15).rng = function (block) {
    var builder = new Builder_2(new AppendableFormatStructure());
    block(builder);
    return new UtcOffsetFormat(builder.g3d());
  };
  var Companion_instance_16;
  function Companion_getInstance_16() {
    return Companion_instance_16;
  }
  function Builder_2(actualBuilder) {
    this.sng_1 = actualBuilder;
  }
  protoOf(Builder_2).fn7 = function () {
    return this.sng_1;
  };
  protoOf(Builder_2).tng = function (structure) {
    this.sng_1.in7(structure);
  };
  protoOf(Builder_2).gn7 = function () {
    return new Builder_2(new AppendableFormatStructure());
  };
  function UtcOffsetFormat(actualFormat) {
    AbstractDateTimeFormat.call(this);
    this.ung_1 = actualFormat;
  }
  protoOf(UtcOffsetFormat).tn5 = function () {
    return this.ung_1;
  };
  protoOf(UtcOffsetFormat).vng = function (value) {
    // Inline function 'kotlin.apply' call
    var this_0 = new IncompleteUtcOffset();
    this_0.gng(value);
    return this_0;
  };
  protoOf(UtcOffsetFormat).un5 = function (value) {
    return this.vng(value instanceof UtcOffset ? value : THROW_CCE());
  };
  protoOf(UtcOffsetFormat).wng = function (intermediate) {
    return intermediate.fng();
  };
  protoOf(UtcOffsetFormat).vn5 = function (intermediate) {
    return this.wng(intermediate instanceof IncompleteUtcOffset ? intermediate : THROW_CCE());
  };
  protoOf(UtcOffsetFormat).wn5 = function () {
    return get_emptyIncompleteUtcOffset();
  };
  function UtcOffsetFieldContainer$_get_offsetIsNegative_$ref_v5gok2() {
    return constructCallableReference(function (p0) {
      return p0.unf();
    }, 1, 0, 417);
  }
  function UtcOffsetFieldContainer$_set_offsetIsNegative_$ref_h7e0jq() {
    return constructCallableReference(function (p0, p1) {
      p0.tnf(p1);
      return Unit_instance;
    }, 2, 0, 418);
  }
  function OffsetFields$sign$1() {
    var tmp = this;
    var tmp_0 = KMutableProperty1;
    var tmp_1 = UtcOffsetFieldContainer$_get_offsetIsNegative_$ref_v5gok2();
    tmp.xng_1 = new PropertyAccessor(getPropertyCallableRef('offsetIsNegative', 1, tmp_0, tmp_1, UtcOffsetFieldContainer$_set_offsetIsNegative_$ref_h7e0jq()));
  }
  protoOf(OffsetFields$sign$1).yng = function () {
    return this.xng_1;
  };
  protoOf(OffsetFields$sign$1).zng = function (obj) {
    var tmp;
    var tmp_0;
    var tmp0_elvis_lhs = obj.wnf();
    if ((tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) === 0) {
      var tmp1_elvis_lhs = obj.ynf();
      tmp_0 = (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) === 0;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp2_elvis_lhs = obj.ang();
      tmp = (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) === 0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(OffsetFields$sign$1).anh = function (obj) {
    return this.zng((!(obj == null) ? isInterface(obj, UtcOffsetFieldContainer) : false) ? obj : THROW_CCE());
  };
  function UtcOffsetFieldContainer$_get_offsetHours_$ref_elsov2() {
    return constructCallableReference(function (p0) {
      return p0.wnf();
    }, 1, 0, 419);
  }
  function UtcOffsetFieldContainer$_set_offsetHours_$ref_4i2hci() {
    return constructCallableReference(function (p0, p1) {
      p0.vnf(p1);
      return Unit_instance;
    }, 2, 0, 420);
  }
  function UtcOffsetFieldContainer$_get_offsetMinutesOfHour_$ref_712kt() {
    return constructCallableReference(function (p0) {
      return p0.ynf();
    }, 1, 0, 421);
  }
  function UtcOffsetFieldContainer$_set_offsetMinutesOfHour_$ref_ka4bon() {
    return constructCallableReference(function (p0, p1) {
      p0.xnf(p1);
      return Unit_instance;
    }, 2, 0, 422);
  }
  function UtcOffsetFieldContainer$_get_offsetSecondsOfMinute_$ref_xrmftp() {
    return constructCallableReference(function (p0) {
      return p0.ang();
    }, 1, 0, 423);
  }
  function UtcOffsetFieldContainer$_set_offsetSecondsOfMinute_$ref_virwvd() {
    return constructCallableReference(function (p0, p1) {
      p0.znf(p1);
      return Unit_instance;
    }, 2, 0, 424);
  }
  function OffsetFields() {
    OffsetFields_instance = this;
    var tmp = this;
    tmp.ing_1 = new OffsetFields$sign$1();
    var tmp_0 = this;
    var tmp_1 = KMutableProperty1;
    var tmp_2 = UtcOffsetFieldContainer$_get_offsetHours_$ref_elsov2();
    var tmp0_accessor = new PropertyAccessor(getPropertyCallableRef('offsetHours', 1, tmp_1, tmp_2, UtcOffsetFieldContainer$_set_offsetHours_$ref_4i2hci()));
    var tmp1_sign = this.ing_1;
    tmp_0.jng_1 = new UnsignedFieldSpec(tmp0_accessor, 0, 18, VOID, 0, tmp1_sign);
    var tmp_3 = this;
    var tmp_4 = KMutableProperty1;
    var tmp_5 = UtcOffsetFieldContainer$_get_offsetMinutesOfHour_$ref_712kt();
    var tmp0_accessor_0 = new PropertyAccessor(getPropertyCallableRef('offsetMinutesOfHour', 1, tmp_4, tmp_5, UtcOffsetFieldContainer$_set_offsetMinutesOfHour_$ref_ka4bon()));
    var tmp1_sign_0 = this.ing_1;
    tmp_3.kng_1 = new UnsignedFieldSpec(tmp0_accessor_0, 0, 59, VOID, 0, tmp1_sign_0);
    var tmp_6 = this;
    var tmp_7 = KMutableProperty1;
    var tmp_8 = UtcOffsetFieldContainer$_get_offsetSecondsOfMinute_$ref_xrmftp();
    var tmp0_accessor_1 = new PropertyAccessor(getPropertyCallableRef('offsetSecondsOfMinute', 1, tmp_7, tmp_8, UtcOffsetFieldContainer$_set_offsetSecondsOfMinute_$ref_virwvd()));
    var tmp1_sign_1 = this.ing_1;
    tmp_6.lng_1 = new UnsignedFieldSpec(tmp0_accessor_1, 0, 59, VOID, 0, tmp1_sign_1);
  }
  var OffsetFields_instance;
  function OffsetFields_getInstance() {
    if (OffsetFields_instance == null)
      new OffsetFields();
    return OffsetFields_instance;
  }
  function AbstractWithOffsetBuilder() {
  }
  function UtcOffsetMinuteOfHourDirective(padding) {
    var tmp = OffsetFields_getInstance().kng_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.fnh_1 = padding;
  }
  protoOf(UtcOffsetMinuteOfHourDirective).equals = function (other) {
    var tmp;
    if (other instanceof UtcOffsetMinuteOfHourDirective) {
      tmp = this.fnh_1.equals(other.fnh_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(UtcOffsetMinuteOfHourDirective).hashCode = function () {
    return this.fnh_1.hashCode();
  };
  function UtcOffsetSecondOfMinuteDirective(padding) {
    var tmp = OffsetFields_getInstance().lng_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.knh_1 = padding;
  }
  protoOf(UtcOffsetSecondOfMinuteDirective).equals = function (other) {
    var tmp;
    if (other instanceof UtcOffsetSecondOfMinuteDirective) {
      tmp = this.knh_1.equals(other.knh_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(UtcOffsetSecondOfMinuteDirective).hashCode = function () {
    return this.knh_1.hashCode();
  };
  function isoOffset(_this__u8e3s4, zOnZero, useSeparator, outputMinute, outputSecond) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    // Inline function 'kotlin.require' call
    if (!(outputMinute.i3(outputSecond) >= 0)) {
      var message = 'Seconds cannot be included without minutes';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    if (zOnZero) {
      optional(_this__u8e3s4, 'Z', isoOffset$lambda(outputMinute, useSeparator, outputSecond));
    } else {
      isoOffset$appendIsoOffsetWithoutZOnZero(_this__u8e3s4, outputMinute, useSeparator, outputSecond);
    }
  }
  var WhenToOutput_NEVER_instance;
  var WhenToOutput_IF_NONZERO_instance;
  var WhenToOutput_ALWAYS_instance;
  var WhenToOutput_entriesInitialized;
  function WhenToOutput_initEntries() {
    if (WhenToOutput_entriesInitialized)
      return Unit_instance;
    WhenToOutput_entriesInitialized = true;
    WhenToOutput_NEVER_instance = new WhenToOutput('NEVER', 0);
    WhenToOutput_IF_NONZERO_instance = new WhenToOutput('IF_NONZERO', 1);
    WhenToOutput_ALWAYS_instance = new WhenToOutput('ALWAYS', 2);
  }
  function WhenToOutput(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function outputIfNeeded(_this__u8e3s4, whenToOutput, format) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    switch (whenToOutput.a1_1) {
      case 0:
        break;
      case 1:
        optional(_this__u8e3s4, VOID, outputIfNeeded$lambda(format));
        break;
      case 2:
        format(_this__u8e3s4);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  function ISO_OFFSET$delegate$lambda() {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    var tmp = Companion_instance_16;
    return tmp.rng(ISO_OFFSET$delegate$lambda$lambda);
  }
  function ISO_OFFSET$delegate$lambda$lambda($this$build) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    var tmp = [ISO_OFFSET$delegate$lambda$lambda$lambda];
    alternativeParsing($this$build, tmp, ISO_OFFSET$delegate$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function ISO_OFFSET$delegate$lambda$lambda$lambda($this$alternativeParsing) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$alternativeParsing.in6('z');
    return Unit_instance;
  }
  function ISO_OFFSET$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    optional($this$alternativeParsing, 'Z', ISO_OFFSET$delegate$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_OFFSET$delegate$lambda$lambda$lambda$lambda($this$optional) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$optional.xn6();
    char($this$optional, _Char___init__impl__6a9atx(58));
    $this$optional.zn6();
    optional($this$optional, VOID, ISO_OFFSET$delegate$lambda$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_OFFSET$delegate$lambda$lambda$lambda$lambda$lambda($this$optional) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    char($this$optional, _Char___init__impl__6a9atx(58));
    $this$optional.bn7();
    return Unit_instance;
  }
  function _get_ISO_OFFSET_$ref_70d0nn() {
    return constructCallableReference(function () {
      return get_ISO_OFFSET();
    }, 0, 0, 425);
  }
  function ISO_OFFSET_BASIC$delegate$lambda() {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    var tmp = Companion_instance_16;
    return tmp.rng(ISO_OFFSET_BASIC$delegate$lambda$lambda);
  }
  function ISO_OFFSET_BASIC$delegate$lambda$lambda($this$build) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    var tmp = [ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda];
    alternativeParsing($this$build, tmp, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda($this$alternativeParsing) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$alternativeParsing.in6('z');
    return Unit_instance;
  }
  function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    optional($this$alternativeParsing, 'Z', ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda($this$optional) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$optional.xn6();
    optional($this$optional, VOID, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda($this$optional) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$optional.zn6();
    optional($this$optional, VOID, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda$lambda($this$optional) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$optional.bn7();
    return Unit_instance;
  }
  function FOUR_DIGIT_OFFSET$delegate$lambda() {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    var tmp = Companion_instance_16;
    return tmp.rng(FOUR_DIGIT_OFFSET$delegate$lambda$lambda);
  }
  function FOUR_DIGIT_OFFSET$delegate$lambda$lambda($this$build) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    $this$build.xn6();
    $this$build.zn6();
    return Unit_instance;
  }
  function isoOffset$appendIsoOffsetWithoutZOnZero$lambda$lambda($useSeparator) {
    return function ($this$outputIfNeeded) {
      var tmp;
      if ($useSeparator) {
        char($this$outputIfNeeded, _Char___init__impl__6a9atx(58));
        tmp = Unit_instance;
      }
      $this$outputIfNeeded.bn7();
      return Unit_instance;
    };
  }
  function isoOffset$appendIsoOffsetWithoutZOnZero$lambda($useSeparator, $outputSecond) {
    return function ($this$outputIfNeeded) {
      var tmp;
      if ($useSeparator) {
        char($this$outputIfNeeded, _Char___init__impl__6a9atx(58));
        tmp = Unit_instance;
      }
      $this$outputIfNeeded.zn6();
      outputIfNeeded($this$outputIfNeeded, $outputSecond, isoOffset$appendIsoOffsetWithoutZOnZero$lambda$lambda($useSeparator));
      return Unit_instance;
    };
  }
  function isoOffset$appendIsoOffsetWithoutZOnZero(_this__u8e3s4, $outputMinute, $useSeparator, $outputSecond) {
    _this__u8e3s4.xn6();
    outputIfNeeded(_this__u8e3s4, $outputMinute, isoOffset$appendIsoOffsetWithoutZOnZero$lambda($useSeparator, $outputSecond));
  }
  function isoOffset$lambda$lambda($this$alternativeParsing) {
    _init_properties_UtcOffsetFormat_kt__9r9ddw();
    char($this$alternativeParsing, _Char___init__impl__6a9atx(122));
    return Unit_instance;
  }
  function isoOffset$lambda$lambda_0($outputMinute, $useSeparator, $outputSecond) {
    return function ($this$alternativeParsing) {
      isoOffset$appendIsoOffsetWithoutZOnZero($this$alternativeParsing, $outputMinute, $useSeparator, $outputSecond);
      return Unit_instance;
    };
  }
  function isoOffset$lambda($outputMinute, $useSeparator, $outputSecond) {
    return function ($this$optional) {
      var tmp = [isoOffset$lambda$lambda];
      alternativeParsing($this$optional, tmp, isoOffset$lambda$lambda_0($outputMinute, $useSeparator, $outputSecond));
      return Unit_instance;
    };
  }
  function outputIfNeeded$lambda($format) {
    return function ($this$optional) {
      $format($this$optional);
      return Unit_instance;
    };
  }
  function WhenToOutput_NEVER_getInstance() {
    WhenToOutput_initEntries();
    return WhenToOutput_NEVER_instance;
  }
  function WhenToOutput_IF_NONZERO_getInstance() {
    WhenToOutput_initEntries();
    return WhenToOutput_IF_NONZERO_instance;
  }
  function WhenToOutput_ALWAYS_getInstance() {
    WhenToOutput_initEntries();
    return WhenToOutput_ALWAYS_instance;
  }
  var properties_initialized_UtcOffsetFormat_kt_6y9jku;
  function _init_properties_UtcOffsetFormat_kt__9r9ddw() {
    if (!properties_initialized_UtcOffsetFormat_kt_6y9jku) {
      properties_initialized_UtcOffsetFormat_kt_6y9jku = true;
      ISO_OFFSET$delegate = lazy(ISO_OFFSET$delegate$lambda);
      ISO_OFFSET_BASIC$delegate = lazy(ISO_OFFSET_BASIC$delegate$lambda);
      FOUR_DIGIT_OFFSET$delegate = lazy(FOUR_DIGIT_OFFSET$delegate$lambda);
      emptyIncompleteUtcOffset = new IncompleteUtcOffset();
    }
  }
  function get_emptyIncompleteYearMonth() {
    _init_properties_YearMonthFormat_kt__i0mmu0();
    return emptyIncompleteYearMonth;
  }
  var emptyIncompleteYearMonth;
  function get_ISO_YEAR_MONTH() {
    _init_properties_YearMonthFormat_kt__i0mmu0();
    var tmp0 = ISO_YEAR_MONTH$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ISO_YEAR_MONTH', 0, tmp, _get_ISO_YEAR_MONTH_$ref_y3tv9a(), null);
    return tmp0.u1();
  }
  var ISO_YEAR_MONTH$delegate;
  function IncompleteYearMonth(year, monthNumber) {
    year = year === VOID ? null : year;
    monthNumber = monthNumber === VOID ? null : monthNumber;
    this.fn8_1 = year;
    this.gn8_1 = monthNumber;
  }
  protoOf(IncompleteYearMonth).dn8 = function (_set____db54di) {
    this.fn8_1 = _set____db54di;
  };
  protoOf(IncompleteYearMonth).wn7 = function () {
    return this.fn8_1;
  };
  protoOf(IncompleteYearMonth).en8 = function (_set____db54di) {
    this.gn8_1 = _set____db54di;
  };
  protoOf(IncompleteYearMonth).bn8 = function () {
    return this.gn8_1;
  };
  protoOf(IncompleteYearMonth).lnh = function () {
    var year = requireParsedField(this.fn8_1, 'year');
    var month = requireParsedField(this.gn8_1, 'monthNumber');
    return YearMonth_init_$Create$(year, month);
  };
  protoOf(IncompleteYearMonth).mnh = function (yearMonth) {
    this.fn8_1 = yearMonth.nnh_1;
    this.gn8_1 = get_number(yearMonth.an8());
  };
  protoOf(IncompleteYearMonth).xbr = function () {
    return new IncompleteYearMonth(this.fn8_1, this.gn8_1);
  };
  protoOf(IncompleteYearMonth).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof IncompleteYearMonth) {
      tmp_0 = this.fn8_1 == other.fn8_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.gn8_1 == other.gn8_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IncompleteYearMonth).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.fn8_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(tmp$ret$0, 31);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.gn8_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    return tmp + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
  };
  protoOf(IncompleteYearMonth).toString = function () {
    var tmp0_elvis_lhs = this.fn8_1;
    var tmp = toString_0(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
    var tmp1_elvis_lhs = this.gn8_1;
    return tmp + '-' + toString_0(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs);
  };
  function requireParsedField(field, name) {
    _init_properties_YearMonthFormat_kt__i0mmu0();
    if (field == null) {
      throw DateTimeFormatException_init_$Create$_0('Can not create a ' + name + ' from the given input: the field ' + name + ' is missing');
    }
    return field;
  }
  function AbstractWithYearMonthBuilder() {
  }
  function Companion_16() {
  }
  protoOf(Companion_16).pnh = function (block) {
    var builder = new Builder_3(new AppendableFormatStructure());
    block(builder);
    return new YearMonthFormat(builder.g3d());
  };
  var Companion_instance_17;
  function Companion_getInstance_17() {
    return Companion_instance_17;
  }
  function Builder_3(actualBuilder) {
    this.qnh_1 = actualBuilder;
  }
  protoOf(Builder_3).fn7 = function () {
    return this.qnh_1;
  };
  protoOf(Builder_3).kn8 = function (structure) {
    return this.qnh_1.in7(structure);
  };
  protoOf(Builder_3).gn7 = function () {
    return new Builder_3(new AppendableFormatStructure());
  };
  function YearMonthFormat(actualFormat) {
    AbstractDateTimeFormat.call(this);
    this.rnh_1 = actualFormat;
  }
  protoOf(YearMonthFormat).tn5 = function () {
    return this.rnh_1;
  };
  protoOf(YearMonthFormat).snh = function (value) {
    // Inline function 'kotlin.apply' call
    var this_0 = new IncompleteYearMonth();
    this_0.mnh(value);
    return this_0;
  };
  protoOf(YearMonthFormat).un5 = function (value) {
    return this.snh(value instanceof YearMonth ? value : THROW_CCE());
  };
  protoOf(YearMonthFormat).tnh = function (intermediate) {
    return intermediate.lnh();
  };
  protoOf(YearMonthFormat).vn5 = function (intermediate) {
    return this.tnh(intermediate instanceof IncompleteYearMonth ? intermediate : THROW_CCE());
  };
  protoOf(YearMonthFormat).wn5 = function () {
    return get_emptyIncompleteYearMonth();
  };
  function YearDirective(padding, isYearOfEra) {
    isYearOfEra = isYearOfEra === VOID ? false : isYearOfEra;
    var tmp = YearMonthFields_getInstance().unh_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 4 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 4 : null;
    SignedIntFieldFormatDirective.call(this, tmp, tmp_0, null, tmp$ret$1, 4);
    this.bni_1 = padding;
    this.cni_1 = isYearOfEra;
  }
  protoOf(YearDirective).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof YearDirective) {
      tmp_0 = this.bni_1.equals(other.bni_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.cni_1 === other.cni_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(YearDirective).hashCode = function () {
    return imul(this.bni_1.hashCode(), 31) + getBooleanHashCode(this.cni_1) | 0;
  };
  function ReducedYearDirective(base, isYearOfEra) {
    isYearOfEra = isYearOfEra === VOID ? false : isYearOfEra;
    ReducedIntFieldDirective.call(this, YearMonthFields_getInstance().unh_1, 2, base);
    this.lni_1 = base;
    this.mni_1 = isYearOfEra;
  }
  protoOf(ReducedYearDirective).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ReducedYearDirective) {
      tmp_0 = this.lni_1 === other.lni_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.mni_1 === other.mni_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ReducedYearDirective).hashCode = function () {
    return imul(this.lni_1, 31) + getBooleanHashCode(this.mni_1) | 0;
  };
  function MonthDirective(padding) {
    var tmp = YearMonthFields_getInstance().vnh_1;
    // Inline function 'kotlinx.datetime.format.minDigits' call
    var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
    // Inline function 'kotlinx.datetime.format.spaces' call
    var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
    UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
    this.uni_1 = padding;
  }
  protoOf(MonthDirective).equals = function (other) {
    var tmp;
    if (other instanceof MonthDirective) {
      tmp = this.uni_1.equals(other.uni_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(MonthDirective).hashCode = function () {
    return this.uni_1.hashCode();
  };
  function YearMonthFieldContainer$_get_year_$ref_7j3zdj() {
    return constructCallableReference(function (p0) {
      return p0.wn7();
    }, 1, 0, 426);
  }
  function YearMonthFieldContainer$_set_year_$ref_kc0aub() {
    return constructCallableReference(function (p0, p1) {
      p0.dn8(p1);
      return Unit_instance;
    }, 2, 0, 427);
  }
  function YearMonthFieldContainer$_get_monthNumber_$ref_pn0wu5() {
    return constructCallableReference(function (p0) {
      return p0.bn8();
    }, 1, 0, 428);
  }
  function YearMonthFieldContainer$_set_monthNumber_$ref_fjapbl() {
    return constructCallableReference(function (p0, p1) {
      p0.en8(p1);
      return Unit_instance;
    }, 2, 0, 429);
  }
  function YearMonthFields() {
    YearMonthFields_instance = this;
    var tmp = this;
    var tmp_0 = KMutableProperty1;
    var tmp_1 = YearMonthFieldContainer$_get_year_$ref_7j3zdj();
    tmp.unh_1 = new GenericFieldSpec(new PropertyAccessor(getPropertyCallableRef('year', 1, tmp_0, tmp_1, YearMonthFieldContainer$_set_year_$ref_kc0aub())));
    var tmp_2 = this;
    var tmp_3 = KMutableProperty1;
    var tmp_4 = YearMonthFieldContainer$_get_monthNumber_$ref_pn0wu5();
    tmp_2.vnh_1 = new UnsignedFieldSpec(new PropertyAccessor(getPropertyCallableRef('monthNumber', 1, tmp_3, tmp_4, YearMonthFieldContainer$_set_monthNumber_$ref_fjapbl())), 1, 12);
  }
  var YearMonthFields_instance;
  function YearMonthFields_getInstance() {
    if (YearMonthFields_instance == null)
      new YearMonthFields();
    return YearMonthFields_instance;
  }
  function yearOfEra(_this__u8e3s4, padding) {
    _init_properties_YearMonthFormat_kt__i0mmu0();
    (isInterface(_this__u8e3s4, AbstractWithYearMonthBuilder) ? _this__u8e3s4 : THROW_CCE()).kn8(new BasicFormatStructure(new YearDirective(padding, true)));
  }
  function yearOfEraTwoDigits(_this__u8e3s4, baseYear) {
    _init_properties_YearMonthFormat_kt__i0mmu0();
    (isInterface(_this__u8e3s4, AbstractWithYearMonthBuilder) ? _this__u8e3s4 : THROW_CCE()).kn8(new BasicFormatStructure(new ReducedYearDirective(baseYear, true)));
  }
  function ISO_YEAR_MONTH$delegate$lambda() {
    _init_properties_YearMonthFormat_kt__i0mmu0();
    var tmp = Companion_instance_17;
    return tmp.pnh(ISO_YEAR_MONTH$delegate$lambda$lambda);
  }
  function ISO_YEAR_MONTH$delegate$lambda$lambda($this$build) {
    _init_properties_YearMonthFormat_kt__i0mmu0();
    $this$build.en6();
    char($this$build, _Char___init__impl__6a9atx(45));
    $this$build.hn6();
    return Unit_instance;
  }
  function _get_ISO_YEAR_MONTH_$ref_y3tv9a() {
    return constructCallableReference(function () {
      return get_ISO_YEAR_MONTH();
    }, 0, 0, 430);
  }
  var properties_initialized_YearMonthFormat_kt_fp0mk6;
  function _init_properties_YearMonthFormat_kt__i0mmu0() {
    if (!properties_initialized_YearMonthFormat_kt_fp0mk6) {
      properties_initialized_YearMonthFormat_kt_fp0mk6 = true;
      emptyIncompleteYearMonth = new IncompleteYearMonth();
      ISO_YEAR_MONTH$delegate = lazy(ISO_YEAR_MONTH$delegate$lambda);
    }
  }
  function monthLength(_this__u8e3s4, isLeapYear) {
    switch (_this__u8e3s4) {
      case 2:
        return isLeapYear ? 29 : 28;
      case 4:
      case 6:
      case 9:
      case 11:
        return 30;
      default:
        return 31;
    }
  }
  function isLeapYear(year) {
    var prolepticYear = fromInt(year);
    var tmp;
    if (equalsLong(bitwiseAnd(prolepticYear, new Long(3, 0)), new Long(0, 0))) {
      var tmp_0;
      // Inline function 'kotlin.Long.rem' call
      var tmp$ret$0 = modulo(prolepticYear, fromInt(100));
      if (!equalsLong(tmp$ret$0, new Long(0, 0))) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlin.Long.rem' call
        var tmp$ret$1 = modulo(prolepticYear, fromInt(400));
        tmp_0 = equalsLong(tmp$ret$1, new Long(0, 0));
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function AppendableFormatStructure() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.hn7_1 = ArrayList_init_$Create$_0();
  }
  protoOf(AppendableFormatStructure).g3d = function () {
    return new ConcatenatedFormatStructure(this.hn7_1);
  };
  protoOf(AppendableFormatStructure).in7 = function (format) {
    if (isInterface(format, NonConcatenatedFormatStructure))
      this.hn7_1.j1(format);
    else {
      if (format instanceof ConcatenatedFormatStructure) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = format.jn7_1.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          this.hn7_1.j1(element);
        }
      } else {
        noWhenBranchMatchedException();
      }
    }
  };
  function UnsignedIntFieldFormatDirective(field, minDigits, spacePadding) {
    this.wn8_1 = field;
    this.xn8_1 = minDigits;
    this.yn8_1 = spacePadding;
    this.zn8_1 = this.wn8_1.bnj_1;
    // Inline function 'kotlin.require' call
    if (!(this.xn8_1 >= 0)) {
      var message = 'The minimum number of digits (' + this.xn8_1 + ') is negative';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.zn8_1 >= this.xn8_1)) {
      var message_0 = 'The maximum number of digits (' + this.zn8_1 + ') is less than the minimum number of digits (' + this.xn8_1 + ')';
      throw IllegalArgumentException_init_$Create$(toString_0(message_0));
    }
    if (!(this.yn8_1 == null)) {
      // Inline function 'kotlin.require' call
      if (!(this.yn8_1 > this.xn8_1)) {
        var message_1 = 'The space padding (' + this.yn8_1 + ') should be more than the minimum number of digits (' + this.xn8_1 + ')';
        throw IllegalArgumentException_init_$Create$(toString_0(message_1));
      }
    }
  }
  protoOf(UnsignedIntFieldFormatDirective).an9 = function () {
    return this.wn8_1;
  };
  protoOf(UnsignedIntFieldFormatDirective).an6 = function () {
    var formatter = new UnsignedIntFormatterStructure(Accessor$getterNotNull$ref(this.wn8_1.vni_1), this.xn8_1);
    return !(this.yn8_1 == null) ? new SpacePaddedFormatter(formatter, this.yn8_1) : formatter;
  };
  protoOf(UnsignedIntFieldFormatDirective).cn6 = function () {
    return spaceAndZeroPaddedUnsignedInt(this.xn8_1, this.zn8_1, this.yn8_1, this.wn8_1.vni_1, this.wn8_1.yni_1);
  };
  function DecimalFractionFieldFormatDirective(field, minDigits, maxDigits, zerosToAdd) {
    this.dnc_1 = field;
    this.enc_1 = minDigits;
    this.fnc_1 = maxDigits;
    this.gnc_1 = zerosToAdd;
  }
  protoOf(DecimalFractionFieldFormatDirective).an9 = function () {
    return this.dnc_1;
  };
  protoOf(DecimalFractionFieldFormatDirective).an6 = function () {
    return new DecimalFractionFormatterStructure(Accessor$getterNotNull$ref_0(this.dnc_1.cnj()), this.enc_1, this.fnc_1, this.gnc_1);
  };
  protoOf(DecimalFractionFieldFormatDirective).cn6 = function () {
    return new ParserStructure(listOf_0(new NumberSpanParserOperation(listOf_0(new FractionPartConsumer(this.enc_1, this.fnc_1, this.dnc_1.cnj(), this.dnc_1.m())))), emptyList());
  };
  function SignedIntFieldFormatDirective(field, minDigits, maxDigits, spacePadding, outputPlusOnExceededWidth) {
    this.dni_1 = field;
    this.eni_1 = minDigits;
    this.fni_1 = maxDigits;
    this.gni_1 = spacePadding;
    this.hni_1 = outputPlusOnExceededWidth;
    // Inline function 'kotlin.require' call
    if (!(this.eni_1 == null || this.eni_1 >= 0)) {
      var message = 'The minimum number of digits (' + this.eni_1 + ') is negative';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.fni_1 == null || this.eni_1 == null || this.fni_1 >= this.eni_1)) {
      var message_0 = 'The maximum number of digits (' + this.fni_1 + ') is less than the minimum number of digits (' + this.eni_1 + ')';
      throw IllegalArgumentException_init_$Create$(toString_0(message_0));
    }
  }
  protoOf(SignedIntFieldFormatDirective).an9 = function () {
    return this.dni_1;
  };
  protoOf(SignedIntFieldFormatDirective).an6 = function () {
    var tmp = Accessor$getterNotNull$ref_1(this.dni_1.cnj());
    var tmp0_elvis_lhs = this.eni_1;
    var formatter = new SignedIntFormatterStructure(tmp, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs, this.hni_1);
    return !(this.gni_1 == null) ? new SpacePaddedFormatter(formatter, this.gni_1) : formatter;
  };
  protoOf(SignedIntFieldFormatDirective).cn6 = function () {
    return SignedIntParser(this.eni_1, this.fni_1, this.gni_1, this.dni_1.cnj(), this.dni_1.m(), this.hni_1);
  };
  function ReducedIntFieldDirective(field, digits, base) {
    this.nni_1 = field;
    this.oni_1 = digits;
    this.pni_1 = base;
  }
  protoOf(ReducedIntFieldDirective).an9 = function () {
    return this.nni_1;
  };
  protoOf(ReducedIntFieldDirective).an6 = function () {
    return new ReducedIntFormatterStructure(Accessor$getterNotNull$ref_2(this.nni_1.cnj()), this.oni_1, this.pni_1);
  };
  protoOf(ReducedIntFieldDirective).cn6 = function () {
    return ReducedIntParser(this.oni_1, this.pni_1, this.nni_1.cnj(), this.nni_1.m());
  };
  function GenericFieldSpec(accessor, name, defaultValue, sign) {
    name = name === VOID ? accessor.m() : name;
    defaultValue = defaultValue === VOID ? null : defaultValue;
    sign = sign === VOID ? null : sign;
    AbstractFieldSpec.call(this);
    this.dnj_1 = accessor;
    this.enj_1 = name;
    this.fnj_1 = defaultValue;
    this.gnj_1 = sign;
  }
  protoOf(GenericFieldSpec).cnj = function () {
    return this.dnj_1;
  };
  protoOf(GenericFieldSpec).m = function () {
    return this.enj_1;
  };
  protoOf(GenericFieldSpec).hnj = function () {
    return this.fnj_1;
  };
  protoOf(GenericFieldSpec).inj = function () {
    return this.gnj_1;
  };
  function PropertyAccessor(property, name) {
    name = name === VOID ? property.callableName : name;
    this.jnj_1 = property;
    this.knj_1 = name;
  }
  protoOf(PropertyAccessor).m = function () {
    return this.knj_1;
  };
  protoOf(PropertyAccessor).lnj = function (container, newValue) {
    var oldValue = this.jnj_1.get(container);
    var tmp;
    if (oldValue === null) {
      this.jnj_1.set(container, newValue);
      tmp = null;
    } else if (equals(oldValue, newValue)) {
      tmp = null;
    } else {
      tmp = oldValue;
    }
    return tmp;
  };
  protoOf(PropertyAccessor).mnj = function (container, newValue) {
    return this.lnj(container, newValue);
  };
  protoOf(PropertyAccessor).nnj = function (container) {
    return this.jnj_1.get(container);
  };
  function UnsignedFieldSpec(accessor, minValue, maxValue, name, defaultValue, sign) {
    name = name === VOID ? accessor.m() : name;
    defaultValue = defaultValue === VOID ? null : defaultValue;
    sign = sign === VOID ? null : sign;
    AbstractFieldSpec.call(this);
    this.vni_1 = accessor;
    this.wni_1 = minValue;
    this.xni_1 = maxValue;
    this.yni_1 = name;
    this.zni_1 = defaultValue;
    this.anj_1 = sign;
    var tmp = this;
    var tmp_0;
    if (this.xni_1 < 10) {
      tmp_0 = 1;
    } else if (this.xni_1 < 100) {
      tmp_0 = 2;
    } else if (this.xni_1 < 1000) {
      tmp_0 = 3;
    } else {
      throw IllegalArgumentException_init_$Create$('Max value ' + this.xni_1 + ' is too large');
    }
    tmp.bnj_1 = tmp_0;
  }
  protoOf(UnsignedFieldSpec).cnj = function () {
    return this.vni_1;
  };
  protoOf(UnsignedFieldSpec).m = function () {
    return this.yni_1;
  };
  protoOf(UnsignedFieldSpec).hnj = function () {
    return this.zni_1;
  };
  protoOf(UnsignedFieldSpec).inj = function () {
    return this.anj_1;
  };
  function Accessor() {
  }
  function AbstractFieldSpec() {
  }
  protoOf(AbstractFieldSpec).toString = function () {
    return 'The field ' + this.m() + ' (default value is ' + toString_1(this.hnj()) + ')';
  };
  function Accessor$getterNotNull$ref(p0) {
    return constructCallableReference(function (p0_0) {
      return p0.onj(p0_0);
    }, 1, 0, 431, 'getterNotNull', [p0]);
  }
  function Accessor$getterNotNull$ref_0(p0) {
    return constructCallableReference(function (p0_0) {
      return p0.onj(p0_0);
    }, 1, 0, 431, 'getterNotNull', [p0]);
  }
  function Accessor$getterNotNull$ref_1(p0) {
    return constructCallableReference(function (p0_0) {
      return p0.onj(p0_0);
    }, 1, 0, 431, 'getterNotNull', [p0]);
  }
  function Accessor$getterNotNull$ref_2(p0) {
    return constructCallableReference(function (p0_0) {
      return p0.onj(p0_0);
    }, 1, 0, 431, 'getterNotNull', [p0]);
  }
  function Accessor$getter$ref(p0) {
    return constructCallableReference(function (p0_0) {
      return p0.nnj(p0_0);
    }, 1, 0, 432, 'getter', [p0]);
  }
  function CachedFormatStructure(formats) {
    ConcatenatedFormatStructure.call(this, formats);
    this.yn5_1 = protoOf(ConcatenatedFormatStructure).an6.call(this);
    this.zn5_1 = protoOf(ConcatenatedFormatStructure).cn6.call(this);
  }
  protoOf(CachedFormatStructure).an6 = function () {
    return this.yn5_1;
  };
  protoOf(CachedFormatStructure).cn6 = function () {
    return this.zn5_1;
  };
  function BasicFormatStructure(directive) {
    this.pnj_1 = directive;
  }
  protoOf(BasicFormatStructure).toString = function () {
    return 'BasicFormatStructure(' + toString_0(this.pnj_1) + ')';
  };
  protoOf(BasicFormatStructure).equals = function (other) {
    var tmp;
    if (other instanceof BasicFormatStructure) {
      tmp = equals(this.pnj_1, other.pnj_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(BasicFormatStructure).hashCode = function () {
    return hashCode(this.pnj_1);
  };
  protoOf(BasicFormatStructure).cn6 = function () {
    return this.pnj_1.cn6();
  };
  protoOf(BasicFormatStructure).an6 = function () {
    return this.pnj_1.an6();
  };
  function ConstantFormatStructure(string) {
    this.qnj_1 = string;
  }
  protoOf(ConstantFormatStructure).toString = function () {
    return 'ConstantFormatStructure(' + this.qnj_1 + ')';
  };
  protoOf(ConstantFormatStructure).equals = function (other) {
    var tmp;
    if (other instanceof ConstantFormatStructure) {
      tmp = this.qnj_1 === other.qnj_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ConstantFormatStructure).hashCode = function () {
    return getStringHashCode(this.qnj_1);
  };
  protoOf(ConstantFormatStructure).cn6 = function () {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = this.qnj_1;
    if (charSequenceLength(this_0) === 0) {
      tmp = emptyList();
    } else {
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_1 = ArrayList_init_$Create$_0();
      var tmp_0;
      if (isAsciiDigit(charCodeAt(this.qnj_1, 0))) {
        var tmp0 = this.qnj_1;
        var tmp$ret$5;
        $l$block: {
          // Inline function 'kotlin.text.takeWhile' call
          var inductionVariable = 0;
          var last = tmp0.length;
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var it = charCodeAt(tmp0, index);
              if (!isAsciiDigit(it)) {
                tmp$ret$5 = substring(tmp0, 0, index);
                break $l$block;
              }
            }
             while (inductionVariable < last);
          tmp$ret$5 = tmp0;
        }
        this_1.j1(new NumberSpanParserOperation(listOf_0(new ConstantNumberConsumer(tmp$ret$5))));
        var tmp0_0 = this.qnj_1;
        var tmp$ret$7;
        $l$block_0: {
          // Inline function 'kotlin.text.dropWhile' call
          var inductionVariable_0 = 0;
          var last_0 = charSequenceLength(tmp0_0) - 1 | 0;
          if (inductionVariable_0 <= last_0)
            do {
              var index_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var it_0 = charCodeAt(tmp0_0, index_0);
              if (!isAsciiDigit(it_0)) {
                tmp$ret$7 = substring_0(tmp0_0, index_0);
                break $l$block_0;
              }
            }
             while (inductionVariable_0 <= last_0);
          tmp$ret$7 = '';
        }
        tmp_0 = tmp$ret$7;
      } else {
        tmp_0 = this.qnj_1;
      }
      var suffix = tmp_0;
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(suffix) > 0) {
        if (isAsciiDigit(charCodeAt(suffix, suffix.length - 1 | 0))) {
          var tmp$ret$10;
          $l$block_1: {
            // Inline function 'kotlin.text.dropLastWhile' call
            var inductionVariable_1 = get_lastIndex(suffix);
            if (0 <= inductionVariable_1)
              do {
                var index_1 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + -1 | 0;
                var it_1 = charCodeAt(suffix, index_1);
                if (!isAsciiDigit(it_1)) {
                  tmp$ret$10 = substring(suffix, 0, index_1 + 1 | 0);
                  break $l$block_1;
                }
              }
               while (0 <= inductionVariable_1);
            tmp$ret$10 = '';
          }
          this_1.j1(new PlainStringParserOperation(tmp$ret$10));
          var tmp$ret$12;
          $l$block_2: {
            // Inline function 'kotlin.text.takeLastWhile' call
            var inductionVariable_2 = get_lastIndex(suffix);
            if (0 <= inductionVariable_2)
              do {
                var index_2 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + -1 | 0;
                var it_2 = charCodeAt(suffix, index_2);
                if (!isAsciiDigit(it_2)) {
                  tmp$ret$12 = substring_0(suffix, index_2 + 1 | 0);
                  break $l$block_2;
                }
              }
               while (0 <= inductionVariable_2);
            tmp$ret$12 = suffix;
          }
          this_1.j1(new NumberSpanParserOperation(listOf_0(new ConstantNumberConsumer(tmp$ret$12))));
        } else {
          this_1.j1(new PlainStringParserOperation(suffix));
        }
      }
      tmp = this_1.t5();
    }
    return new ParserStructure(tmp, emptyList());
  };
  protoOf(ConstantFormatStructure).an6 = function () {
    return new ConstantStringFormatterStructure(this.qnj_1);
  };
  function SignedFormatStructure$parser$lambda(this$0) {
    return function (value, isNegative) {
      var _iterator__ex2g4s = this$0.tnj_1.t();
      while (_iterator__ex2g4s.u()) {
        var field = _iterator__ex2g4s.v();
        var wasNegative = field.yng().nnj(value) === true;
        field.yng().mnj(value, !(isNegative === wasNegative));
      }
      return Unit_instance;
    };
  }
  function formatter$checkIfAllNegative(this$0, value) {
    var seenNonZero = false;
    var _iterator__ex2g4s = this$0.tnj_1.t();
    $l$loop: while (_iterator__ex2g4s.u()) {
      var check = _iterator__ex2g4s.v();
      if (check.yng().nnj(value) === true)
        seenNonZero = true;
      else if (check.anh(value))
        continue $l$loop;
      else
        return false;
    }
    return seenNonZero;
  }
  function SignedFormatStructure$formatter$checkIfAllNegative$ref(this$0) {
    return constructCallableReference(function (p0) {
      return formatter$checkIfAllNegative(this$0, p0);
    }, 1, 0, 433, 'checkIfAllNegative', [this$0]);
  }
  function SignedFormatStructure(format, withPlusSign) {
    this.rnj_1 = format;
    this.snj_1 = withPlusSign;
    var tmp = this;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = basicFormats(this.rnj_1);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp0_safe_receiver = element.an9().inj();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.j1(tmp0_safe_receiver);
      }
    }
    tmp.tnj_1 = toSet(destination);
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.require' call
    if (!!this.tnj_1.r()) {
      var message = 'Signed format must contain at least one field with a sign';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
  }
  protoOf(SignedFormatStructure).toString = function () {
    return 'SignedFormatStructure(' + toString_0(this.rnj_1) + ')';
  };
  protoOf(SignedFormatStructure).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof SignedFormatStructure) {
      tmp_0 = equals(this.rnj_1, other.rnj_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.snj_1 === other.snj_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SignedFormatStructure).hashCode = function () {
    return imul(31, hashCode(this.rnj_1)) + getBooleanHashCode(this.snj_1) | 0;
  };
  protoOf(SignedFormatStructure).cn6 = function () {
    return concat(listOf([new ParserStructure(listOf_0(new SignParser(SignedFormatStructure$parser$lambda(this), this.snj_1, 'sign for ' + toString_0(this.tnj_1))), emptyList()), this.rnj_1.cn6()]));
  };
  protoOf(SignedFormatStructure).an6 = function () {
    var innerFormat = this.rnj_1.an6();
    return new SignedFormatter(innerFormat, SignedFormatStructure$formatter$checkIfAllNegative$ref(this), this.snj_1);
  };
  function Companion_17() {
  }
  protoOf(Companion_17).unj = function (field) {
    var default_0 = field.hnj();
    // Inline function 'kotlin.require' call
    if (!!(default_0 == null)) {
      var message = "The field '" + field.m() + "' does not define a default value";
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    return new PropertyWithDefault(field.cnj(), default_0);
  };
  var Companion_instance_18;
  function Companion_getInstance_18() {
    return Companion_instance_18;
  }
  function PropertyWithDefault(accessor, defaultValue) {
    this.vnj_1 = accessor;
    this.wnj_1 = defaultValue;
  }
  function OptionalFormatStructure$parser$lambda(this$0) {
    return function (it) {
      var _iterator__ex2g4s = this$0.znj_1.t();
      while (_iterator__ex2g4s.u()) {
        var field = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.datetime.internal.format.PropertyWithDefault.assignDefault' call
        field.vnj_1.mnj(it, field.wnj_1);
      }
      return Unit_instance;
    };
  }
  function OptionalFormatStructure(onZero, format) {
    this.xnj_1 = onZero;
    this.ynj_1 = format;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = basicFormats(this.ynj_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = item.an9();
      destination.j1(tmp$ret$2);
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = distinct(destination);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.t();
    while (_iterator__ex2g4s_0.u()) {
      var item_0 = _iterator__ex2g4s_0.v();
      var tmp$ret$5 = Companion_instance_18.unj(item_0);
      destination_0.j1(tmp$ret$5);
    }
    tmp.znj_1 = destination_0;
  }
  protoOf(OptionalFormatStructure).toString = function () {
    return 'Optional(' + this.xnj_1 + ', ' + toString_0(this.ynj_1) + ')';
  };
  protoOf(OptionalFormatStructure).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof OptionalFormatStructure) {
      tmp_0 = this.xnj_1 === other.xnj_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.ynj_1, other.ynj_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(OptionalFormatStructure).hashCode = function () {
    return imul(31, getStringHashCode(this.xnj_1)) + hashCode(this.ynj_1) | 0;
  };
  protoOf(OptionalFormatStructure).cn6 = function () {
    var tmp = emptyList();
    var tmp_0 = this.ynj_1.cn6();
    var tmp_1 = (new ConstantFormatStructure(this.xnj_1)).cn6();
    var tmp_2;
    if (this.znj_1.r()) {
      tmp_2 = emptyList();
    } else {
      tmp_2 = listOf_0(new UnconditionalModification(OptionalFormatStructure$parser$lambda(this)));
    }
    return new ParserStructure(tmp, listOf([tmp_0, concat(listOf([tmp_1, new ParserStructure(tmp_2, emptyList())]))]));
  };
  protoOf(OptionalFormatStructure).an6 = function () {
    var formatter = this.ynj_1.an6();
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.znj_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      // Inline function 'kotlinx.datetime.internal.format.PropertyWithDefault.isDefaultComparisonPredicate' call
      var tmp$ret$2 = new ComparisonPredicate(item.wnj_1, Accessor$getter$ref(item.vnj_1));
      destination.j1(tmp$ret$2);
    }
    var predicate = conjunctionPredicate(destination);
    var tmp;
    if (predicate instanceof Truth) {
      tmp = new ConstantStringFormatterStructure(this.xnj_1);
    } else {
      var tmp_0 = to(Predicate$test$ref(predicate), new ConstantStringFormatterStructure(this.xnj_1));
      tmp = new ConditionalFormatter(listOf([tmp_0, to(Truth$test$ref(Truth_instance), formatter)]));
    }
    return tmp;
  };
  function AlternativesParsingFormatStructure(mainFormat, formats) {
    this.ank_1 = mainFormat;
    this.bnk_1 = formats;
  }
  protoOf(AlternativesParsingFormatStructure).toString = function () {
    return 'AlternativesParsing(' + toString_0(this.bnk_1) + ')';
  };
  protoOf(AlternativesParsingFormatStructure).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof AlternativesParsingFormatStructure) {
      tmp_0 = equals(this.ank_1, other.ank_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.bnk_1, other.bnk_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(AlternativesParsingFormatStructure).hashCode = function () {
    return imul(31, hashCode(this.ank_1)) + hashCode(this.bnk_1) | 0;
  };
  protoOf(AlternativesParsingFormatStructure).cn6 = function () {
    var tmp = emptyList();
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$_0();
    this_0.j1(this.ank_1.cn6());
    var _iterator__ex2g4s = this.bnk_1.t();
    while (_iterator__ex2g4s.u()) {
      var format = _iterator__ex2g4s.v();
      this_0.j1(format.cn6());
    }
    var tmp$ret$0 = this_0.t5();
    return new ParserStructure(tmp, tmp$ret$0);
  };
  protoOf(AlternativesParsingFormatStructure).an6 = function () {
    return this.ank_1.an6();
  };
  function ConcatenatedFormatStructure(formats) {
    this.jn7_1 = formats;
  }
  protoOf(ConcatenatedFormatStructure).toString = function () {
    return 'ConcatenatedFormatStructure(' + joinToString(this.jn7_1, ', ') + ')';
  };
  protoOf(ConcatenatedFormatStructure).equals = function (other) {
    var tmp;
    if (other instanceof ConcatenatedFormatStructure) {
      tmp = equals(this.jn7_1, other.jn7_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ConcatenatedFormatStructure).hashCode = function () {
    return hashCode(this.jn7_1);
  };
  protoOf(ConcatenatedFormatStructure).cn6 = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.jn7_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = item.cn6();
      destination.j1(tmp$ret$2);
    }
    return concat(destination);
  };
  protoOf(ConcatenatedFormatStructure).an6 = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.jn7_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = item.an6();
      destination.j1(tmp$ret$2);
    }
    var formatters = destination;
    var tmp;
    if (formatters.n1() === 1) {
      tmp = single(formatters);
    } else {
      tmp = new ConcatenatedFormatter(formatters);
    }
    return tmp;
  };
  function NonConcatenatedFormatStructure() {
  }
  function basicFormats(format) {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$_0();
    basicFormats$rec(this_0, format);
    return this_0.t5();
  }
  function basicFormats$rec($this_buildList, format) {
    if (format instanceof BasicFormatStructure)
      $this_buildList.j1(format.pnj_1);
    else {
      if (format instanceof ConcatenatedFormatStructure) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = format.jn7_1.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          basicFormats$rec($this_buildList, element);
        }
      } else {
        if (!(format instanceof ConstantFormatStructure)) {
          if (format instanceof SignedFormatStructure) {
            basicFormats$rec($this_buildList, format.rnj_1);
          } else {
            if (format instanceof AlternativesParsingFormatStructure) {
              basicFormats$rec($this_buildList, format.ank_1);
              // Inline function 'kotlin.collections.forEach' call
              var _iterator__ex2g4s_0 = format.bnk_1.t();
              while (_iterator__ex2g4s_0.u()) {
                var element_0 = _iterator__ex2g4s_0.v();
                basicFormats$rec($this_buildList, element_0);
              }
            } else {
              if (format instanceof OptionalFormatStructure) {
                basicFormats$rec($this_buildList, format.ynj_1);
              } else {
                noWhenBranchMatchedException();
              }
            }
          }
        }
      }
    }
  }
  function conjunctionPredicate(predicates) {
    return predicates.r() ? Truth_instance : predicates.n1() === 1 ? single(predicates) : new ConjunctionPredicate(predicates);
  }
  function ComparisonPredicate(expectedValue, getter) {
    this.cnk_1 = expectedValue;
    this.dnk_1 = getter;
  }
  protoOf(ComparisonPredicate).enk = function (value) {
    return equals(this.dnk_1(value), this.cnk_1);
  };
  function Truth() {
  }
  protoOf(Truth).fnk = function (value) {
    return true;
  };
  protoOf(Truth).enk = function (value) {
    return this.fnk(value);
  };
  var Truth_instance;
  function Truth_getInstance() {
    return Truth_instance;
  }
  function ConjunctionPredicate(predicates) {
    this.gnk_1 = predicates;
  }
  protoOf(ConjunctionPredicate).enk = function (value) {
    var tmp0 = this.gnk_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (!element.enk(value)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  function Predicate$test$ref(p0) {
    return constructCallableReference(function (p0_0) {
      return p0.enk(p0_0);
    }, 1, 0, 434, 'test', [p0]);
  }
  function Truth$test$ref(p0) {
    return constructCallableReference(function (p0_0) {
      return p0.fnk(p0_0);
    }, 1, 0, 435, 'test', [p0]);
  }
  function FormatterStructure() {
  }
  function SpacePaddedFormatter(formatter, padding) {
    this.ink_1 = formatter;
    this.jnk_1 = padding;
  }
  protoOf(SpacePaddedFormatter).hnk = function (obj, builder, minusNotRequired) {
    // Inline function 'kotlin.let' call
    var it = StringBuilder_init_$Create$();
    this.ink_1.hnk(obj, it, minusNotRequired);
    var string = it.toString();
    // Inline function 'kotlin.repeat' call
    var times = this.jnk_1 - string.length | 0;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        builder.s(_Char___init__impl__6a9atx(32));
      }
       while (inductionVariable < times);
    builder.k1(string);
  };
  function SignedFormatter(formatter, allSubFormatsNegative, alwaysOutputSign) {
    this.knk_1 = formatter;
    this.lnk_1 = allSubFormatsNegative;
    this.mnk_1 = alwaysOutputSign;
  }
  protoOf(SignedFormatter).hnk = function (obj, builder, minusNotRequired) {
    var tmp;
    if (!minusNotRequired && this.lnk_1(obj)) {
      tmp = _Char___init__impl__6a9atx(45);
    } else if (this.mnk_1) {
      tmp = _Char___init__impl__6a9atx(43);
    } else {
      tmp = null;
    }
    var sign = tmp;
    var tmp_0 = sign;
    if ((tmp_0 == null ? null : new Char(tmp_0)) == null)
      null;
    else {
      var tmp_1 = sign;
      // Inline function 'kotlin.let' call
      var it = (tmp_1 == null ? null : new Char(tmp_1)).f2_1;
      builder.s(it);
    }
    var tmp_2;
    if (minusNotRequired) {
      tmp_2 = true;
    } else {
      var tmp_3 = sign;
      tmp_2 = equals(tmp_3 == null ? null : new Char(tmp_3), new Char(_Char___init__impl__6a9atx(45)));
    }
    this.knk_1.hnk(obj, builder, tmp_2);
  };
  function ConditionalFormatter(formatters) {
    this.nnk_1 = formatters;
  }
  protoOf(ConditionalFormatter).hnk = function (obj, builder, minusNotRequired) {
    var _iterator__ex2g4s = this.nnk_1.t();
    while (_iterator__ex2g4s.u()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.v();
      var condition = _destruct__k2r9zo.zh();
      var formatter = _destruct__k2r9zo.ai();
      if (condition(obj)) {
        formatter.hnk(obj, builder, minusNotRequired);
        return Unit_instance;
      }
    }
  };
  function ConcatenatedFormatter(formatters) {
    this.onk_1 = formatters;
  }
  protoOf(ConcatenatedFormatter).hnk = function (obj, builder, minusNotRequired) {
    var _iterator__ex2g4s = this.onk_1.t();
    while (_iterator__ex2g4s.u()) {
      var formatter = _iterator__ex2g4s.v();
      formatter.hnk(obj, builder, minusNotRequired);
    }
  };
  function UnsignedIntFormatterStructure(number, zeroPadding) {
    this.pnk_1 = number;
    this.qnk_1 = zeroPadding;
    // Inline function 'kotlin.require' call
    if (!(this.qnk_1 >= 0)) {
      var message = 'The minimum number of digits (' + this.qnk_1 + ') is negative';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.qnk_1 <= 9)) {
      var message_0 = 'The minimum number of digits (' + this.qnk_1 + ') exceeds the length of an Int';
      throw IllegalArgumentException_init_$Create$(toString_0(message_0));
    }
  }
  protoOf(UnsignedIntFormatterStructure).hnk = function (obj, builder, minusNotRequired) {
    var num = this.pnk_1(obj);
    var numberStr = num.toString();
    // Inline function 'kotlin.repeat' call
    var times = this.qnk_1 - numberStr.length | 0;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        builder.s(_Char___init__impl__6a9atx(48));
      }
       while (inductionVariable < times);
    builder.k1(numberStr);
  };
  function DecimalFractionFormatterStructure(number, minDigits, maxDigits, zerosToAdd) {
    this.rnk_1 = number;
    this.snk_1 = minDigits;
    this.tnk_1 = maxDigits;
    this.unk_1 = zerosToAdd;
    var containsArg = this.snk_1;
    // Inline function 'kotlin.require' call
    if (!(1 <= containsArg ? containsArg <= 9 : false)) {
      var message = 'The minimum number of digits (' + this.snk_1 + ') is not in range 1..9';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    var containsLower = this.snk_1;
    var containsArg_0 = this.tnk_1;
    // Inline function 'kotlin.require' call
    if (!(containsLower <= containsArg_0 ? containsArg_0 <= 9 : false)) {
      var message_0 = 'The maximum number of digits (' + this.tnk_1 + ') is not in range ' + this.snk_1 + '..9';
      throw IllegalArgumentException_init_$Create$(toString_0(message_0));
    }
  }
  protoOf(DecimalFractionFormatterStructure).hnk = function (obj, builder, minusNotRequired) {
    var number = this.rnk_1(obj);
    var numberWithRequiredPrecision = number.qna(this.tnk_1);
    var zerosToStrip = 0;
    while (this.tnk_1 > (this.snk_1 + zerosToStrip | 0) && (numberWithRequiredPrecision % get_POWERS_OF_TEN()[zerosToStrip + 1 | 0] | 0) === 0) {
      zerosToStrip = zerosToStrip + 1 | 0;
    }
    var zerosToAddBack = this.unk_1.l1((this.tnk_1 - zerosToStrip | 0) - 1 | 0);
    if (zerosToStrip >= zerosToAddBack)
      zerosToStrip = zerosToStrip - zerosToAddBack | 0;
    var digitsToOutput = this.tnk_1 - zerosToStrip | 0;
    var numberToOutput = numberWithRequiredPrecision / get_POWERS_OF_TEN()[zerosToStrip] | 0;
    builder.k1(substring_0((numberToOutput + get_POWERS_OF_TEN()[digitsToOutput] | 0).toString(), 1));
  };
  function SignedIntFormatterStructure(number, zeroPadding, outputPlusOnExceededWidth) {
    this.vnk_1 = number;
    this.wnk_1 = zeroPadding;
    this.xnk_1 = outputPlusOnExceededWidth;
    // Inline function 'kotlin.require' call
    if (!(this.wnk_1 >= 0)) {
      var message = 'The minimum number of digits (' + this.wnk_1 + ') is negative';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.wnk_1 <= 9)) {
      var message_0 = 'The minimum number of digits (' + this.wnk_1 + ') exceeds the length of an Int';
      throw IllegalArgumentException_init_$Create$(toString_0(message_0));
    }
  }
  protoOf(SignedIntFormatterStructure).hnk = function (obj, builder, minusNotRequired) {
    var innerBuilder = StringBuilder_init_$Create$();
    // Inline function 'kotlin.let' call
    var it = this.vnk_1(obj);
    var number = minusNotRequired && it < 0 ? -it | 0 : it;
    if (!(this.xnk_1 == null) && number >= get_POWERS_OF_TEN()[this.xnk_1]) {
      innerBuilder.s(_Char___init__impl__6a9atx(43));
    }
    // Inline function 'kotlin.math.absoluteValue' call
    if (abs(number) < get_POWERS_OF_TEN()[this.wnk_1 - 1 | 0]) {
      if (number >= 0) {
        innerBuilder.ed(number + get_POWERS_OF_TEN()[this.wnk_1] | 0).ld(0);
      } else {
        innerBuilder.ed(number - get_POWERS_OF_TEN()[this.wnk_1] | 0).ld(1);
      }
    } else {
      innerBuilder.ed(number);
    }
    builder.k1(innerBuilder);
  };
  function ReducedIntFormatterStructure(number, digits, base) {
    this.ynk_1 = number;
    this.znk_1 = digits;
    this.anl_1 = base;
  }
  protoOf(ReducedIntFormatterStructure).hnk = function (obj, builder, minusNotRequired) {
    var number = this.ynk_1(obj);
    var containsUpper = get_POWERS_OF_TEN()[this.znk_1];
    var containsArg = number - this.anl_1 | 0;
    if (0 <= containsArg ? containsArg < containsUpper : false) {
      var numberStr = (number % get_POWERS_OF_TEN()[this.znk_1] | 0).toString();
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = this.znk_1 - numberStr.length | 0;
      var tmp$ret$0 = Math.max(0, b);
      var zeroPaddingStr = repeat('0', tmp$ret$0);
      append(builder, [zeroPaddingStr, numberStr]);
    } else {
      if (number >= 0) {
        builder.k1('+');
      }
      builder.k1(number.toString());
    }
  };
  function ConstantStringFormatterStructure(string) {
    this.bnl_1 = string;
  }
  protoOf(ConstantStringFormatterStructure).hnk = function (obj, builder, minusNotRequired) {
    builder.k1(this.bnl_1);
  };
  function FractionPartConsumer(minLength, maxLength, setter, name) {
    NumberConsumer.call(this, minLength === maxLength ? minLength : null, name);
    this.enl_1 = minLength;
    this.fnl_1 = maxLength;
    this.gnl_1 = setter;
    var containsArg = this.enl_1;
    // Inline function 'kotlin.require' call
    if (!(1 <= containsArg ? containsArg <= 9 : false)) {
      var message = 'Invalid minimum length ' + this.enl_1 + ' for field ' + this.inl_1 + ': expected 1..9';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    var containsLower = this.enl_1;
    var containsArg_0 = this.fnl_1;
    // Inline function 'kotlin.require' call
    if (!(containsLower <= containsArg_0 ? containsArg_0 <= 9 : false)) {
      var message_0 = 'Invalid maximum length ' + this.fnl_1 + ' for field ' + this.inl_1 + ': expected ' + this.enl_1 + '..9';
      throw IllegalArgumentException_init_$Create$(toString_0(message_0));
    }
  }
  protoOf(FractionPartConsumer).jnl = function (storage, input, start, end) {
    return (end - start | 0) < this.enl_1 ? new TooFewDigits(this.enl_1) : (end - start | 0) > this.fnl_1 ? new TooManyDigits(this.fnl_1) : setWithoutReassigning(this.gnl_1, storage, new DecimalFraction(parseAsciiInt(input, start, end), end - start | 0));
  };
  function ConstantNumberConsumer(expected) {
    NumberConsumer.call(this, expected.length, 'the predefined string ' + expected);
    this.mnl_1 = expected;
  }
  protoOf(ConstantNumberConsumer).jnl = function (storage, input, start, end) {
    var tmp;
    // Inline function 'kotlin.text.substring' call
    if (toString_0(charSequenceSubSequence(input, start, end)) === this.mnl_1) {
      tmp = null;
    } else {
      tmp = new WrongConstant(this.mnl_1);
    }
    return tmp;
  };
  function NumberConsumer(length, whatThisExpects) {
    this.hnl_1 = length;
    this.inl_1 = whatThisExpects;
  }
  protoOf(NumberConsumer).a = function () {
    return this.hnl_1;
  };
  function ExpectedInt() {
  }
  protoOf(ExpectedInt).nnl = function () {
    return 'expected an Int value';
  };
  var ExpectedInt_instance;
  function ExpectedInt_getInstance() {
    return ExpectedInt_instance;
  }
  function TooManyDigits(maxDigits) {
    this.onl_1 = maxDigits;
  }
  protoOf(TooManyDigits).nnl = function () {
    return 'expected at most ' + this.onl_1 + ' digits';
  };
  function TooFewDigits(minDigits) {
    this.pnl_1 = minDigits;
  }
  protoOf(TooFewDigits).nnl = function () {
    return 'expected at least ' + this.pnl_1 + ' digits';
  };
  function WrongConstant(expected) {
    this.qnl_1 = expected;
  }
  protoOf(WrongConstant).nnl = function () {
    return "expected '" + this.qnl_1 + "'";
  };
  function Conflicting(conflicting) {
    this.rnl_1 = conflicting;
  }
  protoOf(Conflicting).nnl = function () {
    return "attempted to overwrite the existing value '" + toString_0(this.rnl_1) + "'";
  };
  function setWithoutReassigning(_this__u8e3s4, receiver, value) {
    var tmp0_elvis_lhs = _this__u8e3s4.mnj(receiver, value);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var conflictingValue = tmp;
    return new Conflicting(conflictingValue);
  }
  function parseAsciiInt(_this__u8e3s4, start, end) {
    var result = 0;
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = charSequenceGet(_this__u8e3s4, i);
        result = imul(result, 10) + asciiDigitToInt(digit) | 0;
      }
       while (inductionVariable < end);
    return result;
  }
  function UnsignedIntConsumer(minLength, maxLength, setter, name, multiplyByMinus1) {
    multiplyByMinus1 = multiplyByMinus1 === VOID ? false : multiplyByMinus1;
    NumberConsumer.call(this, minLength == maxLength ? minLength : null, name);
    this.unl_1 = minLength;
    this.vnl_1 = maxLength;
    this.wnl_1 = setter;
    this.xnl_1 = multiplyByMinus1;
    // Inline function 'kotlin.require' call
    if (!(this.a() == null || numberRangeToNumber(1, 9).dm(this.a()))) {
      var message = 'Invalid length for field ' + this.inl_1 + ': ' + this.a();
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
  }
  protoOf(UnsignedIntConsumer).jnl = function (storage, input, start, end) {
    var tmp;
    if (!(this.vnl_1 == null) && (end - start | 0) > this.vnl_1) {
      tmp = new TooManyDigits(this.vnl_1);
    } else if (!(this.unl_1 == null) && (end - start | 0) < this.unl_1) {
      tmp = new TooFewDigits(this.unl_1);
    } else {
      var result = parseAsciiIntOrNull(input, start, end);
      tmp = result == null ? ExpectedInt_instance : setWithoutReassigning(this.wnl_1, storage, this.xnl_1 ? -result | 0 : result);
    }
    return tmp;
  };
  function ReducedIntConsumer(length, setter, name, base) {
    NumberConsumer.call(this, length, name);
    this.anm_1 = length;
    this.bnm_1 = setter;
    this.cnm_1 = base;
    this.dnm_1 = get_POWERS_OF_TEN()[this.anm_1];
    this.enm_1 = this.cnm_1 % this.dnm_1 | 0;
    this.fnm_1 = this.cnm_1 - this.enm_1 | 0;
    var containsArg = this.anm_1;
    // Inline function 'kotlin.require' call
    if (!(1 <= containsArg ? containsArg <= 9 : false)) {
      var message = 'Invalid length for field ' + this.inl_1 + ': ' + this.anm_1;
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
  }
  protoOf(ReducedIntConsumer).a = function () {
    return this.anm_1;
  };
  protoOf(ReducedIntConsumer).jnl = function (storage, input, start, end) {
    var result = parseAsciiInt(input, start, end);
    var tmp;
    if (result >= this.enm_1) {
      tmp = this.fnm_1 + result | 0;
    } else {
      tmp = (this.fnm_1 + this.dnm_1 | 0) + result | 0;
    }
    return setWithoutReassigning(this.bnm_1, storage, tmp);
  };
  function parseAsciiIntOrNull(_this__u8e3s4, start, end) {
    var result = 0;
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = charSequenceGet(_this__u8e3s4, i);
        result = imul(result, 10) + asciiDigitToInt(digit) | 0;
        if (result < 0)
          return null;
      }
       while (inductionVariable < end);
    return result;
  }
  function ParseError(position, message) {
    this.gnm_1 = position;
    this.hnm_1 = message;
  }
  function _ParseResult___init__impl__gvz3cn(value) {
    return value;
  }
  function _ParseResult___get_value__impl__86mnxf($this) {
    return $this;
  }
  function Companion_18() {
  }
  protoOf(Companion_18).inm = function (indexOfNextUnparsed) {
    return _ParseResult___init__impl__gvz3cn(indexOfNextUnparsed);
  };
  protoOf(Companion_18).jnm = function (position, message) {
    return _ParseResult___init__impl__gvz3cn(new ParseError(position, message));
  };
  var Companion_instance_19;
  function Companion_getInstance_19() {
    return Companion_instance_19;
  }
  function _Parser___init__impl__gdyfby(commands) {
    return commands;
  }
  function _get_commands__a20n1($this) {
    return $this;
  }
  function Parser__match_impl_nzt83d($this, input, initialContainer, startIndex) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var errors = ArrayList_init_$Create$_0();
    // Inline function 'kotlinx.datetime.internal.format.parser.Parser.parse' call
    var parseOptions = mutableListOf([new ParserState(initialContainer, _get_commands__a20n1($this), startIndex)]);
    iterate_over_alternatives: while (true) {
      var tmp0_elvis_lhs = removeLastOrNull(parseOptions);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break iterate_over_alternatives;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var state = tmp;
      var output = state.knm_1.xbr();
      var inputPosition = state.mnm_1;
      var parserStructure = state.lnm_1;
      // Inline function 'kotlin.run' call
      $l$block: {
        var inductionVariable = 0;
        var last = parserStructure.onm_1.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var ix = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlinx.datetime.internal.format.parser.ParseResult.match' call
            var this_0 = parserStructure.onm_1.l1(ix).qnm(output, input, inputPosition);
            var tmp0_subject = _ParseResult___get_value__impl__86mnxf(this_0);
            if (typeof tmp0_subject === 'number') {
              inputPosition = _ParseResult___get_value__impl__86mnxf(this_0);
            } else {
              if (tmp0_subject instanceof ParseError) {
                var it = _ParseResult___get_value__impl__86mnxf(this_0);
                errors.j1(it);
                break $l$block;
              } else {
                // Inline function 'kotlin.error' call
                var message = 'Unexpected parse result: ' + toString_0(_ParseResult___get_value__impl__86mnxf(this_0));
                throw IllegalStateException_init_$Create$(toString_0(message));
              }
            }
          }
           while (inductionVariable <= last);
        if (parserStructure.pnm_1.r()) {
          if (false || inputPosition === charSequenceLength(input)) {
            return output;
          } else {
            var tmp_0 = inputPosition;
            var it_0 = new ParseError(tmp_0, Parser$match$lambda);
            errors.j1(it_0);
          }
        } else {
          var inductionVariable_0 = parserStructure.pnm_1.n1() - 1 | 0;
          if (0 <= inductionVariable_0)
            do {
              var ix_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              parseOptions.j1(new ParserState(output, parserStructure.pnm_1.l1(ix_0), inputPosition));
            }
             while (0 <= inductionVariable_0);
        }
      }
    }
    // Inline function 'kotlin.collections.sortByDescending' call
    if (errors.n1() > 1) {
      // Inline function 'kotlin.comparisons.compareByDescending' call
      var tmp_1 = Parser$match$lambda_0;
      var tmp$ret$12 = new sam$kotlin_Comparator$0(tmp_1);
      sortWith(errors, tmp$ret$12);
    }
    throw new ParseException(errors);
  }
  function Parser__match$default_impl_x2xlti($this, input, initialContainer, startIndex, $super) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    var tmp;
    if ($super === VOID) {
      tmp = Parser__match_impl_nzt83d($this, input, initialContainer, startIndex);
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new Parser(tmp_0)).rnm.call(new Parser($this), input, initialContainer, startIndex);
    }
    return tmp;
  }
  function ParserState(output, parserStructure, inputPosition) {
    this.knm_1 = output;
    this.lnm_1 = parserStructure;
    this.mnm_1 = inputPosition;
  }
  function Parser__toString_impl_x33iea($this) {
    return 'Parser(commands=' + $this.toString() + ')';
  }
  function Parser__hashCode_impl_bbxllf($this) {
    return hashCode($this);
  }
  function Parser__equals_impl_djxokv($this, other) {
    if (!(other instanceof Parser))
      return false;
    var tmp0_other_with_cast = other instanceof Parser ? other.nnm_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.snm_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).ze = function (a, b) {
    return this.snm_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).q3 = function () {
    return this.snm_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function Parser$match$lambda() {
    return 'There is more input to consume';
  }
  function Parser$match$lambda_0(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = b.gnm_1;
    var tmp$ret$2 = a.gnm_1;
    return compareValues(tmp, tmp$ret$2);
  }
  function Parser(commands) {
    this.nnm_1 = commands;
  }
  protoOf(Parser).toString = function () {
    return Parser__toString_impl_x33iea(this.nnm_1);
  };
  protoOf(Parser).hashCode = function () {
    return Parser__hashCode_impl_bbxllf(this.nnm_1);
  };
  protoOf(Parser).equals = function (other) {
    return Parser__equals_impl_djxokv(this.nnm_1, other);
  };
  function ParserStructure(operations, followedBy) {
    this.onm_1 = operations;
    this.pnm_1 = followedBy;
  }
  protoOf(ParserStructure).toString = function () {
    return joinToString(this.onm_1, ', ') + '(' + joinToString(this.pnm_1, ';') + ')';
  };
  function Companion_19() {
    Companion_instance_20 = this;
    this.tnm_1 = new Long(-1040988569, 1325082731);
  }
  var Companion_instance_20;
  function Companion_getInstance_20() {
    if (Companion_instance_20 == null)
      new Companion_19();
    return Companion_instance_20;
  }
  function ParseException(errors) {
    Companion_getInstance_20();
    Exception_init_$Init$(formatError(errors), this);
    captureStack(this, ParseException);
  }
  function concat(_this__u8e3s4) {
    var result = {_v: new ParserStructure(emptyList(), emptyList())};
    // Inline function 'kotlin.collections.mutableListOf' call
    var accumulatedOperations = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = asReversed(_this__u8e3s4).t();
    while (_iterator__ex2g4s.u()) {
      var parser = _iterator__ex2g4s.v();
      if (parser.pnm_1.r()) {
        accumulatedOperations.j1(parser.onm_1);
      } else {
        concat$flushAccumulatedOperations(accumulatedOperations, result);
        result._v = concat$simplifyAndAppend(parser, result._v);
      }
    }
    concat$flushAccumulatedOperations(accumulatedOperations, result);
    return result._v;
  }
  function formatError(errors) {
    if (errors.n1() === 1) {
      return 'Position ' + errors.l1(0).gnm_1 + ': ' + errors.l1(0).hnm_1();
    }
    var averageMessageLength = 33;
    var tmp0_buffer = StringBuilder_init_$Create$_0(imul(averageMessageLength, errors.n1()));
    return joinTo(errors, tmp0_buffer, ', ', 'Errors: ', VOID, VOID, VOID, formatError$lambda).toString();
  }
  function concat$mergeOperations(baseOperations, numberSpan, unconditionalModifications, simplifiedParserStructure) {
    var operationsToMerge = simplifiedParserStructure.onm_1;
    var firstOperation = firstOrNull(operationsToMerge);
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$_0();
    this_0.o1(baseOperations);
    if (numberSpan == null) {
      this_0.o1(operationsToMerge);
    } else {
      if (firstOperation instanceof NumberSpanParserOperation) {
        this_0.j1(new NumberSpanParserOperation(plus_0(numberSpan, firstOperation.unm_1)));
        var inductionVariable = 1;
        var last = get_lastIndex_0(operationsToMerge);
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this_0.j1(operationsToMerge.l1(i));
          }
           while (!(i === last));
      } else {
        this_0.j1(new NumberSpanParserOperation(numberSpan));
        this_0.o1(operationsToMerge);
      }
    }
    this_0.o1(unconditionalModifications);
    var mergedOperations = this_0.t5();
    return new ParserStructure(mergedOperations, simplifiedParserStructure.pnm_1);
  }
  function concat$simplifyAndAppend(_this__u8e3s4, other) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var newOperations = ArrayList_init_$Create$_0();
    var currentNumberSpan = null;
    // Inline function 'kotlin.collections.mutableListOf' call
    var unconditionalModifications = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = _this__u8e3s4.onm_1.t();
    while (_iterator__ex2g4s.u()) {
      var op = _iterator__ex2g4s.v();
      if (op instanceof NumberSpanParserOperation) {
        if (!(currentNumberSpan == null)) {
          currentNumberSpan.o1(op.unm_1);
        } else {
          currentNumberSpan = toMutableList(op.unm_1);
        }
      } else {
        if (op instanceof UnconditionalModification)
          unconditionalModifications.j1(op);
        else {
          if (!(currentNumberSpan == null)) {
            newOperations.j1(new NumberSpanParserOperation(currentNumberSpan));
            currentNumberSpan = null;
            newOperations.o1(unconditionalModifications);
            unconditionalModifications.c3();
          }
          newOperations.j1(op);
        }
      }
    }
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = _this__u8e3s4.pnm_1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_0 = tmp0.t();
    while (_iterator__ex2g4s_0.u()) {
      var element = _iterator__ex2g4s_0.v();
      var simplified = concat$simplifyAndAppend(element, other);
      var tmp;
      if (simplified.onm_1.r()) {
        // Inline function 'kotlin.collections.ifEmpty' call
        var this_0 = simplified.pnm_1;
        var tmp_0;
        if (this_0.r()) {
          tmp_0 = listOf_0(simplified);
        } else {
          tmp_0 = this_0;
        }
        tmp = tmp_0;
      } else {
        tmp = listOf_0(simplified);
      }
      var list = tmp;
      addAll(destination, list);
    }
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp_1;
    if (destination.r()) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!other.onm_1.r()) {
        return concat$mergeOperations(newOperations, currentNumberSpan, unconditionalModifications, other);
      }
      tmp_1 = other.pnm_1;
    } else {
      tmp_1 = destination;
    }
    var mergedTails = tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    if (currentNumberSpan == null) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_4 = !newOperations.r();
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = true;
    } else {
      var tmp$ret$11;
      $l$block_0: {
        // Inline function 'kotlin.collections.none' call
        var tmp_5;
        if (isInterface(mergedTails, Collection)) {
          tmp_5 = mergedTails.r();
        } else {
          tmp_5 = false;
        }
        if (tmp_5) {
          tmp$ret$11 = true;
          break $l$block_0;
        }
        var _iterator__ex2g4s_1 = mergedTails.t();
        while (_iterator__ex2g4s_1.u()) {
          var element_0 = _iterator__ex2g4s_1.v();
          var tmp_6 = firstOrNull(element_0.onm_1);
          if (tmp_6 instanceof NumberSpanParserOperation) {
            tmp$ret$11 = false;
            break $l$block_0;
          }
        }
        tmp$ret$11 = true;
      }
      tmp_3 = tmp$ret$11;
    }
    if (tmp_3) {
      if (!(currentNumberSpan == null)) {
        newOperations.j1(new NumberSpanParserOperation(currentNumberSpan));
      }
      newOperations.o1(unconditionalModifications);
      tmp_2 = new ParserStructure(newOperations, mergedTails);
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(mergedTails, 10));
      var _iterator__ex2g4s_2 = mergedTails.t();
      while (_iterator__ex2g4s_2.u()) {
        var item = _iterator__ex2g4s_2.v();
        var tmp$ret$15 = concat$mergeOperations(emptyList(), currentNumberSpan, unconditionalModifications, item);
        destination_0.j1(tmp$ret$15);
      }
      var newTails = destination_0;
      tmp_2 = new ParserStructure(newOperations, newTails);
    }
    return tmp_2;
  }
  function concat$flushAccumulatedOperations(accumulatedOperations, result) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!accumulatedOperations.r()) {
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s = asReversed_0(accumulatedOperations).t();
      while (_iterator__ex2g4s.u()) {
        var parserOperations = _iterator__ex2g4s.v();
        this_0.o1(parserOperations);
      }
      var operations = this_0.t5();
      result._v = concat$simplifyAndAppend(new ParserStructure(operations, emptyList()), result._v);
      accumulatedOperations.c3();
    }
  }
  function formatError$lambda(it) {
    return 'position ' + it.gnm_1 + ": '" + it.hnm_1() + "'";
  }
  function spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name, withMinus) {
    withMinus = withMinus === VOID ? false : withMinus;
    var minNumberLength = (minDigits == null ? 1 : minDigits) + (withMinus ? 1 : 0) | 0;
    var tmp;
    if (maxDigits == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = withMinus ? maxDigits + 1 | 0 : maxDigits;
    }
    var tmp2_elvis_lhs = tmp;
    var maxNumberLength = tmp2_elvis_lhs == null ? 2147483647 : tmp2_elvis_lhs;
    var spacePadding_0 = spacePadding == null ? 0 : spacePadding;
    // Inline function 'kotlin.comparisons.minOf' call
    var maxPaddedNumberLength = Math.min(maxNumberLength, spacePadding_0);
    if (minNumberLength >= maxPaddedNumberLength)
      return spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, minNumberLength, maxNumberLength);
    var accumulated = spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, minNumberLength, minNumberLength);
    var inductionVariable = minNumberLength;
    if (inductionVariable < maxPaddedNumberLength)
      do {
        var accumulatedWidth = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        accumulated = new ParserStructure(emptyList(), listOf([spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, accumulatedWidth + 1 | 0, accumulatedWidth + 1 | 0), concat(listOf([new ParserStructure(listOf_0(new PlainStringParserOperation(' ')), emptyList()), accumulated]))]));
      }
       while (inductionVariable < maxPaddedNumberLength);
    var tmp_0;
    if (spacePadding_0 > maxNumberLength) {
      var prepadding = new PlainStringParserOperation(repeat(' ', spacePadding_0 - maxNumberLength | 0));
      tmp_0 = concat(listOf([new ParserStructure(listOf_0(prepadding), emptyList()), accumulated]));
    } else if (spacePadding_0 === maxNumberLength) {
      tmp_0 = accumulated;
    } else {
      var r = new ParserStructure(emptyList(), listOf([spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, spacePadding_0 + 1 | 0, maxNumberLength), accumulated]));
      tmp_0 = r;
    }
    return tmp_0;
  }
  function _get_whatThisExpects__4pg11j($this) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this.unm_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var length = item.a();
      var tmp$ret$2 = (length == null ? 'at least one digit' : '' + length + ' digits') + (' for ' + item.inl_1);
      destination.j1(tmp$ret$2);
    }
    var consumerLengths = destination;
    var tmp;
    if ($this.wnm_1) {
      tmp = 'a number with at least ' + $this.vnm_1 + ' digits: ' + toString_0(consumerLengths);
    } else {
      tmp = 'a number with exactly ' + $this.vnm_1 + ' digits: ' + toString_0(consumerLengths);
    }
    return tmp;
  }
  function NumberSpanParserOperation$consume$lambda(this$0) {
    return function () {
      return 'Unexpected end of input: yet to parse ' + _get_whatThisExpects__4pg11j(this$0);
    };
  }
  function NumberSpanParserOperation$consume$lambda_0($digitsInRow, this$0) {
    return function () {
      return 'Only found ' + $digitsInRow._v + ' digits in a row, but need to parse ' + _get_whatThisExpects__4pg11j(this$0);
    };
  }
  function NumberSpanParserOperation$consume$lambda_1($numberString, this$0, $i, $error) {
    return function () {
      return "Can not interpret the string '" + $numberString + "' as " + this$0.unm_1.l1($i).inl_1 + ': ' + $error.nnl();
    };
  }
  function NumberSpanParserOperation(consumers) {
    this.unm_1 = consumers;
    var tmp = this;
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = this.unm_1.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp_0 = sum;
      var tmp0_elvis_lhs = element.a();
      sum = tmp_0 + (tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs) | 0;
    }
    tmp.vnm_1 = sum;
    var tmp_1 = this;
    var tmp0 = this.unm_1;
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_2;
      if (isInterface(tmp0, Collection)) {
        tmp_2 = tmp0.r();
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp$ret$2 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = tmp0.t();
      while (_iterator__ex2g4s_0.u()) {
        var element_0 = _iterator__ex2g4s_0.v();
        if (element_0.a() == null) {
          tmp$ret$2 = true;
          break $l$block_0;
        }
      }
      tmp$ret$2 = false;
    }
    tmp_1.wnm_1 = tmp$ret$2;
    var tmp0_0 = this.unm_1;
    var tmp$ret$4;
    $l$block_2: {
      // Inline function 'kotlin.collections.all' call
      var tmp_3;
      if (isInterface(tmp0_0, Collection)) {
        tmp_3 = tmp0_0.r();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$4 = true;
        break $l$block_2;
      }
      var _iterator__ex2g4s_1 = tmp0_0.t();
      while (_iterator__ex2g4s_1.u()) {
        var element_1 = _iterator__ex2g4s_1.v();
        var tmp0_elvis_lhs_0 = element_1.a();
        if (!((tmp0_elvis_lhs_0 == null ? 2147483647 : tmp0_elvis_lhs_0) > 0)) {
          tmp$ret$4 = false;
          break $l$block_2;
        }
      }
      tmp$ret$4 = true;
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!tmp$ret$4) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    var tmp0_1 = this.unm_1;
    var tmp$ret$9;
    $l$block_3: {
      // Inline function 'kotlin.collections.count' call
      var tmp_4;
      if (isInterface(tmp0_1, Collection)) {
        tmp_4 = tmp0_1.r();
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        tmp$ret$9 = 0;
        break $l$block_3;
      }
      var count = 0;
      var _iterator__ex2g4s_2 = tmp0_1.t();
      while (_iterator__ex2g4s_2.u()) {
        var element_2 = _iterator__ex2g4s_2.v();
        if (element_2.a() == null) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$9 = count;
    }
    // Inline function 'kotlin.require' call
    if (!(tmp$ret$9 <= 1)) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0_2 = this.unm_1;
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_3 = tmp0_2.t();
      while (_iterator__ex2g4s_3.u()) {
        var element_3 = _iterator__ex2g4s_3.v();
        if (element_3.a() == null) {
          destination.j1(element_3);
        }
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
      var _iterator__ex2g4s_4 = destination.t();
      while (_iterator__ex2g4s_4.u()) {
        var item = _iterator__ex2g4s_4.v();
        var tmp$ret$18 = item.inl_1;
        destination_0.j1(tmp$ret$18);
      }
      var fieldNames = destination_0;
      var message_0 = 'At most one variable-length numeric field in a row is allowed, but got several: ' + toString_0(fieldNames) + '. ' + "Parsing is undefined: for example, with variable-length month number and variable-length day of month, '111' can be parsed as Jan 11th or Nov 1st.";
      throw IllegalArgumentException_init_$Create$(toString_0(message_0));
    }
  }
  protoOf(NumberSpanParserOperation).qnm = function (storage, input, startIndex) {
    if ((startIndex + this.vnm_1 | 0) > charSequenceLength(input)) {
      var tmp = Companion_instance_19;
      return tmp.jnm(startIndex, NumberSpanParserOperation$consume$lambda(this));
    }
    var digitsInRow = {_v: 0};
    while ((startIndex + digitsInRow._v | 0) < charSequenceLength(input) && isAsciiDigit(charSequenceGet(input, startIndex + digitsInRow._v | 0))) {
      digitsInRow._v = digitsInRow._v + 1 | 0;
      digitsInRow._v;
    }
    if (digitsInRow._v < this.vnm_1) {
      var tmp_0 = Companion_instance_19;
      return tmp_0.jnm(startIndex, NumberSpanParserOperation$consume$lambda_0(digitsInRow, this));
    }
    var index = startIndex;
    var inductionVariable = 0;
    var last = this.unm_1.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_elvis_lhs = this.unm_1.l1(i).a();
        var length = tmp0_elvis_lhs == null ? (digitsInRow._v - this.vnm_1 | 0) + 1 | 0 : tmp0_elvis_lhs;
        var error = this.unm_1.l1(i).jnl(storage, input, index, index + length | 0);
        if (!(error == null)) {
          var tmp2 = index;
          // Inline function 'kotlin.text.substring' call
          var endIndex = index + length | 0;
          var numberString = toString_0(charSequenceSubSequence(input, tmp2, endIndex));
          var tmp_1 = Companion_instance_19;
          var tmp_2 = index;
          return tmp_1.jnm(tmp_2, NumberSpanParserOperation$consume$lambda_1(numberString, this, i, error));
        }
        index = index + length | 0;
      }
       while (inductionVariable <= last);
    return Companion_instance_19.inm(index);
  };
  protoOf(NumberSpanParserOperation).toString = function () {
    return _get_whatThisExpects__4pg11j(this);
  };
  function SignedIntParser(minDigits, maxDigits, spacePadding, setter, name, plusOnExceedsWidth) {
    var parsers = mutableListOf([spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name, true)]);
    if (!(plusOnExceedsWidth == null)) {
      parsers.j1(spaceAndZeroPaddedUnsignedInt(minDigits, plusOnExceedsWidth, spacePadding, setter, name));
      parsers.j1(new ParserStructure(listOf([new PlainStringParserOperation('+'), new NumberSpanParserOperation(listOf_0(new UnsignedIntConsumer(plusOnExceedsWidth + 1 | 0, maxDigits, setter, name, false)))]), emptyList()));
    } else {
      parsers.j1(spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name));
    }
    return new ParserStructure(emptyList(), parsers);
  }
  function ReducedIntParser(digits, base, setter, name) {
    return new ParserStructure(emptyList(), listOf([new ParserStructure(listOf_0(new NumberSpanParserOperation(listOf_0(new ReducedIntConsumer(digits, setter, name, base)))), emptyList()), new ParserStructure(listOf([new PlainStringParserOperation('+'), new NumberSpanParserOperation(listOf_0(new UnsignedIntConsumer(null, null, setter, name, false)))]), emptyList()), new ParserStructure(listOf([new PlainStringParserOperation('-'), new NumberSpanParserOperation(listOf_0(new UnsignedIntConsumer(null, null, setter, name, true)))]), emptyList())]));
  }
  function PlainStringParserOperation$consume$lambda(this$0) {
    return function () {
      return "Unexpected end of input: yet to parse '" + this$0.xnm_1 + "'";
    };
  }
  function PlainStringParserOperation$consume$lambda_0(this$0, $input, $startIndex, $i) {
    return function () {
      var tmp0 = $input;
      var tmp2 = $startIndex;
      // Inline function 'kotlin.text.substring' call
      var endIndex = ($startIndex + $i | 0) + 1 | 0;
      var tmp$ret$0 = toString_0(charSequenceSubSequence(tmp0, tmp2, endIndex));
      return 'Expected ' + this$0.xnm_1 + ' but got ' + tmp$ret$0;
    };
  }
  function PlainStringParserOperation(string) {
    this.xnm_1 = string;
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.xnm_1;
    // Inline function 'kotlin.require' call
    if (!(charSequenceLength(this_0) > 0)) {
      var message = 'Empty string is not allowed';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    // Inline function 'kotlin.require' call
    if (!!isAsciiDigit(charCodeAt(this.xnm_1, 0))) {
      var message_0 = "String '" + this.xnm_1 + "' starts with a digit";
      throw IllegalArgumentException_init_$Create$(toString_0(message_0));
    }
    // Inline function 'kotlin.require' call
    if (!!isAsciiDigit(charCodeAt(this.xnm_1, this.xnm_1.length - 1 | 0))) {
      var message_1 = "String '" + this.xnm_1 + "' ends with a digit";
      throw IllegalArgumentException_init_$Create$(toString_0(message_1));
    }
  }
  protoOf(PlainStringParserOperation).qnm = function (storage, input, startIndex) {
    if ((startIndex + this.xnm_1.length | 0) > charSequenceLength(input)) {
      var tmp = Companion_instance_19;
      return tmp.jnm(startIndex, PlainStringParserOperation$consume$lambda(this));
    }
    var inductionVariable = 0;
    var last = charSequenceLength(this.xnm_1) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charSequenceGet(input, startIndex + i | 0) === charCodeAt(this.xnm_1, i))) {
          var tmp_0 = Companion_instance_19;
          return tmp_0.jnm(startIndex, PlainStringParserOperation$consume$lambda_0(this, input, startIndex, i));
        }
      }
       while (inductionVariable <= last);
    return Companion_instance_19.inm(startIndex + this.xnm_1.length | 0);
  };
  protoOf(PlainStringParserOperation).toString = function () {
    return "'" + this.xnm_1 + "'";
  };
  function SignParser$consume$lambda(this$0, $char) {
    return function () {
      return 'Expected ' + this$0.ann_1 + ' but got ' + toString($char);
    };
  }
  function SignParser(isNegativeSetter, withPlusSign, whatThisExpects) {
    this.ynm_1 = isNegativeSetter;
    this.znm_1 = withPlusSign;
    this.ann_1 = whatThisExpects;
  }
  protoOf(SignParser).qnm = function (storage, input, startIndex) {
    if (startIndex >= charSequenceLength(input))
      return Companion_instance_19.inm(startIndex);
    var char = charSequenceGet(input, startIndex);
    if (char === _Char___init__impl__6a9atx(45)) {
      this.ynm_1(storage, true);
      return Companion_instance_19.inm(startIndex + 1 | 0);
    }
    if (char === _Char___init__impl__6a9atx(43) && this.znm_1) {
      this.ynm_1(storage, false);
      return Companion_instance_19.inm(startIndex + 1 | 0);
    }
    var tmp = Companion_instance_19;
    return tmp.jnm(startIndex, SignParser$consume$lambda(this, char));
  };
  protoOf(SignParser).toString = function () {
    return this.ann_1;
  };
  function UnconditionalModification(operation) {
    this.bnn_1 = operation;
  }
  protoOf(UnconditionalModification).qnm = function (storage, input, startIndex) {
    this.bnn_1(storage);
    return Companion_instance_19.inm(startIndex);
  };
  function spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths($withMinus, $setter, $name, minNumberLength, maxNumberLength) {
    // Inline function 'kotlin.check' call
    if (!(maxNumberLength >= (1 + ($withMinus ? 1 : 0) | 0))) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$_0();
    if ($withMinus) {
      this_0.j1(new PlainStringParserOperation('-'));
    }
    this_0.j1(new NumberSpanParserOperation(listOf_0(new UnsignedIntConsumer(minNumberLength - ($withMinus ? 1 : 0) | 0, maxNumberLength - ($withMinus ? 1 : 0) | 0, $setter, $name, $withMinus))));
    var tmp$ret$1 = this_0.t5();
    return new ParserStructure(tmp$ret$1, emptyList());
  }
  function get_POWERS_OF_TEN() {
    _init_properties_math_kt__tgcmt4();
    return POWERS_OF_TEN;
  }
  var POWERS_OF_TEN;
  function DecimalFraction(fractionalPart, digits) {
    this.ona_1 = fractionalPart;
    this.pna_1 = digits;
    // Inline function 'kotlin.require' call
    if (!(this.pna_1 >= 0)) {
      var message = 'Digits must be non-negative, but was ' + this.pna_1;
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
  }
  protoOf(DecimalFraction).qna = function (newDigits) {
    return newDigits === this.pna_1 ? this.ona_1 : newDigits > this.pna_1 ? imul(this.ona_1, get_POWERS_OF_TEN()[newDigits - this.pna_1 | 0]) : this.ona_1 / get_POWERS_OF_TEN()[this.pna_1 - newDigits | 0] | 0;
  };
  protoOf(DecimalFraction).cnn = function (other) {
    var tmp0 = this.pna_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = other.pna_1;
    // Inline function 'kotlin.let' call
    var maxPrecision = Math.max(tmp0, b);
    return compareTo(this.qna(maxPrecision), other.qna(maxPrecision));
  };
  protoOf(DecimalFraction).d = function (other) {
    return this.cnn(other instanceof DecimalFraction ? other : THROW_CCE());
  };
  protoOf(DecimalFraction).equals = function (other) {
    var tmp;
    if (other instanceof DecimalFraction) {
      tmp = this.cnn(other) === 0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(DecimalFraction).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    var denominator = get_POWERS_OF_TEN()[this.pna_1];
    this_0.ed(this.ona_1 / denominator | 0);
    this_0.s(_Char___init__impl__6a9atx(46));
    this_0.q(removePrefix((denominator + (this.ona_1 % denominator | 0) | 0).toString(), '1'));
    return this_0.toString();
  };
  protoOf(DecimalFraction).hashCode = function () {
    throw UnsupportedOperationException_init_$Create$('DecimalFraction is not supposed to be used as a hash key');
  };
  function multiplyAndAdd(d, n, r) {
    _init_properties_math_kt__tgcmt4();
    var md = d;
    var mr = r;
    if (compare(d, new Long(0, 0)) > 0 && compare(r, new Long(0, 0)) < 0) {
      var _unary__edvuaz = md;
      md = subtract(_unary__edvuaz, get_ONE());
      mr = add(mr, n);
    } else if (compare(d, new Long(0, 0)) < 0 && compare(r, new Long(0, 0)) > 0) {
      var _unary__edvuaz_0 = md;
      md = add(_unary__edvuaz_0, get_ONE());
      mr = subtract(mr, n);
    }
    return safeAdd(safeMultiply(md, n), mr);
  }
  var properties_initialized_math_kt_amm9wq;
  function _init_properties_math_kt__tgcmt4() {
    if (!properties_initialized_math_kt_amm9wq) {
      properties_initialized_math_kt_amm9wq = true;
      // Inline function 'kotlin.intArrayOf' call
      POWERS_OF_TEN = new Int32Array([1, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000]);
    }
  }
  function isAsciiDigit(_this__u8e3s4) {
    return _Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false;
  }
  function asciiDigitToInt(_this__u8e3s4) {
    return Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(48));
  }
  function DatePeriodSerializer() {
    DatePeriodSerializer_instance = this;
    this.dnn_1 = DatePeriodIso8601Serializer_getInstance();
    this.enn_1 = PrimitiveSerialDescriptor('kotlinx.datetime.DatePeriod', STRING_getInstance());
  }
  protoOf(DatePeriodSerializer).y70 = function () {
    return this.enn_1;
  };
  protoOf(DatePeriodSerializer).fnn = function (encoder, value) {
    this.dnn_1.fnn(encoder, value);
  };
  protoOf(DatePeriodSerializer).z70 = function (encoder, value) {
    return this.fnn(encoder, value instanceof DatePeriod ? value : THROW_CCE());
  };
  protoOf(DatePeriodSerializer).a71 = function (decoder) {
    return this.dnn_1.a71(decoder);
  };
  var DatePeriodSerializer_instance;
  function DatePeriodSerializer_getInstance() {
    if (DatePeriodSerializer_instance == null)
      new DatePeriodSerializer();
    return DatePeriodSerializer_instance;
  }
  function DateTimePeriodSerializer() {
    DateTimePeriodSerializer_instance = this;
    this.hnn_1 = DateTimePeriodIso8601Serializer_getInstance();
    this.inn_1 = PrimitiveSerialDescriptor('kotlinx.datetime.DateTimePeriod', STRING_getInstance());
  }
  protoOf(DateTimePeriodSerializer).y70 = function () {
    return this.inn_1;
  };
  protoOf(DateTimePeriodSerializer).jnn = function (encoder, value) {
    this.hnn_1.jnn(encoder, value);
  };
  protoOf(DateTimePeriodSerializer).z70 = function (encoder, value) {
    return this.jnn(encoder, value instanceof DateTimePeriod ? value : THROW_CCE());
  };
  protoOf(DateTimePeriodSerializer).a71 = function (decoder) {
    return this.hnn_1.a71(decoder);
  };
  var DateTimePeriodSerializer_instance;
  function DateTimePeriodSerializer_getInstance() {
    if (DateTimePeriodSerializer_instance == null)
      new DateTimePeriodSerializer();
    return DateTimePeriodSerializer_instance;
  }
  function DatePeriodIso8601Serializer() {
    DatePeriodIso8601Serializer_instance = this;
    this.gnn_1 = PrimitiveSerialDescriptor('kotlinx.datetime.DatePeriod/ISO', STRING_getInstance());
  }
  protoOf(DatePeriodIso8601Serializer).y70 = function () {
    return this.gnn_1;
  };
  protoOf(DatePeriodIso8601Serializer).a71 = function (decoder) {
    var period = Companion_instance_1.jr(decoder.i74());
    var tmp;
    if (period instanceof DatePeriod) {
      tmp = period;
    } else {
      throw SerializationException_init_$Create$(period.toString() + ' is not a date-based period');
    }
    return tmp;
  };
  protoOf(DatePeriodIso8601Serializer).fnn = function (encoder, value) {
    encoder.r75(value.toString());
  };
  protoOf(DatePeriodIso8601Serializer).z70 = function (encoder, value) {
    return this.fnn(encoder, value instanceof DatePeriod ? value : THROW_CCE());
  };
  var DatePeriodIso8601Serializer_instance;
  function DatePeriodIso8601Serializer_getInstance() {
    if (DatePeriodIso8601Serializer_instance == null)
      new DatePeriodIso8601Serializer();
    return DatePeriodIso8601Serializer_instance;
  }
  function DateTimePeriodIso8601Serializer() {
    DateTimePeriodIso8601Serializer_instance = this;
    this.knn_1 = PrimitiveSerialDescriptor('kotlinx.datetime.DateTimePeriod/ISO', STRING_getInstance());
  }
  protoOf(DateTimePeriodIso8601Serializer).y70 = function () {
    return this.knn_1;
  };
  protoOf(DateTimePeriodIso8601Serializer).a71 = function (decoder) {
    return Companion_instance_1.jr(decoder.i74());
  };
  protoOf(DateTimePeriodIso8601Serializer).jnn = function (encoder, value) {
    encoder.r75(value.toString());
  };
  protoOf(DateTimePeriodIso8601Serializer).z70 = function (encoder, value) {
    return this.jnn(encoder, value instanceof DateTimePeriod ? value : THROW_CCE());
  };
  var DateTimePeriodIso8601Serializer_instance;
  function DateTimePeriodIso8601Serializer_getInstance() {
    if (DateTimePeriodIso8601Serializer_instance == null)
      new DateTimePeriodIso8601Serializer();
    return DateTimePeriodIso8601Serializer_instance;
  }
  function TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
    return buildClassSerialDescriptor('kotlinx.datetime.TimeBased', [], TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
  }
  function TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
    // Inline function 'kotlinx.serialization.descriptors.element' call
    var elementName = 'nanoseconds';
    var annotations = emptyList();
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer(createKType(getKClass(Long), arrayOf([]), false));
    var descriptor = (isInterface(this_0, KSerializer) ? this_0 : THROW_CCE()).y70();
    $this$buildClassSerialDescriptor.j73(elementName, descriptor, annotations, false);
    return Unit_instance;
  }
  function TimeBasedDateTimeUnitSerializer$_get_descriptor_$ref_ezonyw() {
    return constructCallableReference(function (p0) {
      return p0.y70();
    }, 1, 0, 436);
  }
  function TimeBasedDateTimeUnitSerializer() {
    TimeBasedDateTimeUnitSerializer_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.lnn_1 = lazy_0(tmp_0, TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
  }
  protoOf(TimeBasedDateTimeUnitSerializer).y70 = function () {
    var tmp0 = this.lnn_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, TimeBasedDateTimeUnitSerializer$_get_descriptor_$ref_ezonyw(), null);
    return tmp0.u1();
  };
  protoOf(TimeBasedDateTimeUnitSerializer).mnn = function (encoder, value) {
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.y70();
    var composite = encoder.n74(descriptor);
    composite.y75(TimeBasedDateTimeUnitSerializer_getInstance().y70(), 0, value.rn4_1);
    composite.o74(descriptor);
  };
  protoOf(TimeBasedDateTimeUnitSerializer).z70 = function (encoder, value) {
    return this.mnn(encoder, value instanceof TimeBased ? value : THROW_CCE());
  };
  protoOf(TimeBasedDateTimeUnitSerializer).a71 = function (decoder) {
    var seen = {_v: false};
    var nanoseconds = {_v: new Long(0, 0)};
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.y70();
    var composite = decoder.n74(descriptor);
    if (composite.d75()) {
      nanoseconds._v = composite.t74(TimeBasedDateTimeUnitSerializer_getInstance().y70(), 0);
      seen._v = true;
    } else {
      loop: while (true) {
        var elementIndex = composite.e75(TimeBasedDateTimeUnitSerializer_getInstance().y70());
        switch (elementIndex) {
          case 0:
            nanoseconds._v = composite.t74(TimeBasedDateTimeUnitSerializer_getInstance().y70(), 0);
            seen._v = true;
            break;
          case -1:
            break loop;
          default:
            throwUnknownIndexException(elementIndex);
            break;
        }
      }
    }
    var result = Unit_instance;
    composite.o74(descriptor);
    if (!seen._v)
      throw MissingFieldException_init_$Create$('nanoseconds', this.y70().z71());
    return new TimeBased(nanoseconds._v);
  };
  var TimeBasedDateTimeUnitSerializer_instance;
  function TimeBasedDateTimeUnitSerializer_getInstance() {
    if (TimeBasedDateTimeUnitSerializer_instance == null)
      new TimeBasedDateTimeUnitSerializer();
    return TimeBasedDateTimeUnitSerializer_instance;
  }
  function _get_impl__d88w17($this) {
    var tmp0 = $this.nnn_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('impl', 1, tmp, DateBasedDateTimeUnitSerializer$_get_impl_$ref_m860rs(), null);
    return tmp0.u1();
  }
  function DateBasedDateTimeUnitSerializer$impl$delegate$lambda() {
    var tmp = getKClass(DateBased);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(DayBased), getKClass(MonthBased)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [DayBasedDateTimeUnitSerializer_getInstance(), MonthBasedDateTimeUnitSerializer_getInstance()];
    return new SealedClassSerializer('kotlinx.datetime.DateTimeUnit.DateBased', tmp, tmp_0, tmp$ret$3);
  }
  function DateBasedDateTimeUnitSerializer$_get_impl_$ref_m860rs() {
    return constructCallableReference(function (p0) {
      return _get_impl__d88w17(p0);
    }, 1, 0, 437);
  }
  function DateBasedDateTimeUnitSerializer() {
    DateBasedDateTimeUnitSerializer_instance = this;
    AbstractPolymorphicSerializer.call(this);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.nnn_1 = lazy_0(tmp_0, DateBasedDateTimeUnitSerializer$impl$delegate$lambda);
  }
  protoOf(DateBasedDateTimeUnitSerializer).b71 = function (decoder, klassName) {
    return _get_impl__d88w17(this).b71(decoder, klassName);
  };
  protoOf(DateBasedDateTimeUnitSerializer).onn = function (encoder, value) {
    return _get_impl__d88w17(this).d71(encoder, value);
  };
  protoOf(DateBasedDateTimeUnitSerializer).d71 = function (encoder, value) {
    return this.onn(encoder, value instanceof DateBased ? value : THROW_CCE());
  };
  protoOf(DateBasedDateTimeUnitSerializer).c71 = function () {
    return getKClass(DateBased);
  };
  protoOf(DateBasedDateTimeUnitSerializer).y70 = function () {
    return _get_impl__d88w17(this).y70();
  };
  var DateBasedDateTimeUnitSerializer_instance;
  function DateBasedDateTimeUnitSerializer_getInstance() {
    if (DateBasedDateTimeUnitSerializer_instance == null)
      new DateBasedDateTimeUnitSerializer();
    return DateBasedDateTimeUnitSerializer_instance;
  }
  function DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
    return buildClassSerialDescriptor('kotlinx.datetime.DayBased', [], DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
  }
  function DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
    // Inline function 'kotlinx.serialization.descriptors.element' call
    var annotations = emptyList();
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer(createKType(PrimitiveClasses_getInstance().mc(), arrayOf([]), false));
    var descriptor = (isInterface(this_0, KSerializer) ? this_0 : THROW_CCE()).y70();
    $this$buildClassSerialDescriptor.j73('days', descriptor, annotations, false);
    return Unit_instance;
  }
  function DayBasedDateTimeUnitSerializer$_get_descriptor_$ref_2ycvl3() {
    return constructCallableReference(function (p0) {
      return p0.y70();
    }, 1, 0, 438);
  }
  function DayBasedDateTimeUnitSerializer() {
    DayBasedDateTimeUnitSerializer_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.pnn_1 = lazy_0(tmp_0, DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
  }
  protoOf(DayBasedDateTimeUnitSerializer).y70 = function () {
    var tmp0 = this.pnn_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, DayBasedDateTimeUnitSerializer$_get_descriptor_$ref_2ycvl3(), null);
    return tmp0.u1();
  };
  protoOf(DayBasedDateTimeUnitSerializer).qnn = function (encoder, value) {
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.y70();
    var composite = encoder.n74(descriptor);
    composite.x75(DayBasedDateTimeUnitSerializer_getInstance().y70(), 0, value.xn4_1);
    composite.o74(descriptor);
  };
  protoOf(DayBasedDateTimeUnitSerializer).z70 = function (encoder, value) {
    return this.qnn(encoder, value instanceof DayBased ? value : THROW_CCE());
  };
  protoOf(DayBasedDateTimeUnitSerializer).a71 = function (decoder) {
    var seen = {_v: false};
    var days = {_v: 0};
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.y70();
    var composite = decoder.n74(descriptor);
    if (composite.d75()) {
      days._v = composite.s74(DayBasedDateTimeUnitSerializer_getInstance().y70(), 0);
      seen._v = true;
    } else {
      loop: while (true) {
        var elementIndex = composite.e75(DayBasedDateTimeUnitSerializer_getInstance().y70());
        switch (elementIndex) {
          case 0:
            days._v = composite.s74(DayBasedDateTimeUnitSerializer_getInstance().y70(), 0);
            seen._v = true;
            break;
          case -1:
            break loop;
          default:
            throwUnknownIndexException(elementIndex);
            break;
        }
      }
    }
    var result = Unit_instance;
    composite.o74(descriptor);
    if (!seen._v)
      throw MissingFieldException_init_$Create$('days', this.y70().z71());
    return new DayBased(days._v);
  };
  var DayBasedDateTimeUnitSerializer_instance;
  function DayBasedDateTimeUnitSerializer_getInstance() {
    if (DayBasedDateTimeUnitSerializer_instance == null)
      new DayBasedDateTimeUnitSerializer();
    return DayBasedDateTimeUnitSerializer_instance;
  }
  function MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
    return buildClassSerialDescriptor('kotlinx.datetime.MonthBased', [], MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
  }
  function MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
    // Inline function 'kotlinx.serialization.descriptors.element' call
    var annotations = emptyList();
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer(createKType(PrimitiveClasses_getInstance().mc(), arrayOf([]), false));
    var descriptor = (isInterface(this_0, KSerializer) ? this_0 : THROW_CCE()).y70();
    $this$buildClassSerialDescriptor.j73('months', descriptor, annotations, false);
    return Unit_instance;
  }
  function MonthBasedDateTimeUnitSerializer$_get_descriptor_$ref_vroatn() {
    return constructCallableReference(function (p0) {
      return p0.y70();
    }, 1, 0, 439);
  }
  function MonthBasedDateTimeUnitSerializer() {
    MonthBasedDateTimeUnitSerializer_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.rnn_1 = lazy_0(tmp_0, MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
  }
  protoOf(MonthBasedDateTimeUnitSerializer).y70 = function () {
    var tmp0 = this.rnn_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, MonthBasedDateTimeUnitSerializer$_get_descriptor_$ref_vroatn(), null);
    return tmp0.u1();
  };
  protoOf(MonthBasedDateTimeUnitSerializer).snn = function (encoder, value) {
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.y70();
    var composite = encoder.n74(descriptor);
    composite.x75(MonthBasedDateTimeUnitSerializer_getInstance().y70(), 0, value.yn4_1);
    composite.o74(descriptor);
  };
  protoOf(MonthBasedDateTimeUnitSerializer).z70 = function (encoder, value) {
    return this.snn(encoder, value instanceof MonthBased ? value : THROW_CCE());
  };
  protoOf(MonthBasedDateTimeUnitSerializer).a71 = function (decoder) {
    var seen = {_v: false};
    var months = {_v: 0};
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.y70();
    var composite = decoder.n74(descriptor);
    if (composite.d75()) {
      months._v = composite.s74(MonthBasedDateTimeUnitSerializer_getInstance().y70(), 0);
      seen._v = true;
    } else {
      loop: while (true) {
        var elementIndex = composite.e75(MonthBasedDateTimeUnitSerializer_getInstance().y70());
        switch (elementIndex) {
          case 0:
            months._v = composite.s74(MonthBasedDateTimeUnitSerializer_getInstance().y70(), 0);
            seen._v = true;
            break;
          case -1:
            break loop;
          default:
            throwUnknownIndexException(elementIndex);
            break;
        }
      }
    }
    var result = Unit_instance;
    composite.o74(descriptor);
    if (!seen._v)
      throw MissingFieldException_init_$Create$('months', this.y70().z71());
    return new MonthBased(months._v);
  };
  var MonthBasedDateTimeUnitSerializer_instance;
  function MonthBasedDateTimeUnitSerializer_getInstance() {
    if (MonthBasedDateTimeUnitSerializer_instance == null)
      new MonthBasedDateTimeUnitSerializer();
    return MonthBasedDateTimeUnitSerializer_instance;
  }
  function _get_impl__d88w17_0($this) {
    var tmp0 = $this.tnn_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('impl', 1, tmp, DateTimeUnitSerializer$_get_impl_$ref_2y1hvx(), null);
    return tmp0.u1();
  }
  function DateTimeUnitSerializer$impl$delegate$lambda() {
    var tmp = getKClass(DateTimeUnit);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(DayBased), getKClass(MonthBased), getKClass(TimeBased)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [DayBasedDateTimeUnitSerializer_getInstance(), MonthBasedDateTimeUnitSerializer_getInstance(), TimeBasedDateTimeUnitSerializer_getInstance()];
    return new SealedClassSerializer('kotlinx.datetime.DateTimeUnit', tmp, tmp_0, tmp$ret$3);
  }
  function DateTimeUnitSerializer$_get_impl_$ref_2y1hvx() {
    return constructCallableReference(function (p0) {
      return _get_impl__d88w17_0(p0);
    }, 1, 0, 440);
  }
  function DateTimeUnitSerializer() {
    DateTimeUnitSerializer_instance = this;
    AbstractPolymorphicSerializer.call(this);
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.tnn_1 = lazy_0(tmp_0, DateTimeUnitSerializer$impl$delegate$lambda);
  }
  protoOf(DateTimeUnitSerializer).b71 = function (decoder, klassName) {
    return _get_impl__d88w17_0(this).b71(decoder, klassName);
  };
  protoOf(DateTimeUnitSerializer).unn = function (encoder, value) {
    return _get_impl__d88w17_0(this).d71(encoder, value);
  };
  protoOf(DateTimeUnitSerializer).d71 = function (encoder, value) {
    return this.unn(encoder, value instanceof DateTimeUnit ? value : THROW_CCE());
  };
  protoOf(DateTimeUnitSerializer).c71 = function () {
    return getKClass(DateTimeUnit);
  };
  protoOf(DateTimeUnitSerializer).y70 = function () {
    return _get_impl__d88w17_0(this).y70();
  };
  var DateTimeUnitSerializer_instance;
  function DateTimeUnitSerializer_getInstance() {
    if (DateTimeUnitSerializer_instance == null)
      new DateTimeUnitSerializer();
    return DateTimeUnitSerializer_instance;
  }
  function throwUnknownIndexException(index) {
    throw SerializationException_init_$Create$('An unknown field for index ' + index);
  }
  function LocalDateSerializer() {
    LocalDateSerializer_instance = this;
    this.vnn_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalDate', STRING_getInstance());
  }
  protoOf(LocalDateSerializer).y70 = function () {
    return this.vnn_1;
  };
  protoOf(LocalDateSerializer).a71 = function (decoder) {
    return Companion_getInstance_21().ano(decoder.i74());
  };
  protoOf(LocalDateSerializer).bno = function (encoder, value) {
    encoder.r75(value.toString());
  };
  protoOf(LocalDateSerializer).z70 = function (encoder, value) {
    return this.bno(encoder, value instanceof LocalDate ? value : THROW_CCE());
  };
  var LocalDateSerializer_instance;
  function LocalDateSerializer_getInstance() {
    if (LocalDateSerializer_instance == null)
      new LocalDateSerializer();
    return LocalDateSerializer_instance;
  }
  function LocalDateTimeSerializer() {
    LocalDateTimeSerializer_instance = this;
    this.cno_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalDateTime', STRING_getInstance());
  }
  protoOf(LocalDateTimeSerializer).y70 = function () {
    return this.cno_1;
  };
  protoOf(LocalDateTimeSerializer).a71 = function (decoder) {
    return Companion_getInstance_22().fno(decoder.i74());
  };
  protoOf(LocalDateTimeSerializer).gno = function (encoder, value) {
    encoder.r75(value.toString());
  };
  protoOf(LocalDateTimeSerializer).z70 = function (encoder, value) {
    return this.gno(encoder, value instanceof LocalDateTime ? value : THROW_CCE());
  };
  var LocalDateTimeSerializer_instance;
  function LocalDateTimeSerializer_getInstance() {
    if (LocalDateTimeSerializer_instance == null)
      new LocalDateTimeSerializer();
    return LocalDateTimeSerializer_instance;
  }
  function LocalTimeSerializer() {
    LocalTimeSerializer_instance = this;
    this.hno_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalTime', STRING_getInstance());
  }
  protoOf(LocalTimeSerializer).y70 = function () {
    return this.hno_1;
  };
  protoOf(LocalTimeSerializer).a71 = function (decoder) {
    return Companion_getInstance_23().kno(decoder.i74());
  };
  protoOf(LocalTimeSerializer).lno = function (encoder, value) {
    encoder.r75(value.toString());
  };
  protoOf(LocalTimeSerializer).z70 = function (encoder, value) {
    return this.lno(encoder, value instanceof LocalTime ? value : THROW_CCE());
  };
  var LocalTimeSerializer_instance;
  function LocalTimeSerializer_getInstance() {
    if (LocalTimeSerializer_instance == null)
      new LocalTimeSerializer();
    return LocalTimeSerializer_instance;
  }
  function UtcOffsetSerializer() {
    UtcOffsetSerializer_instance = this;
    this.mno_1 = PrimitiveSerialDescriptor('kotlinx.datetime.UtcOffset', STRING_getInstance());
  }
  protoOf(UtcOffsetSerializer).y70 = function () {
    return this.mno_1;
  };
  protoOf(UtcOffsetSerializer).a71 = function (decoder) {
    return Companion_getInstance_26().ono(decoder.i74());
  };
  protoOf(UtcOffsetSerializer).pno = function (encoder, value) {
    encoder.r75(value.toString());
  };
  protoOf(UtcOffsetSerializer).z70 = function (encoder, value) {
    return this.pno(encoder, value instanceof UtcOffset ? value : THROW_CCE());
  };
  var UtcOffsetSerializer_instance;
  function UtcOffsetSerializer_getInstance() {
    if (UtcOffsetSerializer_instance == null)
      new UtcOffsetSerializer();
    return UtcOffsetSerializer_instance;
  }
  function YearMonthSerializer() {
    YearMonthSerializer_instance = this;
    this.qno_1 = PrimitiveSerialDescriptor('kotlinx.datetime.YearMonth', STRING_getInstance());
  }
  protoOf(YearMonthSerializer).y70 = function () {
    return this.qno_1;
  };
  protoOf(YearMonthSerializer).a71 = function (decoder) {
    return Companion_instance_27.rno(decoder.i74());
  };
  protoOf(YearMonthSerializer).sno = function (encoder, value) {
    encoder.r75(value.toString());
  };
  protoOf(YearMonthSerializer).z70 = function (encoder, value) {
    return this.sno(encoder, value instanceof YearMonth ? value : THROW_CCE());
  };
  var YearMonthSerializer_instance;
  function YearMonthSerializer_getInstance() {
    if (YearMonthSerializer_instance == null)
      new YearMonthSerializer();
    return YearMonthSerializer_instance;
  }
  function get_tzdb() {
    _init_properties_Platform_kt__37ezn1();
    return tzdb;
  }
  var tzdb;
  function currentSystemDefaultZone() {
    _init_properties_Platform_kt__37ezn1();
    var id = ZoneId.systemDefault().id();
    return id === 'SYSTEM' ? to(id, SystemTimeZone_getInstance()) : to(id, null);
  }
  function timeZoneById(zoneId) {
    _init_properties_Platform_kt__37ezn1();
    var tmp;
    if (zoneId === 'SYSTEM') {
      var _destruct__k2r9zo = currentSystemDefaultZone();
      var name = _destruct__k2r9zo.zh();
      var zone = _destruct__k2r9zo.ai();
      if (zone == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        return zone;
      }
      tmp = name;
    } else {
      tmp = zoneId;
    }
    var id = tmp;
    var tmp1_safe_receiver = rulesForId(id);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return new RegionTimeZone(tmp1_safe_receiver, id);
    }
    throw IllegalTimeZoneException_init_$Create$_0('js-joda timezone database is not available');
  }
  function SystemTimeZone() {
    SystemTimeZone_instance = this;
    TimeZone.call(this);
  }
  protoOf(SystemTimeZone).tno = function () {
    return 'SYSTEM';
  };
  protoOf(SystemTimeZone).uno = function (date) {
    return this.vno(atTime(date, Companion_getInstance_23().ino_1));
  };
  protoOf(SystemTimeZone).wno = function (instant) {
    return UtcOffset_0(VOID, -numberToInt((new Date(toNumber(instant.wp()))).getTimezoneOffset()) | 0);
  };
  protoOf(SystemTimeZone).xno = function (dateTime, preferred) {
    var epochMilli = toInstant_0(dateTime, Companion_getInstance_24().yno_1).wp();
    var offsetInMinutesBeforePossibleTransition = numberToInt((new Date(toNumber(epochMilli))).getTimezoneOffset());
    // Inline function 'kotlin.Long.plus' call
    var other = imul(imul(offsetInMinutesBeforePossibleTransition, 60), 1000);
    var epochMilliSystemZone = add(epochMilli, fromInt(other));
    var offsetInMinutesAfterPossibleTransition = numberToInt((new Date(toNumber(epochMilliSystemZone))).getTimezoneOffset());
    var offset = UtcOffset_0(VOID, -offsetInMinutesAfterPossibleTransition | 0);
    return toInstant(dateTime, offset);
  };
  protoOf(SystemTimeZone).equals = function (other) {
    return other === this;
  };
  protoOf(SystemTimeZone).hashCode = function () {
    return getStringHashCode(this.tno());
  };
  var SystemTimeZone_instance;
  function SystemTimeZone_getInstance() {
    if (SystemTimeZone_instance == null)
      new SystemTimeZone();
    return SystemTimeZone_instance;
  }
  function rulesForId(zoneId) {
    _init_properties_Platform_kt__37ezn1();
    // Inline function 'kotlin.getOrThrow' call
    var this_0 = get_tzdb();
    throwOnFailure(this_0);
    var tmp0_safe_receiver = _Result___get_value__impl__bjfvqg(this_0);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.anp(zoneId);
  }
  function tzdb$charCodeToInt(char) {
    var tmp;
    if (_Char___init__impl__6a9atx(48) <= char ? char <= _Char___init__impl__6a9atx(57) : false) {
      tmp = Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(48));
    } else if (_Char___init__impl__6a9atx(97) <= char ? char <= _Char___init__impl__6a9atx(122) : false) {
      tmp = Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(97)) + 10 | 0;
    } else if (_Char___init__impl__6a9atx(65) <= char ? char <= _Char___init__impl__6a9atx(88) : false) {
      tmp = Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65)) + 36 | 0;
    } else {
      throw IllegalArgumentException_init_$Create$('Invalid character: ' + toString(char));
    }
    return tmp;
  }
  function tzdb$base60MinutesInSeconds(string) {
    var parts = split(string, charArrayOf([_Char___init__impl__6a9atx(46)]));
    var sign;
    var minuteNumberStart;
    if (startsWith(string, _Char___init__impl__6a9atx(45))) {
      minuteNumberStart = 1;
      sign = -1;
    } else {
      minuteNumberStart = 0;
      sign = 1;
    }
    var whole = parts.l1(0);
    // Inline function 'kotlin.collections.map' call
    var this_0 = numberRangeToNumber(minuteNumberStart, get_lastIndex(whole));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.x1_1;
    var last = this_0.y1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = item;
        var tmp$ret$2 = tzdb$charCodeToInt(charCodeAt(whole, it));
        destination.j1(tmp$ret$2);
      }
       while (!(item === last));
    // Inline function 'kotlin.collections.fold' call
    var accumulator = new Long(0, 0);
    var _iterator__ex2g4s = destination.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var acc = accumulator;
      // Inline function 'kotlin.Long.plus' call
      var this_1 = multiply(numberToLong(60), acc);
      accumulator = add(this_1, fromInt(element));
    }
    var wholeMinutes = accumulator;
    var tmp0_safe_receiver = getOrNull(parts, 1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0;
      switch (tmp0_safe_receiver.length) {
        case 1:
          tmp_0 = tzdb$charCodeToInt(charCodeAt(tmp0_safe_receiver, 0));
          break;
        case 0:
          tmp_0 = 0;
          break;
        default:
          var tmp_1 = tzdb$charCodeToInt(charCodeAt(tmp0_safe_receiver, 0));
          // Inline function 'kotlin.let' call

          tmp_0 = tmp_1 + (tzdb$charCodeToInt(charCodeAt(tmp0_safe_receiver, 1)) >= 30 ? 1 : 0) | 0;
          break;
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var seconds = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    // Inline function 'kotlin.Long.times' call
    // Inline function 'kotlin.Long.plus' call
    var this_2 = multiply(wholeMinutes, fromInt(60));
    var tmp0 = add(this_2, fromInt(seconds));
    // Inline function 'kotlin.Long.times' call
    var other = sign;
    return multiply(tmp0, fromInt(other));
  }
  function tzdb$1($zones) {
    this.bnp_1 = $zones;
  }
  protoOf(tzdb$1).anp = function (id) {
    var tmp0_elvis_lhs = this.bnp_1.w2(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalTimeZoneException_init_$Create$_0('Unknown time zone: ' + id);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var properties_initialized_Platform_kt_qdcgvf;
  function _init_properties_Platform_kt__37ezn1() {
    if (!properties_initialized_Platform_kt_qdcgvf) {
      properties_initialized_Platform_kt_qdcgvf = true;
      // Inline function 'kotlin.runCatching' call
      var tmp;
      try {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.mutableMapOf' call
          var zones = LinkedHashMap_init_$Create$();
          var tmp0_elvis_lhs = readTzdb();
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$1 = null;
            break $l$block;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var _destruct__k2r9zo = tmp_0;
          var zonesPacked = _destruct__k2r9zo.zh();
          var linksPacked = _destruct__k2r9zo.ai();
          var _iterator__ex2g4s = zonesPacked.t();
          while (_iterator__ex2g4s.u()) {
            var zone = _iterator__ex2g4s.v();
            var components = split(zone, charArrayOf([_Char___init__impl__6a9atx(124)]));
            // Inline function 'kotlin.collections.map' call
            var this_0 = split(components.l1(2), charArrayOf([_Char___init__impl__6a9atx(32)]));
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s_0 = this_0.t();
            while (_iterator__ex2g4s_0.u()) {
              var item = _iterator__ex2g4s_0.v();
              var tmp$ret$5 = UtcOffset_0(null, null, -convertToInt(tzdb$base60MinutesInSeconds(item)) | 0);
              destination.j1(tmp$ret$5);
            }
            var offsets = destination;
            // Inline function 'kotlin.text.map' call
            var this_1 = components.l1(3);
            // Inline function 'kotlin.text.mapTo' call
            var destination_0 = ArrayList_init_$Create$(charSequenceLength(this_1));
            var inductionVariable = 0;
            while (inductionVariable < charSequenceLength(this_1)) {
              var item_0 = charSequenceGet(this_1, inductionVariable);
              inductionVariable = inductionVariable + 1 | 0;
              var tmp$ret$8 = tzdb$charCodeToInt(item_0);
              destination_0.j1(tmp$ret$8);
            }
            var indices = destination_0;
            // Inline function 'kotlin.collections.map' call
            var this_2 = split(components.l1(4), charArrayOf([_Char___init__impl__6a9atx(32)]));
            // Inline function 'kotlin.collections.mapTo' call
            var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
            var _iterator__ex2g4s_1 = this_2.t();
            while (_iterator__ex2g4s_1.u()) {
              var item_1 = _iterator__ex2g4s_1.v();
              var tmp$ret$11 = tzdb$base60MinutesInSeconds(item_1);
              destination_1.j1(tmp$ret$11);
            }
            var lengthsOfPeriodsWithOffsets = destination_1;
            var tmp2 = components.l1(0);
            var tmp$ret$12;
            $l$block_0: {
              // Inline function 'kotlin.collections.runningReduce' call
              var iterator = lengthsOfPeriodsWithOffsets.t();
              if (!iterator.u()) {
                tmp$ret$12 = emptyList();
                break $l$block_0;
              }
              var accumulator = iterator.v();
              // Inline function 'kotlin.apply' call
              var this_3 = ArrayList_init_$Create$(collectionSizeOrDefault(lengthsOfPeriodsWithOffsets, 10));
              this_3.j1(accumulator);
              var result = this_3;
              while (iterator.u()) {
                var tmp0 = accumulator;
                var p1 = iterator.v();
                accumulator = add(tmp0, p1);
                result.j1(accumulator);
              }
              tmp$ret$12 = result;
            }
            // Inline function 'kotlin.let' call
            var it = tmp$ret$12;
            var tmp_1 = it.n1() === (indices.n1() - 1 | 0) ? it : take(it, indices.n1() - 1 | 0);
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(indices, 10));
            var _iterator__ex2g4s_2 = indices.t();
            while (_iterator__ex2g4s_2.u()) {
              var item_2 = _iterator__ex2g4s_2.v();
              var tmp$ret$20 = offsets.l1(item_2);
              destination_2.j1(tmp$ret$20);
            }
            // Inline function 'kotlin.collections.set' call
            var value = new TimeZoneRulesCommon(tmp_1, destination_2, null);
            zones.z2(tmp2, value);
          }
          var _iterator__ex2g4s_3 = linksPacked.t();
          while (_iterator__ex2g4s_3.u()) {
            var link = _iterator__ex2g4s_3.v();
            var components_0 = split(link, charArrayOf([_Char___init__impl__6a9atx(124)]));
            var tmp1_safe_receiver = zones.w2(components_0.l1(0));
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.set' call
              var key = components_0.l1(1);
              zones.z2(key, tmp1_safe_receiver);
            }
          }
          tmp$ret$1 = new tzdb$1(zones);
        }
        // Inline function 'kotlin.Companion.success' call
        var value_0 = tmp$ret$1;
        tmp = _Result___init__impl__xyqfz8(value_0);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp = tmp_2;
      }
      tzdb = tmp;
    }
  }
  function LocalDate_init_$Init$(year, month, day, $this) {
    LocalDate.call($this, year, month, day, Unit_instance);
    var containsArg = $this.zn7_1;
    // Inline function 'kotlin.require' call
    if (!(1 <= containsArg ? containsArg <= 12 : false)) {
      var message = 'Invalid date: month must be a number between 1 and 12, got ' + $this.zn7_1;
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    validateYearAndDay($this);
    return $this;
  }
  function LocalDate_init_$Create$(year, month, day) {
    return LocalDate_init_$Init$(year, month, day, objectCreate(protoOf(LocalDate)));
  }
  function LocalDate_init_$Init$_0(year, month, day, $this) {
    LocalDate.call($this, year, get_number(month), day, Unit_instance);
    validateYearAndDay($this);
    return $this;
  }
  function LocalDate_init_$Create$_0(year, month, day) {
    return LocalDate_init_$Init$_0(year, month, day, objectCreate(protoOf(LocalDate)));
  }
  function validateYearAndDay($this) {
    var containsArg = $this.xn7_1;
    // Inline function 'kotlin.require' call
    if (!(-999999999 <= containsArg ? containsArg <= 999999999 : false)) {
      var message = 'Invalid date: the year is out of range';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    var containsArg_0 = $this.yn7_1;
    // Inline function 'kotlin.require' call
    if (!(1 <= containsArg_0 ? containsArg_0 <= 31 : false)) {
      var message_0 = 'Invalid date: day of month must be a number between 1 and 31, got ' + $this.yn7_1;
      throw IllegalArgumentException_init_$Create$(toString_0(message_0));
    }
    if ($this.yn7_1 > 28 && $this.yn7_1 > monthLength($this.zn7_1, isLeapYear($this.xn7_1))) {
      if ($this.yn7_1 === 29) {
        throw IllegalArgumentException_init_$Create$("Invalid date 'February 29' as '" + $this.xn7_1 + "' is not a leap year");
      } else {
        throw IllegalArgumentException_init_$Create$("Invalid date '" + $this.an8().toString() + ' ' + $this.yn7_1 + "'");
      }
    }
  }
  function Companion_20() {
    Companion_instance_21 = this;
    this.wnn_1 = LocalDate_init_$Create$(-999999999, 1, 1);
    this.xnn_1 = LocalDate_init_$Create$(999999999, 12, 31);
    this.ynn_1 = new Long(-170999002, -86);
    this.znn_1 = new Long(169560311, 85);
  }
  protoOf(Companion_20).cnp = function (input, format) {
    return format.sp(input);
  };
  protoOf(Companion_20).ano = function (input, format, $super) {
    format = format === VOID ? getIsoDateFormat() : format;
    return $super === VOID ? this.cnp(input, format) : $super.cnp.call(this, input, format);
  };
  protoOf(Companion_20).dnp = function (epochDays) {
    // Inline function 'kotlin.require' call
    if (!(compare(new Long(-170999002, -86), epochDays) <= 0 ? compare(epochDays, new Long(169560311, 85)) <= 0 : false)) {
      var message = 'Invalid date: epoch day ' + epochDays.toString() + ' is outside the boundaries of LocalDate';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    // Inline function 'kotlin.Long.plus' call
    var zeroDay = add(epochDays, fromInt(719528));
    // Inline function 'kotlin.Long.minus' call
    var this_0 = zeroDay;
    zeroDay = subtract(this_0, fromInt(60));
    var adjust = new Long(0, 0);
    if (compare(zeroDay, new Long(0, 0)) < 0) {
      // Inline function 'kotlin.Long.plus' call
      var this_1 = zeroDay;
      // Inline function 'kotlin.Long.div' call
      var this_2 = add(this_1, fromInt(1));
      // Inline function 'kotlin.Long.minus' call
      var this_3 = divide(this_2, fromInt(146097));
      var adjustCycles = subtract(this_3, fromInt(1));
      // Inline function 'kotlin.Long.times' call
      adjust = multiply(adjustCycles, fromInt(400));
      var tmp = zeroDay;
      // Inline function 'kotlin.Long.times' call
      var this_4 = negate(adjustCycles);
      var tmp$ret$8 = multiply(this_4, fromInt(146097));
      zeroDay = add(tmp, tmp$ret$8);
    }
    // Inline function 'kotlin.Long.plus' call
    var this_5 = multiply(numberToLong(400), zeroDay);
    // Inline function 'kotlin.Long.div' call
    var this_6 = add(this_5, fromInt(591));
    var yearEst = divide(this_6, fromInt(146097));
    var tmp_0 = zeroDay;
    var tmp_1 = multiply(numberToLong(365), yearEst);
    // Inline function 'kotlin.Long.div' call
    var this_7 = yearEst;
    var tmp$ret$11 = divide(this_7, fromInt(4));
    var tmp_2 = add(tmp_1, tmp$ret$11);
    // Inline function 'kotlin.Long.div' call
    var this_8 = yearEst;
    var tmp$ret$12 = divide(this_8, fromInt(100));
    var tmp_3 = subtract(tmp_2, tmp$ret$12);
    // Inline function 'kotlin.Long.div' call
    var this_9 = yearEst;
    var tmp$ret$13 = divide(this_9, fromInt(400));
    var doyEst = subtract(tmp_0, add(tmp_3, tmp$ret$13));
    if (compare(doyEst, new Long(0, 0)) < 0) {
      var _unary__edvuaz = yearEst;
      yearEst = subtract(_unary__edvuaz, get_ONE());
      var tmp_4 = zeroDay;
      var tmp_5 = multiply(numberToLong(365), yearEst);
      // Inline function 'kotlin.Long.div' call
      var this_10 = yearEst;
      var tmp$ret$14 = divide(this_10, fromInt(4));
      var tmp_6 = add(tmp_5, tmp$ret$14);
      // Inline function 'kotlin.Long.div' call
      var this_11 = yearEst;
      var tmp$ret$15 = divide(this_11, fromInt(100));
      var tmp_7 = subtract(tmp_6, tmp$ret$15);
      // Inline function 'kotlin.Long.div' call
      var this_12 = yearEst;
      var tmp$ret$16 = divide(this_12, fromInt(400));
      doyEst = subtract(tmp_4, add(tmp_7, tmp$ret$16));
    }
    yearEst = add(yearEst, adjust);
    var marchDoy0 = convertToInt(doyEst);
    var marchMonth0 = (imul(marchDoy0, 5) + 2 | 0) / 153 | 0;
    var month = ((marchMonth0 + 2 | 0) % 12 | 0) + 1 | 0;
    var dom = (marchDoy0 - ((imul(marchMonth0, 306) + 5 | 0) / 10 | 0) | 0) + 1 | 0;
    var tmp0 = yearEst;
    // Inline function 'kotlin.Long.plus' call
    var other = marchMonth0 / 10 | 0;
    yearEst = add(tmp0, fromInt(other));
    return new LocalDate(convertToInt(yearEst), month, dom, Unit_instance);
  };
  protoOf(Companion_20).enp = function (block) {
    return Companion_instance_11.hn8(block);
  };
  var Companion_instance_21;
  function Companion_getInstance_21() {
    if (Companion_instance_21 == null)
      new Companion_20();
    return Companion_instance_21;
  }
  function Formats() {
    Formats_instance = this;
    this.on5_1 = get_ISO_DATE_BASIC();
  }
  protoOf(Formats).pn5 = function () {
    return get_ISO_DATE();
  };
  var Formats_instance;
  function Formats_getInstance() {
    if (Formats_instance == null)
      new Formats();
    return Formats_instance;
  }
  function resolvePreviousValid($this, year, month, day) {
    // Inline function 'kotlin.math.min' call
    var b = monthLength(month, isLeapYear(year));
    var newDay = Math.min(day, b);
    return new LocalDate(year, month, newDay, Unit_instance);
  }
  function LocalDate(year, month, day, unit) {
    Companion_getInstance_21();
    this.xn7_1 = year;
    this.yn7_1 = day;
    this.zn7_1 = month;
  }
  protoOf(LocalDate).fnp = function () {
    var y = fromInt(this.xn7_1);
    var m = fromInt(this.zn7_1);
    var total = new Long(0, 0);
    total = add(total, multiply(numberToLong(365), y));
    if (compare(y, new Long(0, 0)) >= 0) {
      var tmp = total;
      // Inline function 'kotlin.Long.plus' call
      // Inline function 'kotlin.Long.div' call
      var this_0 = add(y, fromInt(3));
      var tmp_0 = divide(this_0, fromInt(4));
      // Inline function 'kotlin.Long.plus' call
      // Inline function 'kotlin.Long.div' call
      var this_1 = add(y, fromInt(99));
      var tmp$ret$3 = divide(this_1, fromInt(100));
      var tmp_1 = subtract(tmp_0, tmp$ret$3);
      // Inline function 'kotlin.Long.plus' call
      // Inline function 'kotlin.Long.div' call
      var this_2 = add(y, fromInt(399));
      var tmp$ret$5 = divide(this_2, fromInt(400));
      total = add(tmp, add(tmp_1, tmp$ret$5));
    } else {
      var tmp_2 = total;
      // Inline function 'kotlin.Long.div' call
      var tmp_3 = divide(y, fromInt(-4));
      // Inline function 'kotlin.Long.div' call
      var tmp$ret$7 = divide(y, fromInt(-100));
      var tmp_4 = subtract(tmp_3, tmp$ret$7);
      // Inline function 'kotlin.Long.div' call
      var tmp$ret$8 = divide(y, fromInt(-400));
      total = subtract(tmp_2, add(tmp_4, tmp$ret$8));
    }
    var tmp_5 = total;
    // Inline function 'kotlin.Long.minus' call
    var this_3 = multiply(numberToLong(367), m);
    // Inline function 'kotlin.Long.div' call
    var this_4 = subtract(this_3, fromInt(362));
    var tmp$ret$10 = divide(this_4, fromInt(12));
    total = add(tmp_5, tmp$ret$10);
    var tmp0 = total;
    // Inline function 'kotlin.Long.plus' call
    var other = this.yn7_1 - 1 | 0;
    total = add(tmp0, fromInt(other));
    if (compare(m, new Long(2, 0)) > 0) {
      var _unary__edvuaz = total;
      total = subtract(_unary__edvuaz, get_ONE());
      if (!isLeapYear(this.xn7_1)) {
        var _unary__edvuaz_0 = total;
        total = subtract(_unary__edvuaz_0, get_ONE());
      }
    }
    // Inline function 'kotlin.Long.minus' call
    var this_5 = total;
    return subtract(this_5, fromInt(719528));
  };
  protoOf(LocalDate).an8 = function () {
    return Month_0(this.zn7_1);
  };
  protoOf(LocalDate).sn7 = function () {
    // Inline function 'kotlin.Long.plus' call
    var this_0 = this.fnp();
    // Inline function 'kotlin.mod' call
    var tmp0 = add(this_0, fromInt(3));
    // Inline function 'kotlin.mod' call
    var other = fromInt(7);
    var r = modulo(tmp0, other);
    var tmp$ret$2 = add(r, bitwiseAnd(other, shiftRight(bitwiseAnd(bitwiseXor(r, other), bitwiseOr(r, negate(r))), 63)));
    var dow0 = convertToInt(tmp$ret$2);
    return DayOfWeek_0(dow0 + 1 | 0);
  };
  protoOf(LocalDate).un7 = function () {
    return (firstDayOfYear(this.an8(), isLeapYear(this.xn7_1)) + this.yn7_1 | 0) - 1 | 0;
  };
  protoOf(LocalDate).gnp = function (other) {
    var y = compareTo(this.xn7_1, other.xn7_1);
    if (!(y === 0)) {
      return y;
    }
    var m = compareTo(this.zn7_1, other.zn7_1);
    if (!(m === 0)) {
      return m;
    }
    return compareTo(this.yn7_1, other.yn7_1);
  };
  protoOf(LocalDate).d = function (other) {
    return this.gnp(other instanceof LocalDate ? other : THROW_CCE());
  };
  protoOf(LocalDate).hnp = function (monthsToAdd) {
    if (equalsLong(monthsToAdd, new Long(0, 0))) {
      return this;
    }
    var tmp0 = multiply(numberToLong(this.xn7_1), new Long(12, 0));
    // Inline function 'kotlin.Long.plus' call
    var other = this.zn7_1 - 1 | 0;
    var monthCount = add(tmp0, fromInt(other));
    var calcMonths = safeAdd(monthCount, monthsToAdd);
    // Inline function 'kotlin.floorDiv' call
    // Inline function 'kotlin.floorDiv' call
    var other_0 = fromInt(12);
    var q = divide(calcMonths, other_0);
    if (compare(bitwiseXor(calcMonths, other_0), new Long(0, 0)) < 0 && !equalsLong(multiply(q, other_0), calcMonths)) {
      var _unary__edvuaz = q;
      q = subtract(_unary__edvuaz, get_ONE());
    }
    var newYear = q;
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = numberRangeToNumber(-999999999, 999999999);
    if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), newYear)) {
      throw IllegalArgumentException_init_$Create$('The result of adding ' + monthsToAdd.toString() + ' months to ' + this.toString() + ' is out of LocalDate range.');
    }
    // Inline function 'kotlin.mod' call
    // Inline function 'kotlin.mod' call
    var other_1 = fromInt(12);
    var r = modulo(calcMonths, other_1);
    var tmp$ret$5 = add(r, bitwiseAnd(other_1, shiftRight(bitwiseAnd(bitwiseXor(r, other_1), bitwiseOr(r, negate(r))), 63)));
    var newMonth = convertToInt(tmp$ret$5) + 1 | 0;
    return resolvePreviousValid(this, convertToInt(newYear), newMonth, this.yn7_1);
  };
  protoOf(LocalDate).inp = function (daysToAdd) {
    return equalsLong(daysToAdd, new Long(0, 0)) ? this : Companion_getInstance_21().dnp(safeAdd(this.fnp(), daysToAdd));
  };
  protoOf(LocalDate).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      if (other instanceof LocalDate) {
        tmp_0 = this.gnp(other) === 0;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(LocalDate).hashCode = function () {
    var yearValue = this.xn7_1;
    var monthValue = this.zn7_1;
    var dayValue = this.yn7_1;
    return yearValue & -2048 ^ (((yearValue << 11) + (monthValue << 6) | 0) + dayValue | 0);
  };
  protoOf(LocalDate).toString = function () {
    return format(this, Formats_getInstance().pn5());
  };
  function plus_2(_this__u8e3s4, value, unit) {
    var tmp;
    try {
      var tmp_0;
      if (unit instanceof DayBased) {
        tmp_0 = _this__u8e3s4.inp(safeMultiply(value, fromInt(unit.xn4_1)));
      } else {
        if (unit instanceof MonthBased) {
          tmp_0 = _this__u8e3s4.hnp(safeMultiply(value, fromInt(unit.yn4_1)));
        } else {
          noWhenBranchMatchedException();
        }
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof ArithmeticException) {
        var e = $p;
        throw DateTimeArithmeticException_init_$Create$_0('Arithmetic overflow when adding a value to a date', e);
      } else {
        if ($p instanceof IllegalArgumentException) {
          var e_0 = $p;
          throw DateTimeArithmeticException_init_$Create$_0('Boundaries of LocalDate exceeded when adding a value', e_0);
        } else {
          throw $p;
        }
      }
    }
    return tmp;
  }
  function plus_3(_this__u8e3s4, period) {
    // Inline function 'kotlin.with' call
    var tmp;
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.run' call
      var $this$run = !equalsLong(period.dn4_1, new Long(0, 0)) ? _this__u8e3s4.hnp(period.dn4_1) : _this__u8e3s4;
      tmp = !(period.en4_1 === 0) ? $this$run.inp(fromInt(period.en4_1)) : $this$run;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof ArithmeticException) {
        var e = $p;
        throw DateTimeArithmeticException_init_$Create$_0('Arithmetic overflow when adding a period to a date', e);
      } else {
        if ($p instanceof IllegalArgumentException) {
          var e_0 = $p;
          throw DateTimeArithmeticException_init_$Create$_0('Boundaries of LocalDate exceeded when adding a period', e_0);
        } else {
          throw $p;
        }
      }
    }
    return tmp;
  }
  function get_ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS() {
    _init_properties_LocalDateTime_kt__bewbbg();
    var tmp0 = ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS', 0, tmp, _get_ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS_$ref_4ujexv(), null);
    return tmp0.u1();
  }
  var ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate;
  function Companion_21() {
    Companion_instance_22 = this;
    this.dno_1 = new LocalDateTime(Companion_getInstance_21().wnn_1, Companion_getInstance_23().ino_1);
    this.eno_1 = new LocalDateTime(Companion_getInstance_21().xnn_1, Companion_getInstance_23().jno_1);
  }
  protoOf(Companion_21).jnp = function (input, format) {
    return format.sp(input);
  };
  protoOf(Companion_21).fno = function (input, format, $super) {
    format = format === VOID ? getIsoDateTimeFormat() : format;
    return $super === VOID ? this.jnp(input, format) : $super.jnp.call(this, input, format);
  };
  protoOf(Companion_21).knp = function (builder) {
    return Companion_instance_12.gn9(builder);
  };
  var Companion_instance_22;
  function Companion_getInstance_22() {
    if (Companion_instance_22 == null)
      new Companion_21();
    return Companion_instance_22;
  }
  function Formats_0() {
    Formats_instance_0 = this;
    this.rn5_1 = get_ISO_DATETIME();
  }
  var Formats_instance_0;
  function Formats_getInstance_0() {
    if (Formats_instance_0 == null)
      new Formats_0();
    return Formats_instance_0;
  }
  function LocalDateTime(date, time) {
    Companion_getInstance_22();
    this.xn9_1 = date;
    this.yn9_1 = time;
  }
  protoOf(LocalDateTime).wn7 = function () {
    return this.xn9_1.xn7_1;
  };
  protoOf(LocalDateTime).bn8 = function () {
    return get_number(this.xn9_1.an8());
  };
  protoOf(LocalDateTime).an8 = function () {
    return this.xn9_1.an8();
  };
  protoOf(LocalDateTime).lnp = function () {
    return this.xn9_1.yn7_1;
  };
  protoOf(LocalDateTime).qn7 = function () {
    return this.xn9_1.yn7_1;
  };
  protoOf(LocalDateTime).hna = function () {
    return this.yn9_1.rna_1;
  };
  protoOf(LocalDateTime).bna = function () {
    return this.yn9_1.sna_1;
  };
  protoOf(LocalDateTime).fna = function () {
    return this.yn9_1.una_1;
  };
  protoOf(LocalDateTime).mnp = function (other) {
    var d = this.xn9_1.gnp(other.xn9_1);
    if (!(d === 0)) {
      return d;
    }
    return this.yn9_1.nnp(other.yn9_1);
  };
  protoOf(LocalDateTime).d = function (other) {
    return this.mnp(other instanceof LocalDateTime ? other : THROW_CCE());
  };
  protoOf(LocalDateTime).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      if (other instanceof LocalDateTime) {
        tmp_0 = this.mnp(other) === 0;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(LocalDateTime).hashCode = function () {
    return this.xn9_1.hashCode() ^ this.yn9_1.hashCode();
  };
  protoOf(LocalDateTime).toString = function () {
    return format_0(this, get_ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS());
  };
  protoOf(LocalDateTime).onp = function (offset) {
    var epochDay = this.xn9_1.fnp();
    // Inline function 'kotlin.Long.times' call
    var tmp0 = multiply(epochDay, fromInt(86400));
    // Inline function 'kotlin.Long.plus' call
    var other = this.yn9_1.pnp();
    var secs = add(tmp0, fromInt(other));
    var tmp0_0 = secs;
    // Inline function 'kotlin.Long.minus' call
    var other_0 = offset.hng_1;
    secs = subtract(tmp0_0, fromInt(other_0));
    return secs;
  };
  function plusSeconds(_this__u8e3s4, seconds) {
    _init_properties_LocalDateTime_kt__bewbbg();
    if (seconds === 0) {
      return _this__u8e3s4;
    }
    var currentNanoOfDay = _this__u8e3s4.yn9_1.qnp();
    var totalNanos = add(multiply(numberToLong(seconds % 86400 | 0), new Long(1000000000, 0)), currentNanoOfDay);
    var tmp = seconds / 86400 | 0;
    // Inline function 'kotlin.floorDiv' call
    var other = new Long(-1857093632, 20116);
    var q = divide(totalNanos, other);
    if (compare(bitwiseXor(totalNanos, other), new Long(0, 0)) < 0 && !equalsLong(multiply(q, other), totalNanos)) {
      var _unary__edvuaz = q;
      q = subtract(_unary__edvuaz, get_ONE());
    }
    var tmp$ret$0 = q;
    var totalDays = add(numberToLong(tmp), tmp$ret$0);
    // Inline function 'kotlin.mod' call
    var other_0 = new Long(-1857093632, 20116);
    var r = modulo(totalNanos, other_0);
    var newNanoOfDay = add(r, bitwiseAnd(other_0, shiftRight(bitwiseAnd(bitwiseXor(r, other_0), bitwiseOr(r, negate(r))), 63)));
    var newTime = equalsLong(newNanoOfDay, currentNanoOfDay) ? _this__u8e3s4.yn9_1 : Companion_getInstance_23().rnp(newNanoOfDay);
    return new LocalDateTime(_this__u8e3s4.xn9_1.inp(totalDays), newTime);
  }
  function ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda() {
    _init_properties_LocalDateTime_kt__bewbbg();
    var tmp = Companion_instance_12;
    return tmp.gn9(ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda);
  }
  function ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda($this$build) {
    _init_properties_LocalDateTime_kt__bewbbg();
    $this$build.mn6(get_ISO_DATE());
    var tmp = [ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda];
    alternativeParsing($this$build, tmp, ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda_0);
    $this$build.vn6(get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS());
    return Unit_instance;
  }
  function ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda($this$alternativeParsing) {
    _init_properties_LocalDateTime_kt__bewbbg();
    char($this$alternativeParsing, _Char___init__impl__6a9atx(116));
    return Unit_instance;
  }
  function ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
    _init_properties_LocalDateTime_kt__bewbbg();
    char($this$alternativeParsing, _Char___init__impl__6a9atx(84));
    return Unit_instance;
  }
  function _get_ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS_$ref_4ujexv() {
    return constructCallableReference(function () {
      return get_ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS();
    }, 0, 0, 441);
  }
  var properties_initialized_LocalDateTime_kt_aulw4q;
  function _init_properties_LocalDateTime_kt__bewbbg() {
    if (!properties_initialized_LocalDateTime_kt_aulw4q) {
      properties_initialized_LocalDateTime_kt_aulw4q = true;
      ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate = lazy(ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda);
    }
  }
  function get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS() {
    _init_properties_LocalTime_kt__nmhi56();
    var tmp0 = ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS', 0, tmp, _get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS_$ref_fmwpvv(), null);
    return tmp0.u1();
  }
  var ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate;
  function LocalTime_init_$Init$(hour, minute, second, nanosecond, $this) {
    second = second === VOID ? 0 : second;
    nanosecond = nanosecond === VOID ? 0 : nanosecond;
    LocalTime.call($this, hour, minute, second, nanosecond, Unit_instance);
    _init_$check_eg57ze(hour, 0, 23, 'hour');
    _init_$check_eg57ze(minute, 0, 59, 'minute');
    _init_$check_eg57ze(second, 0, 59, 'second');
    _init_$check_eg57ze(nanosecond, 0, 999999999, 'nanosecond');
    return $this;
  }
  function LocalTime_init_$Create$(hour, minute, second, nanosecond) {
    return LocalTime_init_$Init$(hour, minute, second, nanosecond, objectCreate(protoOf(LocalTime)));
  }
  function Companion_22() {
    Companion_instance_23 = this;
    this.ino_1 = LocalTime_init_$Create$(0, 0, 0, 0);
    this.jno_1 = LocalTime_init_$Create$(23, 59, 59, 999999999);
  }
  protoOf(Companion_22).snp = function (input, format) {
    return format.sp(input);
  };
  protoOf(Companion_22).kno = function (input, format, $super) {
    format = format === VOID ? getIsoTimeFormat() : format;
    return $super === VOID ? this.snp(input, format) : $super.snp.call(this, input, format);
  };
  protoOf(Companion_22).tnp = function (secondOfDay, nanoOfSecond) {
    // Inline function 'kotlin.require' call
    if (!(0 <= secondOfDay ? secondOfDay < 86400 : false)) {
      var message = 'Invalid time: secondOfDay must be between 0 and 86400, got ' + secondOfDay;
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    // Inline function 'kotlin.require' call
    if (!(0 <= nanoOfSecond ? nanoOfSecond < 1000000000 : false)) {
      var message_0 = 'Invalid time: nanosecondOfSecond must be between 0 and 1000000000, got ' + nanoOfSecond;
      throw IllegalArgumentException_init_$Create$(toString_0(message_0));
    }
    var hours = secondOfDay / 3600 | 0;
    var secondWithoutHours = secondOfDay - imul(hours, 3600) | 0;
    var minutes = secondWithoutHours / 60 | 0;
    var second = secondWithoutHours - imul(minutes, 60) | 0;
    return new LocalTime(hours, minutes, second, nanoOfSecond, Unit_instance);
  };
  protoOf(Companion_22).rnp = function (nanoOfDay) {
    var tmp;
    if (compare(nanoOfDay, new Long(0, 0)) >= 0) {
      var tmp0 = new Long(86400, 0);
      // Inline function 'kotlin.Long.times' call
      var other = 1000000000;
      var tmp$ret$0 = multiply(tmp0, fromInt(other));
      tmp = compare(nanoOfDay, tmp$ret$0) < 0;
    } else {
      tmp = false;
    }
    // Inline function 'kotlin.require' call
    if (!tmp) {
      var message = 'Invalid time: nanosecondOfDay must be between 0 and 86_400_000_000_000, got ' + nanoOfDay.toString();
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    var newNanoOfDay = nanoOfDay;
    var hours = convertToInt(divide(newNanoOfDay, new Long(817405952, 838)));
    newNanoOfDay = subtract(newNanoOfDay, multiply(numberToLong(hours), new Long(817405952, 838)));
    var minutes = convertToInt(divide(newNanoOfDay, new Long(-129542144, 13)));
    newNanoOfDay = subtract(newNanoOfDay, multiply(numberToLong(minutes), new Long(-129542144, 13)));
    var tmp0_0 = newNanoOfDay;
    // Inline function 'kotlin.Long.div' call
    var other_0 = 1000000000;
    var tmp$ret$3 = divide(tmp0_0, fromInt(other_0));
    var seconds = convertToInt(tmp$ret$3);
    var tmp0_1 = newNanoOfDay;
    // Inline function 'kotlin.Long.minus' call
    var other_1 = imul(seconds, 1000000000);
    newNanoOfDay = subtract(tmp0_1, fromInt(other_1));
    return new LocalTime(hours, minutes, seconds, convertToInt(newNanoOfDay), Unit_instance);
  };
  var Companion_instance_23;
  function Companion_getInstance_23() {
    if (Companion_instance_23 == null)
      new Companion_22();
    return Companion_instance_23;
  }
  function Formats_1() {
  }
  protoOf(Formats_1).pn5 = function () {
    return get_ISO_TIME();
  };
  var Formats_instance_1;
  function Formats_getInstance_1() {
    return Formats_instance_1;
  }
  function _init_$check_eg57ze(value, lower, upper, str) {
    // Inline function 'kotlin.require' call
    if (!(lower <= value ? value <= upper : false)) {
      var message = 'Invalid time: ' + str + ' must be a number between ' + lower + ' and ' + upper + ', got ' + value;
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    return Unit_instance;
  }
  function LocalTime(hour, minute, second, nanosecond, unit) {
    Companion_getInstance_23();
    this.rna_1 = hour;
    this.sna_1 = minute;
    this.tna_1 = second;
    this.una_1 = nanosecond;
  }
  protoOf(LocalTime).nnp = function (other) {
    var h = compareTo(this.rna_1, other.rna_1);
    if (!(h === 0)) {
      return h;
    }
    var m = compareTo(this.sna_1, other.sna_1);
    if (!(m === 0)) {
      return m;
    }
    var s = compareTo(this.tna_1, other.tna_1);
    if (!(s === 0)) {
      return s;
    }
    return compareTo(this.una_1, other.una_1);
  };
  protoOf(LocalTime).d = function (other) {
    return this.nnp(other instanceof LocalTime ? other : THROW_CCE());
  };
  protoOf(LocalTime).hashCode = function () {
    var nod = this.qnp();
    return convertToInt(bitwiseXor(nod, shiftRightUnsigned(nod, 32)));
  };
  protoOf(LocalTime).pnp = function () {
    var total = imul(this.rna_1, 3600);
    total = total + imul(this.sna_1, 60) | 0;
    total = total + this.tna_1 | 0;
    return total;
  };
  protoOf(LocalTime).qnp = function () {
    var tmp0 = fromInt(this.rna_1);
    // Inline function 'kotlin.Long.times' call
    var other = 1000000000;
    // Inline function 'kotlin.Long.times' call
    var this_0 = multiply(tmp0, fromInt(other));
    var total = multiply(this_0, fromInt(3600));
    var tmp = total;
    var tmp0_0 = fromInt(this.sna_1);
    // Inline function 'kotlin.Long.times' call
    var other_0 = 1000000000;
    // Inline function 'kotlin.Long.times' call
    var this_1 = multiply(tmp0_0, fromInt(other_0));
    var tmp$ret$3 = multiply(this_1, fromInt(60));
    total = add(tmp, tmp$ret$3);
    var tmp_0 = total;
    var tmp0_1 = fromInt(this.tna_1);
    // Inline function 'kotlin.Long.times' call
    var other_1 = 1000000000;
    var tmp$ret$4 = multiply(tmp0_1, fromInt(other_1));
    total = add(tmp_0, tmp$ret$4);
    total = add(total, fromInt(this.una_1));
    return total;
  };
  protoOf(LocalTime).toString = function () {
    return format_1(this, get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS());
  };
  protoOf(LocalTime).equals = function (other) {
    var tmp;
    if (other instanceof LocalTime) {
      tmp = this.nnp(other) === 0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  function ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda() {
    _init_properties_LocalTime_kt__nmhi56();
    var tmp = Companion_instance_13;
    return tmp.vna(ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda);
  }
  function ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda($this$build) {
    _init_properties_LocalTime_kt__nmhi56();
    $this$build.on6();
    char($this$build, _Char___init__impl__6a9atx(58));
    $this$build.qn6();
    optional($this$build, VOID, ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda($this$optional) {
    _init_properties_LocalTime_kt__nmhi56();
    char($this$optional, _Char___init__impl__6a9atx(58));
    $this$optional.sn6();
    optional($this$optional, VOID, ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda$lambda($this$optional) {
    _init_properties_LocalTime_kt__nmhi56();
    char($this$optional, _Char___init__impl__6a9atx(46));
    secondFractionInternal($this$optional, 1, 9, Companion_getInstance_14().wnb_1);
    return Unit_instance;
  }
  function _get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS_$ref_fmwpvv() {
    return constructCallableReference(function () {
      return get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS();
    }, 0, 0, 442);
  }
  var properties_initialized_LocalTime_kt_bt8uiw;
  function _init_properties_LocalTime_kt__nmhi56() {
    if (!properties_initialized_LocalTime_kt_bt8uiw) {
      properties_initialized_LocalTime_kt_bt8uiw = true;
      ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate = lazy(ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda);
    }
  }
  function firstDayOfYear(_this__u8e3s4, leapYear) {
    var leap = leapYear ? 1 : 0;
    var tmp;
    switch (_this__u8e3s4.a1_1) {
      case 0:
        tmp = 1;
        break;
      case 1:
        tmp = 32;
        break;
      case 2:
        tmp = 60 + leap | 0;
        break;
      case 3:
        tmp = 91 + leap | 0;
        break;
      case 4:
        tmp = 121 + leap | 0;
        break;
      case 5:
        tmp = 152 + leap | 0;
        break;
      case 6:
        tmp = 182 + leap | 0;
        break;
      case 7:
        tmp = 213 + leap | 0;
        break;
      case 8:
        tmp = 244 + leap | 0;
        break;
      case 9:
        tmp = 274 + leap | 0;
        break;
      case 10:
        tmp = 305 + leap | 0;
        break;
      case 11:
        tmp = 335 + leap | 0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function get_lenientOffsetFormat() {
    _init_properties_TimeZone_kt__dwyks9();
    return lenientOffsetFormat;
  }
  var lenientOffsetFormat;
  function toLocalDateTime(_this__u8e3s4, offset) {
    _init_properties_TimeZone_kt__dwyks9();
    var tmp;
    try {
      tmp = toLocalDateTimeImpl(_this__u8e3s4, offset);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throw DateTimeArithmeticException_init_$Create$_0('Instant ' + _this__u8e3s4.toString() + ' is not representable as LocalDateTime', e);
      } else {
        throw $p;
      }
    }
    return tmp;
  }
  function toLocalDateTimeImpl(_this__u8e3s4, offset) {
    _init_properties_TimeZone_kt__dwyks9();
    var tmp0 = _this__u8e3s4.up_1;
    // Inline function 'kotlin.Long.plus' call
    var other = offset.hng_1;
    var localSecond = add(tmp0, fromInt(other));
    // Inline function 'kotlin.floorDiv' call
    var other_0 = new Long(86400, 0);
    var q = divide(localSecond, other_0);
    if (compare(bitwiseXor(localSecond, other_0), new Long(0, 0)) < 0 && !equalsLong(multiply(q, other_0), localSecond)) {
      var _unary__edvuaz = q;
      q = subtract(_unary__edvuaz, get_ONE());
    }
    var localEpochDay = q;
    // Inline function 'kotlin.mod' call
    var other_1 = new Long(86400, 0);
    var r = modulo(localSecond, other_1);
    var tmp$ret$2 = add(r, bitwiseAnd(other_1, shiftRight(bitwiseAnd(bitwiseXor(r, other_1), bitwiseOr(r, negate(r))), 63)));
    var secsOfDay = convertToInt(tmp$ret$2);
    var date = Companion_getInstance_21().dnp(localEpochDay);
    var time = Companion_getInstance_23().tnp(secsOfDay, _this__u8e3s4.vp_1);
    return new LocalDateTime(date, time);
  }
  function toInstant(_this__u8e3s4, offset, youShallNotPass) {
    youShallNotPass = youShallNotPass === VOID ? Companion_getInstance_10().sn5_1 : youShallNotPass;
    _init_properties_TimeZone_kt__dwyks9();
    return Companion_getInstance().pp(_this__u8e3s4.onp(offset), _this__u8e3s4.fna());
  }
  function toLocalDateTime_0(_this__u8e3s4, timeZone) {
    _init_properties_TimeZone_kt__dwyks9();
    return timeZone.zno(_this__u8e3s4);
  }
  function Companion_23() {
    Companion_instance_24 = this;
    this.yno_1 = new FixedOffsetTimeZone(Companion_getInstance_26().nno_1, 'UTC');
  }
  protoOf(Companion_23).unp = function () {
    var _destruct__k2r9zo = currentSystemDefaultZone();
    var name = _destruct__k2r9zo.zh();
    var zone = _destruct__k2r9zo.ai();
    return zone == null ? this.vnp(name) : zone;
  };
  protoOf(Companion_23).vnp = function (zoneId) {
    if (zoneId === 'UTC') {
      return this.yno_1;
    }
    if (zoneId === 'Z' || zoneId === 'z') {
      return asTimeZone(Companion_getInstance_26().nno_1);
    }
    if (zoneId === 'SYSTEM') {
      return this.unp();
    }
    if (zoneId.length === 1) {
      throw IllegalTimeZoneException_init_$Create$_0('Invalid zone ID: ' + zoneId);
    }
    try {
      if (startsWith_0(zoneId, '+') || startsWith_0(zoneId, '-')) {
        return asTimeZone(get_lenientOffsetFormat().sp(zoneId));
      }
      switch (zoneId) {
        case 'UTC':
        case 'GMT':
        case 'UT':
          return new FixedOffsetTimeZone(Companion_getInstance_26().nno_1, zoneId);
      }
      if (startsWith_0(zoneId, 'UTC+') || startsWith_0(zoneId, 'GMT+') || startsWith_0(zoneId, 'UTC-') || startsWith_0(zoneId, 'GMT-')) {
        var prefix = take_0(zoneId, 3);
        var offset = get_lenientOffsetFormat().sp(substring_0(zoneId, 3));
        return asTimeZone_0(offset, prefix);
      }
      if (startsWith_0(zoneId, 'UT+') || startsWith_0(zoneId, 'UT-')) {
        var offset_0 = get_lenientOffsetFormat().sp(substring_0(zoneId, 2));
        return asTimeZone_0(offset_0, 'UT');
      }
    } catch ($p) {
      if ($p instanceof DateTimeFormatException) {
        var e = $p;
        throw IllegalTimeZoneException_init_$Create$_1(e);
      } else {
        throw $p;
      }
    }
    var tmp;
    try {
      tmp = timeZoneById(zoneId);
    } catch ($p_0) {
      var tmp_0;
      if ($p_0 instanceof Exception) {
        var e_0 = $p_0;
        throw IllegalTimeZoneException_init_$Create$_2('Invalid zone ID: ' + zoneId, e_0);
      } else {
        throw $p_0;
      }
    }
    return tmp;
  };
  var Companion_instance_24;
  function Companion_getInstance_24() {
    if (Companion_instance_24 == null)
      new Companion_23();
    return Companion_instance_24;
  }
  function TimeZone() {
    Companion_getInstance_24();
  }
  protoOf(TimeZone).tno = function () {
    // Inline function 'kotlin.error' call
    var message = 'Should be overridden';
    throw IllegalStateException_init_$Create$(toString_0(message));
  };
  protoOf(TimeZone).uno = function (date) {
    // Inline function 'kotlin.error' call
    var message = 'Should be overridden';
    throw IllegalStateException_init_$Create$(toString_0(message));
  };
  protoOf(TimeZone).wno = function (instant) {
    // Inline function 'kotlin.error' call
    var message = 'Should be overridden';
    throw IllegalStateException_init_$Create$(toString_0(message));
  };
  protoOf(TimeZone).zno = function (instant) {
    var tmp;
    try {
      tmp = toLocalDateTimeImpl(instant, this.wno(instant));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throw DateTimeArithmeticException_init_$Create$_0('Instant ' + instant.toString() + ' is not representable as LocalDateTime.', e);
      } else {
        throw $p;
      }
    }
    return tmp;
  };
  protoOf(TimeZone).xno = function (dateTime, preferred) {
    // Inline function 'kotlin.error' call
    var message = 'Should be overridden';
    throw IllegalStateException_init_$Create$(toString_0(message));
  };
  protoOf(TimeZone).vno = function (dateTime, preferred, $super) {
    preferred = preferred === VOID ? null : preferred;
    return $super === VOID ? this.xno(dateTime, preferred) : $super.xno.call(this, dateTime, preferred);
  };
  protoOf(TimeZone).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      if (other instanceof TimeZone) {
        tmp_0 = this.tno() === other.tno();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(TimeZone).hashCode = function () {
    return getStringHashCode(this.tno());
  };
  protoOf(TimeZone).toString = function () {
    return this.tno();
  };
  function FixedOffsetTimeZone_init_$Init$(offset, $this) {
    FixedOffsetTimeZone.call($this, offset, offset.toString());
    return $this;
  }
  function FixedOffsetTimeZone_init_$Create$(offset) {
    return FixedOffsetTimeZone_init_$Init$(offset, objectCreate(protoOf(FixedOffsetTimeZone)));
  }
  function Companion_24() {
  }
  var Companion_instance_25;
  function Companion_getInstance_25() {
    return Companion_instance_25;
  }
  function FixedOffsetTimeZone(offset, id) {
    TimeZone.call(this);
    this.wnp_1 = offset;
    this.xnp_1 = id;
  }
  protoOf(FixedOffsetTimeZone).tno = function () {
    return this.xnp_1;
  };
  protoOf(FixedOffsetTimeZone).uno = function (date) {
    return toInstant(new LocalDateTime(date, Companion_getInstance_23().ino_1), this.wnp_1);
  };
  protoOf(FixedOffsetTimeZone).wno = function (instant) {
    return this.wnp_1;
  };
  protoOf(FixedOffsetTimeZone).xno = function (dateTime, preferred) {
    return toInstant(dateTime, this.wnp_1);
  };
  protoOf(FixedOffsetTimeZone).zno = function (instant) {
    return toLocalDateTime(instant, this.wnp_1);
  };
  function toInstant_0(_this__u8e3s4, timeZone, youShallNotPass) {
    youShallNotPass = youShallNotPass === VOID ? Companion_getInstance_10().sn5_1 : youShallNotPass;
    _init_properties_TimeZone_kt__dwyks9();
    return timeZone.vno(_this__u8e3s4);
  }
  function atStartOfDayIn(_this__u8e3s4, timeZone, youShallNotPass) {
    youShallNotPass = youShallNotPass === VOID ? Companion_getInstance_10().sn5_1 : youShallNotPass;
    _init_properties_TimeZone_kt__dwyks9();
    return timeZone.uno(_this__u8e3s4);
  }
  function lenientOffsetFormat$lambda($this$build) {
    _init_properties_TimeZone_kt__dwyks9();
    var tmp = lenientOffsetFormat$lambda$lambda;
    var tmp_0 = [tmp, lenientOffsetFormat$lambda$lambda_0];
    alternativeParsing($this$build, tmp_0, lenientOffsetFormat$lambda$lambda_1);
    return Unit_instance;
  }
  function lenientOffsetFormat$lambda$lambda($this$alternativeParsing) {
    _init_properties_TimeZone_kt__dwyks9();
    $this$alternativeParsing.wn6(Padding_NONE_getInstance());
    return Unit_instance;
  }
  function lenientOffsetFormat$lambda$lambda_0($this$alternativeParsing) {
    _init_properties_TimeZone_kt__dwyks9();
    isoOffset($this$alternativeParsing, false, false, WhenToOutput_IF_NONZERO_getInstance(), WhenToOutput_IF_NONZERO_getInstance());
    return Unit_instance;
  }
  function lenientOffsetFormat$lambda$lambda_1($this$alternativeParsing) {
    _init_properties_TimeZone_kt__dwyks9();
    isoOffset($this$alternativeParsing, true, true, WhenToOutput_ALWAYS_getInstance(), WhenToOutput_IF_NONZERO_getInstance());
    return Unit_instance;
  }
  var properties_initialized_TimeZone_kt_fgsidh;
  function _init_properties_TimeZone_kt__dwyks9() {
    if (!properties_initialized_TimeZone_kt_fgsidh) {
      properties_initialized_TimeZone_kt_fgsidh = true;
      var tmp = Companion_instance_16;
      lenientOffsetFormat = tmp.rng(lenientOffsetFormat$lambda);
    }
  }
  function get_utcOffsetCache() {
    _init_properties_UtcOffset_kt__93zod7();
    return utcOffsetCache;
  }
  var utcOffsetCache;
  function totalSecondsValid($this, totalSeconds) {
    return -64800 <= totalSeconds ? totalSeconds <= 64800 : false;
  }
  function validateTotal($this, totalSeconds) {
    // Inline function 'kotlin.require' call
    if (!totalSecondsValid($this, totalSeconds)) {
      var message = 'Total seconds value is out of range: ' + totalSeconds;
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
  }
  function validate($this, hours, minutes, seconds) {
    if (hours < -18 || hours > 18) {
      throw IllegalArgumentException_init_$Create$('Zone offset hours not in valid range: value ' + hours + ' is not in the range -18 to 18');
    }
    if (hours > 0) {
      if (minutes < 0 || seconds < 0) {
        throw IllegalArgumentException_init_$Create$('Zone offset minutes and seconds must be positive because hours is positive');
      }
    } else if (hours < 0) {
      if (minutes > 0 || seconds > 0) {
        throw IllegalArgumentException_init_$Create$('Zone offset minutes and seconds must be negative because hours is negative');
      }
    } else if (minutes > 0 && seconds < 0 || (minutes < 0 && seconds > 0)) {
      throw IllegalArgumentException_init_$Create$('Zone offset minutes and seconds must have the same sign');
    }
    if (abs(minutes) > 59) {
      throw IllegalArgumentException_init_$Create$('Zone offset minutes not in valid range: abs(value) ' + abs(minutes) + ' is not in the range 0 to 59');
    }
    if (abs(seconds) > 59) {
      throw IllegalArgumentException_init_$Create$('Zone offset seconds not in valid range: abs(value) ' + abs(seconds) + ' is not in the range 0 to 59');
    }
    if (abs(hours) === 18 && (abs(minutes) > 0 || abs(seconds) > 0)) {
      throw IllegalArgumentException_init_$Create$('Utc offset not in valid range: -18:00 to +18:00');
    }
  }
  function ofSecondsUnsafe($this, seconds) {
    var tmp;
    if ((seconds % 900 | 0) === 0) {
      var tmp0_elvis_lhs = get_utcOffsetCache().w2(seconds);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.also' call
        var this_0 = new UtcOffset(seconds);
        // Inline function 'kotlin.collections.set' call
        get_utcOffsetCache().z2(seconds, this_0);
        tmp_0 = this_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      tmp = new UtcOffset(seconds);
    }
    return tmp;
  }
  function Companion_25() {
    Companion_instance_26 = this;
    this.nno_1 = new UtcOffset(0);
  }
  protoOf(Companion_25).ynp = function (input, format) {
    return format.sp(input);
  };
  protoOf(Companion_25).ono = function (input, format, $super) {
    format = format === VOID ? getIsoUtcOffsetFormat() : format;
    return $super === VOID ? this.ynp(input, format) : $super.ynp.call(this, input, format);
  };
  protoOf(Companion_25).znp = function (hours, minutes, seconds) {
    return hours === 0 && minutes === 0 && seconds === 0 ? this.nno_1 : this.anq((imul(hours, 3600) + imul(minutes, 60) | 0) + seconds | 0);
  };
  protoOf(Companion_25).bnq = function (hours, minutes, seconds) {
    validate(this, hours, minutes, seconds);
    return this.znp(hours, minutes, seconds);
  };
  protoOf(Companion_25).anq = function (seconds) {
    validateTotal(this, seconds);
    // Inline function 'kotlin.let' call
    return ofSecondsUnsafe(Companion_getInstance_26(), seconds);
  };
  var Companion_instance_26;
  function Companion_getInstance_26() {
    if (Companion_instance_26 == null)
      new Companion_25();
    return Companion_instance_26;
  }
  function Formats_2() {
  }
  protoOf(Formats_2).pn5 = function () {
    return get_ISO_OFFSET();
  };
  var Formats_instance_2;
  function Formats_getInstance_2() {
    return Formats_instance_2;
  }
  function UtcOffset(totalSeconds) {
    Companion_getInstance_26();
    this.hng_1 = totalSeconds;
  }
  protoOf(UtcOffset).hashCode = function () {
    return this.hng_1;
  };
  protoOf(UtcOffset).equals = function (other) {
    var tmp;
    if (other instanceof UtcOffset) {
      tmp = this.hng_1 === other.hng_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(UtcOffset).toString = function () {
    return format_2(this, Formats_instance_2.pn5());
  };
  function UtcOffset_0(hours, minutes, seconds) {
    hours = hours === VOID ? null : hours;
    minutes = minutes === VOID ? null : minutes;
    seconds = seconds === VOID ? null : seconds;
    _init_properties_UtcOffset_kt__93zod7();
    var tmp;
    if (!(hours == null)) {
      var tmp_0 = Companion_getInstance_26();
      var tmp_1 = minutes == null ? 0 : minutes;
      tmp = tmp_0.bnq(hours, tmp_1, seconds == null ? 0 : seconds);
    } else if (!(minutes == null)) {
      var tmp_2 = Companion_getInstance_26();
      var tmp_3 = minutes / 60 | 0;
      var tmp_4 = minutes % 60 | 0;
      tmp = tmp_2.bnq(tmp_3, tmp_4, seconds == null ? 0 : seconds);
    } else {
      var tmp_5 = Companion_getInstance_26();
      tmp = tmp_5.anq(seconds == null ? 0 : seconds);
    }
    return tmp;
  }
  function asTimeZone_0(_this__u8e3s4, prefix) {
    _init_properties_UtcOffset_kt__93zod7();
    return _this__u8e3s4.hng_1 === 0 ? new FixedOffsetTimeZone(_this__u8e3s4, prefix) : new FixedOffsetTimeZone(_this__u8e3s4, prefix + _this__u8e3s4.toString());
  }
  var properties_initialized_UtcOffset_kt_4gxffr;
  function _init_properties_UtcOffset_kt__93zod7() {
    if (!properties_initialized_UtcOffset_kt_4gxffr) {
      properties_initialized_UtcOffset_kt_4gxffr = true;
      // Inline function 'kotlin.collections.mutableMapOf' call
      utcOffsetCache = LinkedHashMap_init_$Create$();
    }
  }
  function validateYear($this) {
    var containsArg = $this.nnh_1;
    // Inline function 'kotlin.require' call
    if (!(-999999999 <= containsArg ? containsArg <= 999999999 : false)) {
      var message = 'Year ' + $this.nnh_1 + ' is out of range: -999999999..999999999';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
  }
  function YearMonth_init_$Init$(year, month, $this) {
    YearMonth.call($this, year, month, Unit_instance);
    var containsArg = $this.onh_1;
    // Inline function 'kotlin.require' call
    if (!(1 <= containsArg ? containsArg <= 12 : false)) {
      var message = 'Month must be in 1..12, but was ' + month;
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    validateYear($this);
    return $this;
  }
  function YearMonth_init_$Create$(year, month) {
    return YearMonth_init_$Init$(year, month, objectCreate(protoOf(YearMonth)));
  }
  function Companion_26() {
  }
  protoOf(Companion_26).cnq = function (input, format) {
    return format.sp(input);
  };
  protoOf(Companion_26).rno = function (input, format, $super) {
    format = format === VOID ? Formats_instance_3.pn5() : format;
    return $super === VOID ? this.cnq(input, format) : $super.cnq.call(this, input, format);
  };
  var Companion_instance_27;
  function Companion_getInstance_27() {
    return Companion_instance_27;
  }
  function Formats_3() {
  }
  protoOf(Formats_3).pn5 = function () {
    return get_ISO_YEAR_MONTH();
  };
  var Formats_instance_3;
  function Formats_getInstance_3() {
    return Formats_instance_3;
  }
  function YearMonth$_get_year_$ref_chp4n6() {
    return constructCallableReference(function (p0) {
      return p0.nnh_1;
    }, 1, 0, 443);
  }
  function YearMonth$_get_month_$ref_9rphhd() {
    return constructCallableReference(function (p0) {
      return p0.an8();
    }, 1, 0, 444);
  }
  function YearMonth(year, month, unit) {
    this.nnh_1 = year;
    this.onh_1 = month;
  }
  protoOf(YearMonth).an8 = function () {
    return Month_0(this.onh_1);
  };
  protoOf(YearMonth).dnq = function (other) {
    var tmp = KProperty1;
    var tmp_0 = getPropertyCallableRef('year', 1, tmp, YearMonth$_get_year_$ref_chp4n6(), null);
    var tmp_1 = KProperty1;
    return compareValuesBy(this, other, [tmp_0, getPropertyCallableRef('month', 1, tmp_1, YearMonth$_get_month_$ref_9rphhd(), null)]);
  };
  protoOf(YearMonth).d = function (other) {
    return this.dnq(other instanceof YearMonth ? other : THROW_CCE());
  };
  protoOf(YearMonth).toString = function () {
    return Formats_instance_3.pn5().qn5(this);
  };
  protoOf(YearMonth).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof YearMonth) {
      tmp_0 = this.nnh_1 === other.nnh_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.an8().equals(other.an8());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(YearMonth).hashCode = function () {
    return imul(this.nnh_1, 31) + this.an8().hashCode() | 0;
  };
  function WallClockOffset() {
  }
  function FixedOffset() {
  }
  function Gap(start, offsetBefore, offsetAfter) {
    this.enq_1 = start;
    this.fnq_1 = offsetBefore;
    this.gnq_1 = offsetAfter;
    // Inline function 'kotlin.check' call
    if (!(this.fnq_1.hng_1 < this.gnq_1.hng_1)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
  }
  protoOf(Gap).hnq = function () {
    return this.gnq_1.hng_1 - this.fnq_1.hng_1 | 0;
  };
  protoOf(Gap).toString = function () {
    return 'Gap(start=' + this.enq_1.toString() + ', offsetBefore=' + this.fnq_1.toString() + ', offsetAfter=' + this.gnq_1.toString() + ')';
  };
  protoOf(Gap).hashCode = function () {
    var result = this.enq_1.hashCode();
    result = imul(result, 31) + this.fnq_1.hashCode() | 0;
    result = imul(result, 31) + this.gnq_1.hashCode() | 0;
    return result;
  };
  protoOf(Gap).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Gap))
      return false;
    var tmp0_other_with_cast = other instanceof Gap ? other : THROW_CCE();
    if (!this.enq_1.equals(tmp0_other_with_cast.enq_1))
      return false;
    if (!this.fnq_1.equals(tmp0_other_with_cast.fnq_1))
      return false;
    if (!this.gnq_1.equals(tmp0_other_with_cast.gnq_1))
      return false;
    return true;
  };
  function Overlap(start, offsetBefore, offsetAfter) {
    this.inq_1 = start;
    this.jnq_1 = offsetBefore;
    this.knq_1 = offsetAfter;
    // Inline function 'kotlin.check' call
    if (!(this.jnq_1.hng_1 > this.knq_1.hng_1)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
  }
  protoOf(Overlap).toString = function () {
    return 'Overlap(start=' + this.inq_1.toString() + ', offsetBefore=' + this.jnq_1.toString() + ', offsetAfter=' + this.knq_1.toString() + ')';
  };
  protoOf(Overlap).hashCode = function () {
    var result = this.inq_1.hashCode();
    result = imul(result, 31) + this.jnq_1.hashCode() | 0;
    result = imul(result, 31) + this.knq_1.hashCode() | 0;
    return result;
  };
  protoOf(Overlap).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Overlap))
      return false;
    var tmp0_other_with_cast = other instanceof Overlap ? other : THROW_CCE();
    if (!this.inq_1.equals(tmp0_other_with_cast.inq_1))
      return false;
    if (!this.jnq_1.equals(tmp0_other_with_cast.jnq_1))
      return false;
    if (!this.knq_1.equals(tmp0_other_with_cast.knq_1))
      return false;
    return true;
  };
  function Regular(offset) {
    this.lnq_1 = offset;
  }
  protoOf(Regular).toString = function () {
    return 'Regular(offset=' + this.lnq_1.toString() + ')';
  };
  protoOf(Regular).hashCode = function () {
    return this.lnq_1.hashCode();
  };
  protoOf(Regular).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Regular))
      return false;
    var tmp0_other_with_cast = other instanceof Regular ? other : THROW_CCE();
    if (!this.lnq_1.equals(tmp0_other_with_cast.lnq_1))
      return false;
    return true;
  };
  function OffsetInfo(transitionInstant, offsetBefore, offsetAfter) {
    var tmp;
    if (offsetBefore.equals(offsetAfter)) {
      tmp = new Regular(offsetBefore);
    } else if (offsetBefore.hng_1 < offsetAfter.hng_1) {
      tmp = new Gap(transitionInstant, offsetBefore, offsetAfter);
    } else {
      tmp = new Overlap(transitionInstant, offsetBefore, offsetAfter);
    }
    return tmp;
  }
  function RegionTimeZone(tzid, id) {
    TimeZone.call(this);
    this.mnq_1 = tzid;
    this.nnq_1 = id;
  }
  protoOf(RegionTimeZone).tno = function () {
    return this.nnq_1;
  };
  protoOf(RegionTimeZone).uno = function (date) {
    var ldt = new LocalDateTime(date, Companion_getInstance_23().ino_1);
    var info = this.mnq_1.onq(ldt);
    var tmp;
    if (info instanceof Regular) {
      tmp = toInstant(ldt, info.lnq_1);
    } else {
      if (info instanceof Gap) {
        tmp = info.enq_1;
      } else {
        if (info instanceof Overlap) {
          tmp = toInstant(ldt, info.jnq_1);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  };
  protoOf(RegionTimeZone).xno = function (dateTime, preferred) {
    var info = this.mnq_1.onq(dateTime);
    var tmp;
    if (info instanceof Regular) {
      tmp = toInstant(dateTime, info.lnq_1);
    } else {
      if (info instanceof Gap) {
        var tmp_0;
        try {
          tmp_0 = toInstant(plusSeconds(dateTime, info.hnq()), info.gnq_1);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof IllegalArgumentException) {
            var e = $p;
            throw DateTimeArithmeticException_init_$Create$_0('Overflow whet correcting the date-time to not be in the transition gap', e);
          } else {
            throw $p;
          }
        }
        tmp = tmp_0;
      } else {
        if (info instanceof Overlap) {
          tmp = toInstant(dateTime, info.knq_1.equals(preferred) ? info.knq_1 : info.jnq_1);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  };
  protoOf(RegionTimeZone).wno = function (instant) {
    return this.mnq_1.pnq(instant);
  };
  function offsetInfoForTransitionIndex($this, transitionIndex) {
    var transitionInstant = Companion_getInstance().rp($this.qnq_1.l1(transitionIndex));
    var offsetBefore = $this.rnq_1.l1(transitionIndex);
    var offsetAfter = $this.rnq_1.l1(transitionIndex + 1 | 0);
    return OffsetInfo(transitionInstant, offsetBefore, offsetAfter);
  }
  function TimeZoneRulesCommon(transitionEpochSeconds, offsets, recurringZoneRules) {
    this.qnq_1 = transitionEpochSeconds;
    this.rnq_1 = offsets;
    this.snq_1 = recurringZoneRules;
    // Inline function 'kotlin.require' call
    if (!(this.rnq_1.n1() === (this.qnq_1.n1() + 1 | 0))) {
      var message = 'offsets.size must be one more than transitionEpochSeconds.size';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    var tmp = this;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$_0();
    var inductionVariable = 0;
    var last = this.qnq_1.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var instant = Companion_getInstance().rp(this.qnq_1.l1(i));
        var ldtBefore = toLocalDateTime(instant, this.rnq_1.l1(i));
        var ldtAfter = toLocalDateTime(instant, this.rnq_1.l1(i + 1 | 0));
        if (ldtBefore.mnp(ldtAfter) < 0) {
          this_0.j1(ldtBefore);
          this_0.j1(ldtAfter);
        } else {
          this_0.j1(ldtAfter);
          this_0.j1(ldtBefore);
        }
      }
       while (inductionVariable <= last);
    tmp.tnq_1 = this_0.t5();
  }
  protoOf(TimeZoneRulesCommon).pnq = function (instant) {
    var epochSeconds = instant.up_1;
    var tmp;
    if (!(this.snq_1 == null)) {
      var tmp0_safe_receiver = lastOrNull(this.qnq_1);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = compare(epochSeconds, tmp0_safe_receiver) >= 0;
      }
      tmp = !(tmp_0 === false);
    } else {
      tmp = false;
    }
    if (tmp) {
      return this.snq_1.vnq(instant, last(this.rnq_1));
    }
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = binarySearch(this.qnq_1, epochSeconds) + 1 | 0;
    var index = abs(this_0);
    return this.rnq_1.l1(index);
  };
  protoOf(TimeZoneRulesCommon).onq = function (localDateTime) {
    var tmp;
    if (!(this.snq_1 == null)) {
      var tmp0_safe_receiver = lastOrNull(this.tnq_1);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = localDateTime.mnp(tmp0_safe_receiver) > 0;
      }
      tmp = !(tmp_0 === false);
    } else {
      tmp = false;
    }
    if (tmp) {
      return this.snq_1.wnq(localDateTime, last(this.rnq_1));
    }
    // Inline function 'kotlin.let' call
    var it = binarySearch(this.tnq_1, localDateTime);
    var lastIndexNotBiggerThanLdt = it < 0 ? (-it | 0) - 2 | 0 : it;
    if (lastIndexNotBiggerThanLdt === -1) {
      return new Regular(first(this.rnq_1));
    }
    var tmp_1;
    if ((lastIndexNotBiggerThanLdt % 2 | 0) === 0) {
      tmp_1 = offsetInfoForTransitionIndex(this, lastIndexNotBiggerThanLdt / 2 | 0);
    } else if (!(lastIndexNotBiggerThanLdt === (this.tnq_1.n1() - 1 | 0)) && this.tnq_1.l1(lastIndexNotBiggerThanLdt).equals(this.tnq_1.l1(lastIndexNotBiggerThanLdt + 1 | 0))) {
      tmp_1 = offsetInfoForTransitionIndex(this, (lastIndexNotBiggerThanLdt / 2 | 0) + 1 | 0);
    } else {
      tmp_1 = new Regular(this.rnq_1.l1((lastIndexNotBiggerThanLdt / 2 | 0) + 1 | 0));
    }
    return tmp_1;
  };
  protoOf(TimeZoneRulesCommon).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    var inductionVariable = 0;
    var last_0 = this.qnq_1.n1() - 1 | 0;
    if (inductionVariable <= last_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.w(this.rnq_1.l1(i));
        this_0.q(' until ');
        this_0.w(Companion_getInstance().rp(this.qnq_1.l1(i)));
        this_0.q(', ');
      }
       while (inductionVariable <= last_0);
    this_0.q('then ');
    this_0.w(last(this.rnq_1));
    if (!(this.snq_1 == null)) {
      this_0.q(', after that ');
      this_0.w(this.snq_1);
    }
    return this_0.toString();
  };
  function Rule(transitionDateTime, offsetBefore, offsetAfter) {
    this.xnq_1 = transitionDateTime;
    this.ynq_1 = offsetBefore;
    this.znq_1 = offsetAfter;
  }
  protoOf(Rule).toString = function () {
    return 'transitioning from ' + this.ynq_1.toString() + ' to ' + this.znq_1.toString() + ' on ' + toString_1(this.xnq_1);
  };
  function sam$kotlin_Comparator$0_0(function_0) {
    this.anr_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).ze = function (a, b) {
    return this.anr_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).q3 = function () {
    return this.anr_1;
  };
  protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function RecurringZoneRules$rulesForYear$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = a.xnq_1;
    var tmp$ret$2 = b.xnq_1;
    return compareValues(tmp, tmp$ret$2);
  }
  function safeAdd(a, b) {
    var sum = add(a, b);
    if (compare(bitwiseXor(a, sum), new Long(0, 0)) < 0 && compare(bitwiseXor(a, b), new Long(0, 0)) >= 0) {
      throw ArithmeticException_init_$Create$('Addition overflows a long: ' + a.toString() + ' + ' + b.toString());
    }
    return sum;
  }
  function safeMultiply(a, b) {
    if (equalsLong(b, new Long(1, 0))) {
      return a;
    }
    if (equalsLong(a, new Long(1, 0))) {
      return b;
    }
    if (equalsLong(a, new Long(0, 0)) || equalsLong(b, new Long(0, 0))) {
      return new Long(0, 0);
    }
    var total = multiply(a, b);
    if (!equalsLong(divide(total, b), a) || (equalsLong(a, new Long(0, -2147483648)) && equalsLong(b, new Long(-1, -1))) || (equalsLong(b, new Long(0, -2147483648)) && equalsLong(a, new Long(-1, -1)))) {
      throw ArithmeticException_init_$Create$('Multiplication overflows a long: ' + a.toString() + ' * ' + b.toString());
    }
    return total;
  }
  function safeMultiply_0(a, b) {
    var total = multiply(fromInt(a), fromInt(b));
    if (compare(total, new Long(-2147483648, -1)) < 0 || compare(total, new Long(2147483647, 0)) > 0) {
      throw ArithmeticException_init_$Create$('Multiplication overflows an int: ' + a + ' * ' + b);
    }
    return convertToInt(total);
  }
  function readTzdb() {
    var tmp;
    try {
      // Inline function 'kotlin.js.asDynamic' call
      var tzdbData = ZoneRulesProvider.getTzdbData();
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$1 = tzdbData.zones;
      var tmp_0 = toList(tmp$ret$1);
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$2 = tzdbData.links;
      tmp = to(tmp_0, toList(tmp$ret$2));
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  //region block: post-declaration
  protoOf(Builder).en7 = appendAlternativeParsingImpl;
  protoOf(Builder).dn7 = appendOptionalImpl;
  protoOf(Builder).in6 = chars;
  protoOf(Builder).g3d = build;
  protoOf(Builder).kn8 = addFormatStructureForYearMonth;
  protoOf(Builder).jn6 = day;
  protoOf(Builder).kn6 = day$default;
  protoOf(Builder).ln6 = dayOfYear;
  protoOf(Builder).mn6 = date;
  protoOf(Builder).dn6 = year;
  protoOf(Builder).en6 = year$default;
  protoOf(Builder).fn6 = yearTwoDigits;
  protoOf(Builder).gn6 = monthNumber;
  protoOf(Builder).hn6 = monthNumber$default;
  protoOf(Builder_0).en7 = appendAlternativeParsingImpl;
  protoOf(Builder_0).dn7 = appendOptionalImpl;
  protoOf(Builder_0).in6 = chars;
  protoOf(Builder_0).g3d = build;
  protoOf(Builder_0).jn8 = addFormatStructureForDate;
  protoOf(Builder_0).kn7 = addFormatStructureForTime;
  protoOf(Builder_0).kn8 = addFormatStructureForYearMonth;
  protoOf(Builder_0).jn6 = day;
  protoOf(Builder_0).kn6 = day$default;
  protoOf(Builder_0).ln6 = dayOfYear;
  protoOf(Builder_0).mn6 = date;
  protoOf(Builder_0).dn6 = year;
  protoOf(Builder_0).en6 = year$default;
  protoOf(Builder_0).fn6 = yearTwoDigits;
  protoOf(Builder_0).gn6 = monthNumber;
  protoOf(Builder_0).hn6 = monthNumber$default;
  protoOf(Builder_0).nn6 = hour;
  protoOf(Builder_0).on6 = hour$default;
  protoOf(Builder_0).pn6 = minute;
  protoOf(Builder_0).qn6 = minute$default;
  protoOf(Builder_0).rn6 = second;
  protoOf(Builder_0).sn6 = second$default;
  protoOf(Builder_0).tn6 = secondFraction_0;
  protoOf(Builder_0).un6 = secondFraction;
  protoOf(Builder_0).vn6 = time;
  protoOf(IncompleteLocalTime).mna = set_fractionOfSecond;
  protoOf(IncompleteLocalTime).nna = get_fractionOfSecond;
  protoOf(Builder_1).en7 = appendAlternativeParsingImpl;
  protoOf(Builder_1).dn7 = appendOptionalImpl;
  protoOf(Builder_1).in6 = chars;
  protoOf(Builder_1).g3d = build;
  protoOf(Builder_1).nn6 = hour;
  protoOf(Builder_1).on6 = hour$default;
  protoOf(Builder_1).pn6 = minute;
  protoOf(Builder_1).qn6 = minute$default;
  protoOf(Builder_1).rn6 = second;
  protoOf(Builder_1).sn6 = second$default;
  protoOf(Builder_1).tn6 = secondFraction_0;
  protoOf(Builder_1).un6 = secondFraction;
  protoOf(Builder_1).vn6 = time;
  protoOf(Builder_2).en7 = appendAlternativeParsingImpl;
  protoOf(Builder_2).dn7 = appendOptionalImpl;
  protoOf(Builder_2).in6 = chars;
  protoOf(Builder_2).g3d = build;
  protoOf(Builder_2).wn6 = offsetHours;
  protoOf(Builder_2).xn6 = offsetHours$default;
  protoOf(Builder_2).yn6 = offsetMinutesOfHour;
  protoOf(Builder_2).zn6 = offsetMinutesOfHour$default;
  protoOf(Builder_2).an7 = offsetSecondsOfMinute;
  protoOf(Builder_2).bn7 = offsetSecondsOfMinute$default;
  protoOf(Builder_3).en7 = appendAlternativeParsingImpl;
  protoOf(Builder_3).dn7 = appendOptionalImpl;
  protoOf(Builder_3).in6 = chars;
  protoOf(Builder_3).g3d = build;
  protoOf(Builder_3).dn6 = year;
  protoOf(Builder_3).en6 = year$default;
  protoOf(Builder_3).fn6 = yearTwoDigits;
  protoOf(Builder_3).gn6 = monthNumber;
  protoOf(Builder_3).hn6 = monthNumber$default;
  protoOf(PropertyAccessor).onj = getterNotNull;
  protoOf(SpacePaddedFormatter).bn6 = format$default;
  protoOf(SignedFormatter).bn6 = format$default;
  protoOf(ConditionalFormatter).bn6 = format$default;
  protoOf(ConcatenatedFormatter).bn6 = format$default;
  protoOf(UnsignedIntFormatterStructure).bn6 = format$default;
  protoOf(DecimalFractionFormatterStructure).bn6 = format$default;
  protoOf(SignedIntFormatterStructure).bn6 = format$default;
  protoOf(ReducedIntFormatterStructure).bn6 = format$default;
  protoOf(ConstantStringFormatterStructure).bn6 = format$default;
  //endregion
  //region block: init
  Companion_instance_0 = new Companion();
  Companion_instance_1 = new Companion_0();
  Companion_instance_2 = new Companion_1();
  Companion_instance_3 = new Companion_2();
  Companion_instance_4 = new Companion_3();
  Companion_instance_5 = new Companion_4();
  Companion_instance_11 = new Companion_10();
  Companion_instance_12 = new Companion_11();
  Companion_instance_13 = new Companion_12();
  Companion_instance_15 = new Companion_14();
  Companion_instance_16 = new Companion_15();
  Companion_instance_17 = new Companion_16();
  Companion_instance_18 = new Companion_17();
  Truth_instance = new Truth();
  ExpectedInt_instance = new ExpectedInt();
  Companion_instance_19 = new Companion_18();
  Formats_instance_1 = new Formats_1();
  Companion_instance_25 = new Companion_24();
  Formats_instance_2 = new Formats_2();
  Companion_instance_27 = new Companion_26();
  Formats_instance_3 = new Formats_3();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_getInstance_21;
  _.$_$.b = Companion_getInstance_22;
  _.$_$.c = Companion_getInstance_24;
  _.$_$.d = DatePeriod_init_$Create$;
  _.$_$.e = LocalDate_init_$Create$_0;
  _.$_$.f = LocalDate_init_$Create$;
  _.$_$.g = LocalTime_init_$Create$;
  _.$_$.h = byUnicodePattern;
  _.$_$.i = atStartOfDayIn;
  _.$_$.j = atTime;
  _.$_$.k = format_0;
  _.$_$.l = get_isoDayNumber;
  _.$_$.m = get_number;
  _.$_$.n = plus_3;
  _.$_$.o = toInstant_0;
  _.$_$.p = toLocalDateTime_0;
  //endregion
  return _;
}));

//# sourceMappingURL=Kotlin-DateTime-library-kotlinx-datetime.js.map
